// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: `${string}://openapi.json` | (string & {});
};

export type ApiRequest = {
  readonly id: number;
  name: string;
  url: string;
  method?: ApiRequestMethod;
  headers?: any | null;
  body?: any | null;
};

export enum ApiRequestMethod {
  Get = 'get',
  Post = 'post',
  Put = 'put',
  Patch = 'patch',
  Delete = 'delete',
}

export type ApiRequestRequest = {
  name: string;
  url: string;
  method?: ApiRequestMethod;
  headers?: any | null;
  body?: any | null;
};

export type BackgroundTask = {
  readonly id: number;
  name: string;
  interval: number;
};

export type BackgroundTaskRequest = {
  name: string;
  interval: number;
};

export enum BackgroundTaskStatus {
  Pending = 'pending',
  Running = 'running',
}

export enum BlankEnum {
  '' = '',
}

export type Chat = {
  readonly id: number;
  readonly telegram_id: number;
  readonly type: ChatType;
  readonly title: string | null;
  readonly username: string | null;
  readonly first_name: string | null;
  readonly last_name: string | null;
  readonly is_forum: boolean;
  readonly is_direct_messages: boolean;
  is_allowed?: boolean;
  is_blocked?: boolean;
};

export type ChatRequest = {
  is_allowed?: boolean;
  is_blocked?: boolean;
};

export enum ChatType {
  Private = 'private',
  Group = 'group',
  Supergroup = 'supergroup',
  Channel = 'channel',
}

export enum ClientErrorType {
  ClientError = 'client_error',
}

export type Condition = {
  readonly id: number;
  name: string;
  parts: Array<ConditionPart>;
};

export type ConditionPart = {
  readonly id: number;
  type: ConditionPartType;
  first_value: string;
  operator: ConditionPartOperatorType;
  second_value: string;
  next_part_operator?: ConditionPartNextPartOperator | BlankEnum | NullEnum;
};

export enum ConditionPartNextPartOperator {
  And = '&&',
  Or = '||',
}

export enum ConditionPartOperatorType {
  Equal = '==',
  NotEqual = '!=',
  Greater = '>',
  GreaterOrEqual = '>=',
  Less = '<',
  LessOrEqual = '<=',
}

export type ConditionPartRequest = {
  type: ConditionPartType;
  first_value: string;
  operator: ConditionPartOperatorType;
  second_value: string;
  next_part_operator?: ConditionPartNextPartOperator | BlankEnum | NullEnum;
};

export enum ConditionPartType {
  Positive = '+',
  Negative = '-',
}

export type ConditionRequest = {
  name: string;
  parts: Array<ConditionPartRequest>;
};

export type Connection = {
  readonly id: number;
  source_object_type: ConnectionSourceObjectType;
  source_object_id: number;
  source_handle_position: ConnectionHandlePosition;
  target_object_type: ConnectionTargetObjectType;
  target_object_id: number;
  target_handle_position: ConnectionHandlePosition;
};

export enum ConnectionHandlePosition {
  Left = 'left',
  Right = 'right',
}

export type ConnectionRequest = {
  source_object_type: ConnectionSourceObjectType;
  source_object_id: number;
  source_handle_position: ConnectionHandlePosition;
  target_object_type: ConnectionTargetObjectType;
  target_object_id: number;
  target_handle_position: ConnectionHandlePosition;
};

export enum ConnectionSourceObjectType {
  Trigger = 'trigger',
  Message = 'message',
  MessageKeyboardButton = 'message_keyboard_button',
  Condition = 'condition',
  BackgroundTask = 'background_task',
  ApiRequest = 'api_request',
  DatabaseOperation = 'database_operation',
  Invoice = 'invoice',
  TemporaryVariable = 'temporary_variable',
  Timer = 'timer',
  Randomizer = 'randomizer',
}

export enum ConnectionTargetObjectType {
  Trigger = 'trigger',
  Message = 'message',
  Condition = 'condition',
  ApiRequest = 'api_request',
  DatabaseOperation = 'database_operation',
  Invoice = 'invoice',
  TemporaryVariable = 'temporary_variable',
  Timer = 'timer',
  Randomizer = 'randomizer',
}

export type DatabaseCreateOperation = {
  data: any;
};

export type DatabaseCreateOperationRequest = {
  data: any;
};

export type DatabaseOperation = {
  readonly id: number;
  name: string;
  create_operation?: DatabaseCreateOperation | null;
  update_operation?: DatabaseUpdateOperation | null;
};

export type DatabaseOperationRequest = {
  name: string;
  create_operation?: DatabaseCreateOperationRequest | null;
  update_operation?: DatabaseUpdateOperationRequest | null;
};

export type DatabaseRecord = {
  readonly id: number;
  data: any;
};

export type DatabaseRecordRequest = {
  data: any;
};

export type DatabaseUpdateOperation = {
  overwrite?: boolean;
  lookup_field_name: string;
  lookup_field_value: string;
  create_if_not_found?: boolean;
  new_data: any;
};

export type DatabaseUpdateOperationRequest = {
  overwrite?: boolean;
  lookup_field_name: string;
  lookup_field_value: string;
  create_if_not_found?: boolean;
  new_data: any;
};

export type DiagramApiRequest = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
  readonly url: string;
  readonly method: ApiRequestMethod;
};

export type DiagramApiRequestRequest = {
  x?: number;
  y?: number;
};

export type DiagramBackgroundTask = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
  readonly status: BackgroundTaskStatus;
  readonly interval: number;
};

export type DiagramBackgroundTaskRequest = {
  x?: number;
  y?: number;
};

export type DiagramCondition = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
};

export type DiagramConditionRequest = {
  x?: number;
  y?: number;
};

export type DiagramDatabaseOperation = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
};

export type DiagramDatabaseOperationRequest = {
  x?: number;
  y?: number;
};

export type DiagramInvoice = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
};

export type DiagramInvoiceRequest = {
  x?: number;
  y?: number;
};

export type DiagramMessage = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
  readonly text: string | null;
  readonly keyboard: DiagramMessageKeyboard | null;
};

export type DiagramMessageKeyboard = {
  type?: MessageKeyboardType;
  buttons: Array<DiagramMessageKeyboardButton>;
};

export type DiagramMessageKeyboardButton = {
  readonly id: number;
  row: number;
  position: number;
  text: string;
  url?: string | null | string;
  style?: MessageKeyboardButtonStyle;
  source_connections: Array<Connection>;
};

export type DiagramMessageKeyboardButtonRequest = {
  row: number;
  position: number;
  text: string;
  url?: string | null | string;
  style?: MessageKeyboardButtonStyle;
  source_connections: Array<ConnectionRequest>;
};

export type DiagramMessageKeyboardRequest = {
  type?: MessageKeyboardType;
  buttons: Array<DiagramMessageKeyboardButtonRequest>;
};

export type DiagramMessageRequest = {
  x?: number;
  y?: number;
};

export type DiagramRandomizer = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
};

export type DiagramRandomizerRequest = {
  x?: number;
  y?: number;
};

export type DiagramTemporaryVariable = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
  readonly value: string;
};

export type DiagramTemporaryVariableRequest = {
  x?: number;
  y?: number;
};

export type DiagramTimer = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
  readonly duration_seconds: number;
};

export type DiagramTimerRequest = {
  x?: number;
  y?: number;
};

export type DiagramTrigger = {
  readonly id: number;
  readonly name: string;
  x?: number;
  y?: number;
  readonly source_connections: Array<Connection>;
};

export type DiagramTriggerRequest = {
  x?: number;
  y?: number;
};

export type Document = {
  readonly content: string;
  readonly updated_date: string;
};

export type Error401 = {
  code: ErrorCode401;
  detail: string;
  attr: string | null;
};

export type Error403 = {
  code: ErrorCode403;
  detail: string;
  attr: string | null;
};

export type Error404 = {
  code: ErrorCode404;
  detail: string;
  attr: string | null;
};

export type Error405 = {
  code: ErrorCode405;
  detail: string;
  attr: string | null;
};

export type Error406 = {
  code: ErrorCode406;
  detail: string;
  attr: string | null;
};

export type Error415 = {
  code: ErrorCode415;
  detail: string;
  attr: string | null;
};

export type Error500 = {
  code: ErrorCode500;
  detail: string;
  attr: string | null;
};

export enum ErrorCode401 {
  AuthenticationFailed = 'authentication_failed',
  NotAuthenticated = 'not_authenticated',
}

export enum ErrorCode403 {
  PermissionDenied = 'permission_denied',
}

export enum ErrorCode404 {
  NotFound = 'not_found',
}

export enum ErrorCode405 {
  MethodNotAllowed = 'method_not_allowed',
}

export enum ErrorCode406 {
  NotAcceptable = 'not_acceptable',
}

export enum ErrorCode415 {
  UnsupportedMediaType = 'unsupported_media_type',
}

export enum ErrorCode500 {
  Error = 'error',
}

export type ErrorResponse401 = {
  type: ClientErrorType;
  errors: Array<Error401>;
};

export type ErrorResponse403 = {
  type: ClientErrorType;
  errors: Array<Error403>;
};

export type ErrorResponse404 = {
  type: ClientErrorType;
  errors: Array<Error404>;
};

export type ErrorResponse405 = {
  type: ClientErrorType;
  errors: Array<Error405>;
};

export type ErrorResponse406 = {
  type: ClientErrorType;
  errors: Array<Error406>;
};

export type ErrorResponse415 = {
  type: ClientErrorType;
  errors: Array<Error415>;
};

export type ErrorResponse500 = {
  type: ServerErrorType;
  errors: Array<Error500>;
};

export type InstructionGetSectionListErrorResponse400 = ParseErrorResponse;

export type Invoice = {
  readonly id: number;
  name: string;
  title: string;
  description: string;
  image?: InvoiceImage | null;
  prices: Array<InvoicePrice>;
};

export type InvoiceImage = {
  readonly name: string | null;
  readonly size: number;
  readonly url: string;
  from_url?: string | null | string;
};

export type InvoiceImageRequest = {
  from_url?: string | null | string;
};

export type InvoicePrice = {
  readonly id: number;
  label: string;
  amount: number;
};

export type InvoicePriceRequest = {
  label: string;
  amount: number;
};

export type InvoiceRequest = {
  name: string;
  title: string;
  description: string;
  image?: InvoiceImageRequest | null;
  prices: Array<InvoicePriceRequest>;
};

export enum InvoiceStatus {
  Pending = 'pending',
  Paid = 'paid',
  Failed = 'failed',
  Expired = 'expired',
  Refunded = 'refunded',
}

export type LegalGetDocumentErrorResponse400 = ParseErrorResponse;

export type Message = {
  readonly id: number;
  name: string;
  text?: string | null;
  settings: MessageSettings;
  images?: Array<MessageImage> | null;
  documents?: Array<MessageDocument> | null;
  keyboard?: MessageKeyboard | null;
};

export type MessageDocument = {
  readonly name: string | null;
  readonly size: number;
  readonly url: string;
  from_url?: string | null | string;
  id?: number;
  position: number;
};

export type MessageDocumentRequest = {
  from_url?: string | null | string;
  id?: number;
  position: number;
};

export type MessageImage = {
  readonly name: string | null;
  readonly size: number;
  readonly url: string;
  from_url?: string | null | string;
  id?: number;
  position: number;
};

export type MessageImageRequest = {
  from_url?: string | null | string;
  id?: number;
  position: number;
};

export type MessageKeyboard = {
  type?: MessageKeyboardType;
  buttons: Array<MessageKeyboardButton>;
};

export type MessageKeyboardButton = {
  id?: number;
  row: number;
  position: number;
  text: string;
  url?: string | null | string;
  style?: MessageKeyboardButtonStyle;
};

export type MessageKeyboardButtonRequest = {
  id?: number;
  row: number;
  position: number;
  text: string;
  url?: string | null | string;
  style?: MessageKeyboardButtonStyle;
};

export enum MessageKeyboardButtonStyle {
  Default = 'default',
  Primary = 'primary',
  Success = 'success',
  Danger = 'danger',
}

export type MessageKeyboardRequest = {
  type?: MessageKeyboardType;
  buttons: Array<MessageKeyboardButtonRequest>;
};

export enum MessageKeyboardType {
  Default = 'default',
  Inline = 'inline',
  Payment = 'payment',
}

export type MessageRequest = {
  name: string;
  text?: string | null;
  settings: MessageSettingsRequest;
  images?: Array<MessageImageRequest> | null;
  documents?: Array<MessageDocumentRequest> | null;
  keyboard?: MessageKeyboardRequest | null;
};

export type MessageSettings = {
  reply_to_user_message?: boolean;
  delete_user_message?: boolean;
  send_as_new_message?: boolean;
};

export type MessageSettingsRequest = {
  reply_to_user_message?: boolean;
  delete_user_message?: boolean;
  send_as_new_message?: boolean;
};

export type NullEnum = null;

export type PaginatedChatList = {
  count: number;
  limit: number;
  offset: number;
  results: Array<Chat>;
};

export type PaginatedDatabaseRecordList = {
  count: number;
  limit: number;
  offset: number;
  results: Array<DatabaseRecord>;
};

export type PaginatedSubscriptionInvoiceList = {
  count: number;
  limit: number;
  offset: number;
  results: Array<SubscriptionInvoice>;
};

export type PaginatedTelegramBotUserList = {
  count: number;
  limit: number;
  offset: number;
  results: Array<TelegramBotUser>;
};

export type PaginatedTemporaryVariableList = {
  count: number;
  limit: number;
  offset: number;
  results: Array<TemporaryVariable>;
};

export type PaginatedVariableList = {
  count: number;
  limit: number;
  offset: number;
  results: Array<Variable>;
};

export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};

export enum ParseErrorCodeEnum {
  ParseError = 'parse_error',
}

export type ParseErrorResponse = {
  type: ClientErrorType;
  errors: Array<ParseError>;
};

export type PatchedApiRequestRequest = {
  name?: string;
  url?: string;
  method?: ApiRequestMethod;
  headers?: any | null;
  body?: any | null;
};

export type PatchedBackgroundTaskRequest = {
  name?: string;
  interval?: number;
};

export type PatchedChatRequest = {
  is_allowed?: boolean;
  is_blocked?: boolean;
};

export type PatchedConditionRequest = {
  name?: string;
  parts?: Array<ConditionPartRequest>;
};

export type PatchedDatabaseOperationRequest = {
  name?: string;
  create_operation?: DatabaseCreateOperationRequest | null;
  update_operation?: DatabaseUpdateOperationRequest | null;
};

export type PatchedDatabaseRecordRequest = {
  data?: any;
};

export type PatchedDiagramApiRequestRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramBackgroundTaskRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramConditionRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramDatabaseOperationRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramInvoiceRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramMessageRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramRandomizerRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramTemporaryVariableRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramTimerRequest = {
  x?: number;
  y?: number;
};

export type PatchedDiagramTriggerRequest = {
  x?: number;
  y?: number;
};

export type PatchedInvoiceRequest = {
  name?: string;
  title?: string;
  description?: string;
  image?: InvoiceImageRequest | null;
  prices?: Array<InvoicePriceRequest>;
};

export type PatchedMessageRequest = {
  name?: string;
  text?: string | null;
  settings?: MessageSettingsRequest;
  images?: Array<MessageImageRequest> | null;
  documents?: Array<MessageDocumentRequest> | null;
  keyboard?: MessageKeyboardRequest | null;
};

export type PatchedRandomizerRequest = {
  name?: string;
};

export type PatchedTelegramBotRequest = {
  api_token?: string;
  is_private?: boolean;
};

export type PatchedTelegramBotUserRequest = {
  is_allowed?: boolean;
  is_blocked?: boolean;
};

export type PatchedTemporaryVariableRequest = {
  name?: string;
  value?: string;
};

export type PatchedTimerRequest = {
  name?: string;
  duration_seconds?: number;
};

export type PatchedTriggerRequest = {
  name?: string;
  command?: TriggerCommandRequest | null;
  message?: TriggerMessageRequest | null;
  webhook?: TriggerWebhookRequest | null;
};

export type PatchedVariableRequest = {
  name?: string;
  value?: string;
  description?: string;
};

export type PremiumGetSubscriptionInvoiceErrorResponse400 = ParseErrorResponse;

export type PremiumGetSubscriptionInvoiceListError =
  PremiumGetSubscriptionInvoiceListStatusesErrorComponent;

export type PremiumGetSubscriptionInvoiceListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & PremiumGetSubscriptionInvoiceListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type PremiumGetSubscriptionInvoiceListStatusesErrorComponent = {
  attr: 'statuses';
  code: 'invalid_choice';
  detail: string;
};

export type PremiumGetSubscriptionInvoiceListValidationError = {
  type: ValidationErrorType;
  errors: Array<PremiumGetSubscriptionInvoiceListError>;
};

export type PremiumGetSubscriptionPriceCheckoutErrorResponse400 = ParseErrorResponse;

export type PremiumGetSubscriptionPriceErrorResponse400 = ParseErrorResponse;

export type PremiumGetSubscriptionPriceListErrorResponse400 = ParseErrorResponse;

export type Randomizer = {
  readonly id: number;
  name: string;
};

export type RandomizerRequest = {
  name: string;
};

export type Section = {
  readonly id: number;
  readonly title: string;
  readonly text: string;
};

export enum ServerErrorType {
  ServerError = 'server_error',
}

export type SubscriptionInvoice = {
  readonly id: number;
  readonly status: InvoiceStatus;
  readonly period_months: number;
  readonly amount_stars: number;
  readonly telegram_charge_id: string | null;
  readonly created_date: string;
  readonly paid_date: string | null;
};

export type SubscriptionPrice = {
  readonly id: number;
  readonly badge: string | null;
  readonly discount_percentage: number | null;
  readonly period_months: number;
  readonly base_amount_stars: number;
  readonly amount_stars: number;
};

export type SubscriptionPriceCheckoutResponse = {
  readonly url: string;
};

export type TelegramBot = {
  readonly id: number;
  readonly username: string;
  api_token: string;
  readonly storage_size: number;
  readonly used_storage_size: number;
  readonly remaining_storage_size: number;
  is_private?: boolean;
  readonly is_enabled: boolean;
  readonly is_loading: boolean;
  readonly added_date: string;
};

export type TelegramBotRequest = {
  api_token: string;
  is_private?: boolean;
};

export type TelegramBotStats = {
  readonly total: number;
  readonly enabled: number;
};

export type TelegramBotStatsResponse = {
  telegram_bots: TelegramBotStats;
  users: UserStats;
};

export type TelegramBotUser = {
  readonly id: number;
  readonly telegram_id: number;
  readonly username: string | null;
  readonly first_name: string;
  readonly last_name: string | null;
  readonly is_bot: boolean;
  readonly is_premium: boolean;
  is_allowed?: boolean;
  is_blocked?: boolean;
  readonly activated_date: string;
};

export type TelegramBotUserRequest = {
  is_allowed?: boolean;
  is_blocked?: boolean;
};

export type TelegramBotsCreateApiRequestBodyErrorComponent = {
  attr: 'body';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateApiRequestError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateApiRequestNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateApiRequestNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateApiRequestXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateApiRequestYErrorComponent)
  | ({
      attr: 'url';
    } & TelegramBotsCreateApiRequestUrlErrorComponent)
  | ({
      attr: 'method';
    } & TelegramBotsCreateApiRequestMethodErrorComponent)
  | ({
      attr: 'headers';
    } & TelegramBotsCreateApiRequestHeadersErrorComponent)
  | ({
      attr: 'body';
    } & TelegramBotsCreateApiRequestBodyErrorComponent);

export type TelegramBotsCreateApiRequestErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateApiRequestValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateApiRequestHeadersErrorComponent = {
  attr: 'headers';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateApiRequestMethodErrorComponent = {
  attr: 'method';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsCreateApiRequestNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateApiRequestNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateApiRequestUrlErrorComponent = {
  attr: 'url';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateApiRequestValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateApiRequestError>;
};

export type TelegramBotsCreateApiRequestXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateApiRequestYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateBackgroundTaskError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateBackgroundTaskNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateBackgroundTaskNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateBackgroundTaskXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateBackgroundTaskYErrorComponent)
  | ({
      attr: 'interval';
    } & TelegramBotsCreateBackgroundTaskIntervalErrorComponent);

export type TelegramBotsCreateBackgroundTaskErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateBackgroundTaskValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateBackgroundTaskIntervalErrorComponent = {
  attr: 'interval';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateBackgroundTaskNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateBackgroundTaskNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateBackgroundTaskValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateBackgroundTaskError>;
};

export type TelegramBotsCreateBackgroundTaskXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateBackgroundTaskYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateConditionError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateConditionNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateConditionNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateConditionXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateConditionYErrorComponent)
  | ({
      attr: 'parts.non_field_errors';
    } & TelegramBotsCreateConditionPartsNonFieldErrorsErrorComponent)
  | ({
      attr: 'parts.INDEX.non_field_errors';
    } & TelegramBotsCreateConditionPartsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'parts.INDEX.type';
    } & TelegramBotsCreateConditionPartsIndexTypeErrorComponent)
  | ({
      attr: 'parts.INDEX.first_value';
    } & TelegramBotsCreateConditionPartsIndexFirstValueErrorComponent)
  | ({
      attr: 'parts.INDEX.operator';
    } & TelegramBotsCreateConditionPartsIndexOperatorErrorComponent)
  | ({
      attr: 'parts.INDEX.second_value';
    } & TelegramBotsCreateConditionPartsIndexSecondValueErrorComponent)
  | ({
      attr: 'parts.INDEX.next_part_operator';
    } & TelegramBotsCreateConditionPartsIndexNextPartOperatorErrorComponent);

export type TelegramBotsCreateConditionErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateConditionValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateConditionNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateConditionNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateConditionPartsIndexFirstValueErrorComponent = {
  attr: 'parts.INDEX.first_value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateConditionPartsIndexNextPartOperatorErrorComponent = {
  attr: 'parts.INDEX.next_part_operator';
  code: 'invalid_choice';
  detail: string;
};

export type TelegramBotsCreateConditionPartsIndexNonFieldErrorsErrorComponent = {
  attr: 'parts.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConditionPartsIndexOperatorErrorComponent = {
  attr: 'parts.INDEX.operator';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConditionPartsIndexSecondValueErrorComponent = {
  attr: 'parts.INDEX.second_value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateConditionPartsIndexTypeErrorComponent = {
  attr: 'parts.INDEX.type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConditionPartsNonFieldErrorsErrorComponent = {
  attr: 'parts.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConditionValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateConditionError>;
};

export type TelegramBotsCreateConditionXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateConditionYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateConnectionError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateConnectionNonFieldErrorsErrorComponent)
  | ({
      attr: 'source_object_type';
    } & TelegramBotsCreateConnectionSourceObjectTypeErrorComponent)
  | ({
      attr: 'source_object_id';
    } & TelegramBotsCreateConnectionSourceObjectIdErrorComponent)
  | ({
      attr: 'source_handle_position';
    } & TelegramBotsCreateConnectionSourceHandlePositionErrorComponent)
  | ({
      attr: 'target_object_type';
    } & TelegramBotsCreateConnectionTargetObjectTypeErrorComponent)
  | ({
      attr: 'target_object_id';
    } & TelegramBotsCreateConnectionTargetObjectIdErrorComponent)
  | ({
      attr: 'target_handle_position';
    } & TelegramBotsCreateConnectionTargetHandlePositionErrorComponent);

export type TelegramBotsCreateConnectionErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateConnectionValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateConnectionNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateConnectionSourceHandlePositionErrorComponent = {
  attr: 'source_handle_position';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConnectionSourceObjectIdErrorComponent = {
  attr: 'source_object_id';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConnectionSourceObjectTypeErrorComponent = {
  attr: 'source_object_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConnectionTargetHandlePositionErrorComponent = {
  attr: 'target_handle_position';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConnectionTargetObjectIdErrorComponent = {
  attr: 'target_object_id';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConnectionTargetObjectTypeErrorComponent = {
  attr: 'target_object_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateConnectionValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateConnectionError>;
};

export type TelegramBotsCreateDatabaseOperationCreateOperationDataErrorComponent = {
  attr: 'create_operation.data';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateDatabaseOperationCreateOperationNonFieldErrorsErrorComponent =
  {
    attr: 'create_operation.non_field_errors';
    code: 'invalid';
    detail: string;
  };

export type TelegramBotsCreateDatabaseOperationError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateDatabaseOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateDatabaseOperationNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateDatabaseOperationXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateDatabaseOperationYErrorComponent)
  | ({
      attr: 'create_operation.non_field_errors';
    } & TelegramBotsCreateDatabaseOperationCreateOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'create_operation.data';
    } & TelegramBotsCreateDatabaseOperationCreateOperationDataErrorComponent)
  | ({
      attr: 'update_operation.non_field_errors';
    } & TelegramBotsCreateDatabaseOperationUpdateOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'update_operation.overwrite';
    } & TelegramBotsCreateDatabaseOperationUpdateOperationOverwriteErrorComponent)
  | ({
      attr: 'update_operation.lookup_field_name';
    } & TelegramBotsCreateDatabaseOperationUpdateOperationLookupFieldNameErrorComponent)
  | ({
      attr: 'update_operation.lookup_field_value';
    } & TelegramBotsCreateDatabaseOperationUpdateOperationLookupFieldValueErrorComponent)
  | ({
      attr: 'update_operation.create_if_not_found';
    } & TelegramBotsCreateDatabaseOperationUpdateOperationCreateIfNotFoundErrorComponent)
  | ({
      attr: 'update_operation.new_data';
    } & TelegramBotsCreateDatabaseOperationUpdateOperationNewDataErrorComponent);

export type TelegramBotsCreateDatabaseOperationErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateDatabaseOperationValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateDatabaseOperationNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateDatabaseOperationNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateDatabaseOperationUpdateOperationCreateIfNotFoundErrorComponent =
  {
    attr: 'update_operation.create_if_not_found';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsCreateDatabaseOperationUpdateOperationLookupFieldNameErrorComponent =
  {
    attr: 'update_operation.lookup_field_name';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };

export type TelegramBotsCreateDatabaseOperationUpdateOperationLookupFieldValueErrorComponent =
  {
    attr: 'update_operation.lookup_field_value';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };

export type TelegramBotsCreateDatabaseOperationUpdateOperationNewDataErrorComponent = {
  attr: 'update_operation.new_data';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateDatabaseOperationUpdateOperationNonFieldErrorsErrorComponent =
  {
    attr: 'update_operation.non_field_errors';
    code: 'invalid';
    detail: string;
  };

export type TelegramBotsCreateDatabaseOperationUpdateOperationOverwriteErrorComponent =
  {
    attr: 'update_operation.overwrite';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsCreateDatabaseOperationValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateDatabaseOperationError>;
};

export type TelegramBotsCreateDatabaseOperationXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateDatabaseOperationYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateDatabaseRecordDataErrorComponent = {
  attr: 'data';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateDatabaseRecordError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateDatabaseRecordNonFieldErrorsErrorComponent)
  | ({
      attr: 'data';
    } & TelegramBotsCreateDatabaseRecordDataErrorComponent);

export type TelegramBotsCreateDatabaseRecordErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateDatabaseRecordValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateDatabaseRecordNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateDatabaseRecordValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateDatabaseRecordError>;
};

export type TelegramBotsCreateDiagramRandomizerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateDiagramRandomizerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateDiagramRandomizerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateDiagramRandomizerYErrorComponent);

export type TelegramBotsCreateDiagramRandomizerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateDiagramRandomizerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateDiagramRandomizerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateDiagramRandomizerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateDiagramRandomizerError>;
};

export type TelegramBotsCreateDiagramRandomizerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateDiagramRandomizerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateDiagramTimerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateDiagramTimerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateDiagramTimerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateDiagramTimerYErrorComponent);

export type TelegramBotsCreateDiagramTimerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateDiagramTimerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateDiagramTimerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateDiagramTimerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateDiagramTimerError>;
};

export type TelegramBotsCreateDiagramTimerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateDiagramTimerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateDiagramTriggerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateDiagramTriggerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateDiagramTriggerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateDiagramTriggerYErrorComponent);

export type TelegramBotsCreateDiagramTriggerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateDiagramTriggerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateDiagramTriggerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateDiagramTriggerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateDiagramTriggerError>;
};

export type TelegramBotsCreateDiagramTriggerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateDiagramTriggerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateInvoiceDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateInvoiceError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateInvoiceNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateInvoiceNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateInvoiceXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateInvoiceYErrorComponent)
  | ({
      attr: 'title';
    } & TelegramBotsCreateInvoiceTitleErrorComponent)
  | ({
      attr: 'description';
    } & TelegramBotsCreateInvoiceDescriptionErrorComponent)
  | ({
      attr: 'image.non_field_errors';
    } & TelegramBotsCreateInvoiceImageNonFieldErrorsErrorComponent)
  | ({
      attr: 'image.file';
    } & TelegramBotsCreateInvoiceImageFileErrorComponent)
  | ({
      attr: 'image.from_url';
    } & TelegramBotsCreateInvoiceImageFromUrlErrorComponent)
  | ({
      attr: 'prices.non_field_errors';
    } & TelegramBotsCreateInvoicePricesNonFieldErrorsErrorComponent)
  | ({
      attr: 'prices.INDEX.non_field_errors';
    } & TelegramBotsCreateInvoicePricesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'prices.INDEX.label';
    } & TelegramBotsCreateInvoicePricesIndexLabelErrorComponent)
  | ({
      attr: 'prices.INDEX.amount';
    } & TelegramBotsCreateInvoicePricesIndexAmountErrorComponent);

export type TelegramBotsCreateInvoiceErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateInvoiceValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateInvoiceImageFileErrorComponent = {
  attr: 'image.file';
  code: 'empty' | 'invalid' | 'invalid_image' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsCreateInvoiceImageFromUrlErrorComponent = {
  attr: 'image.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateInvoiceImageNonFieldErrorsErrorComponent = {
  attr: 'image.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateInvoiceNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateInvoiceNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateInvoicePricesIndexAmountErrorComponent = {
  attr: 'prices.INDEX.amount';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateInvoicePricesIndexLabelErrorComponent = {
  attr: 'prices.INDEX.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateInvoicePricesIndexNonFieldErrorsErrorComponent = {
  attr: 'prices.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateInvoicePricesNonFieldErrorsErrorComponent = {
  attr: 'prices.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateInvoiceTitleErrorComponent = {
  attr: 'title';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateInvoiceValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateInvoiceError>;
};

export type TelegramBotsCreateInvoiceXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateInvoiceYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageDocumentsIndexFileErrorComponent = {
  attr: 'documents.INDEX.file';
  code: 'empty' | 'invalid' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsCreateMessageDocumentsIndexFromUrlErrorComponent = {
  attr: 'documents.INDEX.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateMessageDocumentsIndexIdErrorComponent = {
  attr: 'documents.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageDocumentsIndexNonFieldErrorsErrorComponent = {
  attr: 'documents.INDEX.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateMessageDocumentsIndexPositionErrorComponent = {
  attr: 'documents.INDEX.position';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateMessageDocumentsNonFieldErrorsErrorComponent = {
  attr: 'documents.non_field_errors';
  code: 'not_a_list';
  detail: string;
};

export type TelegramBotsCreateMessageError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateMessageNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateMessageXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateMessageYErrorComponent)
  | ({
      attr: 'text';
    } & TelegramBotsCreateMessageTextErrorComponent)
  | ({
      attr: 'settings.non_field_errors';
    } & TelegramBotsCreateMessageSettingsNonFieldErrorsErrorComponent)
  | ({
      attr: 'settings.reply_to_user_message';
    } & TelegramBotsCreateMessageSettingsReplyToUserMessageErrorComponent)
  | ({
      attr: 'settings.delete_user_message';
    } & TelegramBotsCreateMessageSettingsDeleteUserMessageErrorComponent)
  | ({
      attr: 'settings.send_as_new_message';
    } & TelegramBotsCreateMessageSettingsSendAsNewMessageErrorComponent)
  | ({
      attr: 'images.non_field_errors';
    } & TelegramBotsCreateMessageImagesNonFieldErrorsErrorComponent)
  | ({
      attr: 'images.INDEX.non_field_errors';
    } & TelegramBotsCreateMessageImagesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'images.INDEX.file';
    } & TelegramBotsCreateMessageImagesIndexFileErrorComponent)
  | ({
      attr: 'images.INDEX.from_url';
    } & TelegramBotsCreateMessageImagesIndexFromUrlErrorComponent)
  | ({
      attr: 'images.INDEX.id';
    } & TelegramBotsCreateMessageImagesIndexIdErrorComponent)
  | ({
      attr: 'images.INDEX.position';
    } & TelegramBotsCreateMessageImagesIndexPositionErrorComponent)
  | ({
      attr: 'documents.non_field_errors';
    } & TelegramBotsCreateMessageDocumentsNonFieldErrorsErrorComponent)
  | ({
      attr: 'documents.INDEX.non_field_errors';
    } & TelegramBotsCreateMessageDocumentsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'documents.INDEX.file';
    } & TelegramBotsCreateMessageDocumentsIndexFileErrorComponent)
  | ({
      attr: 'documents.INDEX.from_url';
    } & TelegramBotsCreateMessageDocumentsIndexFromUrlErrorComponent)
  | ({
      attr: 'documents.INDEX.id';
    } & TelegramBotsCreateMessageDocumentsIndexIdErrorComponent)
  | ({
      attr: 'documents.INDEX.position';
    } & TelegramBotsCreateMessageDocumentsIndexPositionErrorComponent)
  | ({
      attr: 'keyboard.non_field_errors';
    } & TelegramBotsCreateMessageKeyboardNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.type';
    } & TelegramBotsCreateMessageKeyboardTypeErrorComponent)
  | ({
      attr: 'keyboard.buttons.non_field_errors';
    } & TelegramBotsCreateMessageKeyboardButtonsNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.non_field_errors';
    } & TelegramBotsCreateMessageKeyboardButtonsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.id';
    } & TelegramBotsCreateMessageKeyboardButtonsIndexIdErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.row';
    } & TelegramBotsCreateMessageKeyboardButtonsIndexRowErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.position';
    } & TelegramBotsCreateMessageKeyboardButtonsIndexPositionErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.text';
    } & TelegramBotsCreateMessageKeyboardButtonsIndexTextErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.url';
    } & TelegramBotsCreateMessageKeyboardButtonsIndexUrlErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.style';
    } & TelegramBotsCreateMessageKeyboardButtonsIndexStyleErrorComponent);

export type TelegramBotsCreateMessageErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateMessageValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateMessageImagesIndexFileErrorComponent = {
  attr: 'images.INDEX.file';
  code: 'empty' | 'invalid' | 'invalid_image' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsCreateMessageImagesIndexFromUrlErrorComponent = {
  attr: 'images.INDEX.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateMessageImagesIndexIdErrorComponent = {
  attr: 'images.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageImagesIndexNonFieldErrorsErrorComponent = {
  attr: 'images.INDEX.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateMessageImagesIndexPositionErrorComponent = {
  attr: 'images.INDEX.position';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateMessageImagesNonFieldErrorsErrorComponent = {
  attr: 'images.non_field_errors';
  code: 'not_a_list';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardButtonsIndexIdErrorComponent = {
  attr: 'keyboard.buttons.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardButtonsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'keyboard.buttons.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };

export type TelegramBotsCreateMessageKeyboardButtonsIndexPositionErrorComponent = {
  attr: 'keyboard.buttons.INDEX.position';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardButtonsIndexRowErrorComponent = {
  attr: 'keyboard.buttons.INDEX.row';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardButtonsIndexStyleErrorComponent = {
  attr: 'keyboard.buttons.INDEX.style';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardButtonsIndexTextErrorComponent = {
  attr: 'keyboard.buttons.INDEX.text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardButtonsIndexUrlErrorComponent = {
  attr: 'keyboard.buttons.INDEX.url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardButtonsNonFieldErrorsErrorComponent = {
  attr: 'keyboard.buttons.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardNonFieldErrorsErrorComponent = {
  attr: 'keyboard.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateMessageKeyboardTypeErrorComponent = {
  attr: 'keyboard.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateMessageNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageSettingsDeleteUserMessageErrorComponent = {
  attr: 'settings.delete_user_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageSettingsNonFieldErrorsErrorComponent = {
  attr: 'settings.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateMessageSettingsReplyToUserMessageErrorComponent = {
  attr: 'settings.reply_to_user_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageSettingsSendAsNewMessageErrorComponent = {
  attr: 'settings.send_as_new_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageTextErrorComponent = {
  attr: 'text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateMessageValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateMessageError>;
};

export type TelegramBotsCreateMessageXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateMessageYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateRandomizerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateRandomizerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateRandomizerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateRandomizerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateRandomizerYErrorComponent);

export type TelegramBotsCreateRandomizerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateRandomizerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateRandomizerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateRandomizerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateRandomizerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateRandomizerError>;
};

export type TelegramBotsCreateRandomizerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateRandomizerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateTelegramBotApiTokenErrorComponent = {
  attr: 'api_token';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed'
    | 'unique';
  detail: string;
};

export type TelegramBotsCreateTelegramBotError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateTelegramBotNonFieldErrorsErrorComponent)
  | ({
      attr: 'api_token';
    } & TelegramBotsCreateTelegramBotApiTokenErrorComponent)
  | ({
      attr: 'is_private';
    } & TelegramBotsCreateTelegramBotIsPrivateErrorComponent);

export type TelegramBotsCreateTelegramBotErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateTelegramBotValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateTelegramBotIsPrivateErrorComponent = {
  attr: 'is_private';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateTelegramBotNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateTelegramBotValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateTelegramBotError>;
};

export type TelegramBotsCreateTemporaryVariableError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateTemporaryVariableNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateTemporaryVariableNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateTemporaryVariableXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateTemporaryVariableYErrorComponent)
  | ({
      attr: 'value';
    } & TelegramBotsCreateTemporaryVariableValueErrorComponent);

export type TelegramBotsCreateTemporaryVariableErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateTemporaryVariableValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateTemporaryVariableNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateTemporaryVariableNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateTemporaryVariableValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateTemporaryVariableError>;
};

export type TelegramBotsCreateTemporaryVariableValueErrorComponent = {
  attr: 'value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateTemporaryVariableXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateTemporaryVariableYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateTimerDurationSecondsErrorComponent = {
  attr: 'duration_seconds';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsCreateTimerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateTimerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateTimerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateTimerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateTimerYErrorComponent)
  | ({
      attr: 'duration_seconds';
    } & TelegramBotsCreateTimerDurationSecondsErrorComponent);

export type TelegramBotsCreateTimerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateTimerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateTimerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateTimerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateTimerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateTimerError>;
};

export type TelegramBotsCreateTimerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateTimerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateTriggerCommandCommandErrorComponent = {
  attr: 'command.command';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateTriggerCommandDescriptionErrorComponent = {
  attr: 'command.description';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateTriggerCommandNonFieldErrorsErrorComponent = {
  attr: 'command.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateTriggerCommandPayloadErrorComponent = {
  attr: 'command.payload';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateTriggerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateTriggerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateTriggerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsCreateTriggerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsCreateTriggerYErrorComponent)
  | ({
      attr: 'command.non_field_errors';
    } & TelegramBotsCreateTriggerCommandNonFieldErrorsErrorComponent)
  | ({
      attr: 'command.command';
    } & TelegramBotsCreateTriggerCommandCommandErrorComponent)
  | ({
      attr: 'command.payload';
    } & TelegramBotsCreateTriggerCommandPayloadErrorComponent)
  | ({
      attr: 'command.description';
    } & TelegramBotsCreateTriggerCommandDescriptionErrorComponent)
  | ({
      attr: 'message.non_field_errors';
    } & TelegramBotsCreateTriggerMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'message.text';
    } & TelegramBotsCreateTriggerMessageTextErrorComponent)
  | ({
      attr: 'webhook.non_field_errors';
    } & TelegramBotsCreateTriggerWebhookNonFieldErrorsErrorComponent);

export type TelegramBotsCreateTriggerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateTriggerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateTriggerMessageNonFieldErrorsErrorComponent = {
  attr: 'message.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateTriggerMessageTextErrorComponent = {
  attr: 'message.text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateTriggerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateTriggerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateTriggerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateTriggerError>;
};

export type TelegramBotsCreateTriggerWebhookNonFieldErrorsErrorComponent = {
  attr: 'webhook.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsCreateTriggerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateTriggerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsCreateVariableDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateVariableError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsCreateVariableNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsCreateVariableNameErrorComponent)
  | ({
      attr: 'value';
    } & TelegramBotsCreateVariableValueErrorComponent)
  | ({
      attr: 'description';
    } & TelegramBotsCreateVariableDescriptionErrorComponent);

export type TelegramBotsCreateVariableErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsCreateVariableValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsCreateVariableNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsCreateVariableNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsCreateVariableValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsCreateVariableError>;
};

export type TelegramBotsCreateVariableValueErrorComponent = {
  attr: 'value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsDeleteApiRequestErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteBackgroundTaskErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteChatErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteConditionErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteConnectionErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteDatabaseOperationErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteDatabaseRecordErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteDiagramRandomizerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteDiagramTimerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteDiagramTriggerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteInvoiceErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteMessageErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteRandomizerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteTelegramBotErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteTemporaryVariableErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteTimerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteTriggerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteUserErrorResponse400 = ParseErrorResponse;

export type TelegramBotsDeleteVariableErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetApiRequestErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetApiRequestListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetBackgroundTaskErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetBackgroundTaskListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetChatErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetChatListError = TelegramBotsGetChatListTypeErrorComponent;

export type TelegramBotsGetChatListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsGetChatListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsGetChatListTypeErrorComponent = {
  attr: 'type';
  code: 'invalid_choice';
  detail: string;
};

export type TelegramBotsGetChatListValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsGetChatListError>;
};

export type TelegramBotsGetConditionErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetConditionListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDatabaseOperationErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDatabaseOperationListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDatabaseRecordErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDatabaseRecordListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramApiRequestErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramApiRequestListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramBackgroundTaskErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramBackgroundTaskListErrorResponse400 =
  ParseErrorResponse;

export type TelegramBotsGetDiagramConditionErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramConditionListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramDatabaseOperationErrorResponse400 =
  ParseErrorResponse;

export type TelegramBotsGetDiagramDatabaseOperationListErrorResponse400 =
  ParseErrorResponse;

export type TelegramBotsGetDiagramInvoiceErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramInvoiceListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramMessageErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramMessageListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramRandomizerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramRandomizerListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramTemporaryVariableErrorResponse400 =
  ParseErrorResponse;

export type TelegramBotsGetDiagramTemporaryVariableListErrorResponse400 =
  ParseErrorResponse;

export type TelegramBotsGetDiagramTimerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramTimerListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramTriggerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetDiagramTriggerListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetInvoiceErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetInvoiceListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetMessageErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetMessageListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetRandomizerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetRandomizerListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetStatsErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetTelegramBotErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetTelegramBotListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetTemporaryVariableErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetTemporaryVariableListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetTimerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetTimerListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetTriggerErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetTriggerListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetUserErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetUserListError = any;

export type TelegramBotsGetUserListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsGetUserListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsGetUserListValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsGetUserListError>;
};

export type TelegramBotsGetUserTimelineStatsErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetVariableErrorResponse400 = ParseErrorResponse;

export type TelegramBotsGetVariableListErrorResponse400 = ParseErrorResponse;

export type TelegramBotsPartialUpdateApiRequestBodyErrorComponent = {
  attr: 'body';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsPartialUpdateApiRequestError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateApiRequestNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateApiRequestNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateApiRequestXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateApiRequestYErrorComponent)
  | ({
      attr: 'url';
    } & TelegramBotsPartialUpdateApiRequestUrlErrorComponent)
  | ({
      attr: 'method';
    } & TelegramBotsPartialUpdateApiRequestMethodErrorComponent)
  | ({
      attr: 'headers';
    } & TelegramBotsPartialUpdateApiRequestHeadersErrorComponent)
  | ({
      attr: 'body';
    } & TelegramBotsPartialUpdateApiRequestBodyErrorComponent);

export type TelegramBotsPartialUpdateApiRequestErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateApiRequestValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateApiRequestHeadersErrorComponent = {
  attr: 'headers';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsPartialUpdateApiRequestMethodErrorComponent = {
  attr: 'method';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateApiRequestNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateApiRequestNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateApiRequestUrlErrorComponent = {
  attr: 'url';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateApiRequestValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateApiRequestError>;
};

export type TelegramBotsPartialUpdateApiRequestXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateApiRequestYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateBackgroundTaskError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateBackgroundTaskNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateBackgroundTaskNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateBackgroundTaskXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateBackgroundTaskYErrorComponent)
  | ({
      attr: 'interval';
    } & TelegramBotsPartialUpdateBackgroundTaskIntervalErrorComponent);

export type TelegramBotsPartialUpdateBackgroundTaskErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateBackgroundTaskValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateBackgroundTaskIntervalErrorComponent = {
  attr: 'interval';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateBackgroundTaskNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateBackgroundTaskNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateBackgroundTaskValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateBackgroundTaskError>;
};

export type TelegramBotsPartialUpdateBackgroundTaskXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateBackgroundTaskYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateChatError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateChatNonFieldErrorsErrorComponent)
  | ({
      attr: 'is_allowed';
    } & TelegramBotsPartialUpdateChatIsAllowedErrorComponent)
  | ({
      attr: 'is_blocked';
    } & TelegramBotsPartialUpdateChatIsBlockedErrorComponent);

export type TelegramBotsPartialUpdateChatErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateChatValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateChatIsAllowedErrorComponent = {
  attr: 'is_allowed';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateChatIsBlockedErrorComponent = {
  attr: 'is_blocked';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateChatNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateChatValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateChatError>;
};

export type TelegramBotsPartialUpdateConditionError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateConditionNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateConditionNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateConditionXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateConditionYErrorComponent)
  | ({
      attr: 'parts.non_field_errors';
    } & TelegramBotsPartialUpdateConditionPartsNonFieldErrorsErrorComponent)
  | ({
      attr: 'parts.INDEX.non_field_errors';
    } & TelegramBotsPartialUpdateConditionPartsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'parts.INDEX.type';
    } & TelegramBotsPartialUpdateConditionPartsIndexTypeErrorComponent)
  | ({
      attr: 'parts.INDEX.first_value';
    } & TelegramBotsPartialUpdateConditionPartsIndexFirstValueErrorComponent)
  | ({
      attr: 'parts.INDEX.operator';
    } & TelegramBotsPartialUpdateConditionPartsIndexOperatorErrorComponent)
  | ({
      attr: 'parts.INDEX.second_value';
    } & TelegramBotsPartialUpdateConditionPartsIndexSecondValueErrorComponent)
  | ({
      attr: 'parts.INDEX.next_part_operator';
    } & TelegramBotsPartialUpdateConditionPartsIndexNextPartOperatorErrorComponent);

export type TelegramBotsPartialUpdateConditionErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateConditionValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateConditionNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionPartsIndexFirstValueErrorComponent = {
  attr: 'parts.INDEX.first_value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionPartsIndexNextPartOperatorErrorComponent =
  {
    attr: 'parts.INDEX.next_part_operator';
    code: 'invalid_choice';
    detail: string;
  };

export type TelegramBotsPartialUpdateConditionPartsIndexNonFieldErrorsErrorComponent = {
  attr: 'parts.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionPartsIndexOperatorErrorComponent = {
  attr: 'parts.INDEX.operator';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionPartsIndexSecondValueErrorComponent = {
  attr: 'parts.INDEX.second_value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionPartsIndexTypeErrorComponent = {
  attr: 'parts.INDEX.type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionPartsNonFieldErrorsErrorComponent = {
  attr: 'parts.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateConditionError>;
};

export type TelegramBotsPartialUpdateConditionXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateConditionYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDatabaseOperationCreateOperationDataErrorComponent =
  {
    attr: 'create_operation.data';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };

export type TelegramBotsPartialUpdateDatabaseOperationCreateOperationNonFieldErrorsErrorComponent =
  {
    attr: 'create_operation.non_field_errors';
    code: 'invalid';
    detail: string;
  };

export type TelegramBotsPartialUpdateDatabaseOperationError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDatabaseOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateDatabaseOperationNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDatabaseOperationXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDatabaseOperationYErrorComponent)
  | ({
      attr: 'create_operation.non_field_errors';
    } & TelegramBotsPartialUpdateDatabaseOperationCreateOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'create_operation.data';
    } & TelegramBotsPartialUpdateDatabaseOperationCreateOperationDataErrorComponent)
  | ({
      attr: 'update_operation.non_field_errors';
    } & TelegramBotsPartialUpdateDatabaseOperationUpdateOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'update_operation.overwrite';
    } & TelegramBotsPartialUpdateDatabaseOperationUpdateOperationOverwriteErrorComponent)
  | ({
      attr: 'update_operation.lookup_field_name';
    } & TelegramBotsPartialUpdateDatabaseOperationUpdateOperationLookupFieldNameErrorComponent)
  | ({
      attr: 'update_operation.lookup_field_value';
    } & TelegramBotsPartialUpdateDatabaseOperationUpdateOperationLookupFieldValueErrorComponent)
  | ({
      attr: 'update_operation.create_if_not_found';
    } & TelegramBotsPartialUpdateDatabaseOperationUpdateOperationCreateIfNotFoundErrorComponent)
  | ({
      attr: 'update_operation.new_data';
    } & TelegramBotsPartialUpdateDatabaseOperationUpdateOperationNewDataErrorComponent);

export type TelegramBotsPartialUpdateDatabaseOperationErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDatabaseOperationValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDatabaseOperationNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateDatabaseOperationNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDatabaseOperationUpdateOperationCreateIfNotFoundErrorComponent =
  {
    attr: 'update_operation.create_if_not_found';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsPartialUpdateDatabaseOperationUpdateOperationLookupFieldNameErrorComponent =
  {
    attr: 'update_operation.lookup_field_name';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };

export type TelegramBotsPartialUpdateDatabaseOperationUpdateOperationLookupFieldValueErrorComponent =
  {
    attr: 'update_operation.lookup_field_value';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };

export type TelegramBotsPartialUpdateDatabaseOperationUpdateOperationNewDataErrorComponent =
  {
    attr: 'update_operation.new_data';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };

export type TelegramBotsPartialUpdateDatabaseOperationUpdateOperationNonFieldErrorsErrorComponent =
  {
    attr: 'update_operation.non_field_errors';
    code: 'invalid';
    detail: string;
  };

export type TelegramBotsPartialUpdateDatabaseOperationUpdateOperationOverwriteErrorComponent =
  {
    attr: 'update_operation.overwrite';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsPartialUpdateDatabaseOperationValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDatabaseOperationError>;
};

export type TelegramBotsPartialUpdateDatabaseOperationXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDatabaseOperationYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDatabaseRecordDataErrorComponent = {
  attr: 'data';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateDatabaseRecordError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDatabaseRecordNonFieldErrorsErrorComponent)
  | ({
      attr: 'data';
    } & TelegramBotsPartialUpdateDatabaseRecordDataErrorComponent);

export type TelegramBotsPartialUpdateDatabaseRecordErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDatabaseRecordValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDatabaseRecordNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDatabaseRecordValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDatabaseRecordError>;
};

export type TelegramBotsPartialUpdateDiagramApiRequestError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramApiRequestNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramApiRequestXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramApiRequestYErrorComponent);

export type TelegramBotsPartialUpdateDiagramApiRequestErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramApiRequestValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramApiRequestNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramApiRequestValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramApiRequestError>;
};

export type TelegramBotsPartialUpdateDiagramApiRequestXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramApiRequestYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramBackgroundTaskError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramBackgroundTaskNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramBackgroundTaskXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramBackgroundTaskYErrorComponent);

export type TelegramBotsPartialUpdateDiagramBackgroundTaskErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramBackgroundTaskValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramBackgroundTaskNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsPartialUpdateDiagramBackgroundTaskValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramBackgroundTaskError>;
};

export type TelegramBotsPartialUpdateDiagramBackgroundTaskXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramBackgroundTaskYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramConditionError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramConditionNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramConditionXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramConditionYErrorComponent);

export type TelegramBotsPartialUpdateDiagramConditionErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramConditionValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramConditionNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramConditionValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramConditionError>;
};

export type TelegramBotsPartialUpdateDiagramConditionXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramConditionYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramDatabaseOperationError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramDatabaseOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramDatabaseOperationXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramDatabaseOperationYErrorComponent);

export type TelegramBotsPartialUpdateDiagramDatabaseOperationErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramDatabaseOperationValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramDatabaseOperationNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsPartialUpdateDiagramDatabaseOperationValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramDatabaseOperationError>;
};

export type TelegramBotsPartialUpdateDiagramDatabaseOperationXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramDatabaseOperationYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramInvoiceError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramInvoiceNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramInvoiceXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramInvoiceYErrorComponent);

export type TelegramBotsPartialUpdateDiagramInvoiceErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramInvoiceValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramInvoiceNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramInvoiceValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramInvoiceError>;
};

export type TelegramBotsPartialUpdateDiagramInvoiceXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramInvoiceYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramMessageError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramMessageXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramMessageYErrorComponent);

export type TelegramBotsPartialUpdateDiagramMessageErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramMessageValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramMessageNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramMessageValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramMessageError>;
};

export type TelegramBotsPartialUpdateDiagramMessageXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramMessageYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramRandomizerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramRandomizerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramRandomizerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramRandomizerYErrorComponent);

export type TelegramBotsPartialUpdateDiagramRandomizerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramRandomizerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramRandomizerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramRandomizerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramRandomizerError>;
};

export type TelegramBotsPartialUpdateDiagramRandomizerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramRandomizerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramTemporaryVariableError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramTemporaryVariableNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramTemporaryVariableXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramTemporaryVariableYErrorComponent);

export type TelegramBotsPartialUpdateDiagramTemporaryVariableErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramTemporaryVariableValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramTemporaryVariableNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsPartialUpdateDiagramTemporaryVariableValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramTemporaryVariableError>;
};

export type TelegramBotsPartialUpdateDiagramTemporaryVariableXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramTemporaryVariableYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramTimerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramTimerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramTimerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramTimerYErrorComponent);

export type TelegramBotsPartialUpdateDiagramTimerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramTimerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramTimerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramTimerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramTimerError>;
};

export type TelegramBotsPartialUpdateDiagramTimerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramTimerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramTriggerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateDiagramTriggerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateDiagramTriggerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateDiagramTriggerYErrorComponent);

export type TelegramBotsPartialUpdateDiagramTriggerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateDiagramTriggerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateDiagramTriggerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramTriggerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateDiagramTriggerError>;
};

export type TelegramBotsPartialUpdateDiagramTriggerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateDiagramTriggerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateInvoiceNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateInvoiceNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateInvoiceXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateInvoiceYErrorComponent)
  | ({
      attr: 'title';
    } & TelegramBotsPartialUpdateInvoiceTitleErrorComponent)
  | ({
      attr: 'description';
    } & TelegramBotsPartialUpdateInvoiceDescriptionErrorComponent)
  | ({
      attr: 'image.non_field_errors';
    } & TelegramBotsPartialUpdateInvoiceImageNonFieldErrorsErrorComponent)
  | ({
      attr: 'image.file';
    } & TelegramBotsPartialUpdateInvoiceImageFileErrorComponent)
  | ({
      attr: 'image.from_url';
    } & TelegramBotsPartialUpdateInvoiceImageFromUrlErrorComponent)
  | ({
      attr: 'prices.non_field_errors';
    } & TelegramBotsPartialUpdateInvoicePricesNonFieldErrorsErrorComponent)
  | ({
      attr: 'prices.INDEX.non_field_errors';
    } & TelegramBotsPartialUpdateInvoicePricesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'prices.INDEX.label';
    } & TelegramBotsPartialUpdateInvoicePricesIndexLabelErrorComponent)
  | ({
      attr: 'prices.INDEX.amount';
    } & TelegramBotsPartialUpdateInvoicePricesIndexAmountErrorComponent);

export type TelegramBotsPartialUpdateInvoiceErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateInvoiceValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateInvoiceImageFileErrorComponent = {
  attr: 'image.file';
  code: 'empty' | 'invalid' | 'invalid_image' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceImageFromUrlErrorComponent = {
  attr: 'image.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceImageNonFieldErrorsErrorComponent = {
  attr: 'image.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoicePricesIndexAmountErrorComponent = {
  attr: 'prices.INDEX.amount';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoicePricesIndexLabelErrorComponent = {
  attr: 'prices.INDEX.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoicePricesIndexNonFieldErrorsErrorComponent = {
  attr: 'prices.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoicePricesNonFieldErrorsErrorComponent = {
  attr: 'prices.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceTitleErrorComponent = {
  attr: 'title';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateInvoiceError>;
};

export type TelegramBotsPartialUpdateInvoiceXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateInvoiceYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageDocumentsIndexFileErrorComponent = {
  attr: 'documents.INDEX.file';
  code: 'empty' | 'invalid' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageDocumentsIndexFromUrlErrorComponent = {
  attr: 'documents.INDEX.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageDocumentsIndexIdErrorComponent = {
  attr: 'documents.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageDocumentsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'documents.INDEX.non_field_errors';
    code: 'invalid';
    detail: string;
  };

export type TelegramBotsPartialUpdateMessageDocumentsIndexPositionErrorComponent = {
  attr: 'documents.INDEX.position';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageDocumentsNonFieldErrorsErrorComponent = {
  attr: 'documents.non_field_errors';
  code: 'not_a_list';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateMessageNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateMessageXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateMessageYErrorComponent)
  | ({
      attr: 'text';
    } & TelegramBotsPartialUpdateMessageTextErrorComponent)
  | ({
      attr: 'settings.non_field_errors';
    } & TelegramBotsPartialUpdateMessageSettingsNonFieldErrorsErrorComponent)
  | ({
      attr: 'settings.reply_to_user_message';
    } & TelegramBotsPartialUpdateMessageSettingsReplyToUserMessageErrorComponent)
  | ({
      attr: 'settings.delete_user_message';
    } & TelegramBotsPartialUpdateMessageSettingsDeleteUserMessageErrorComponent)
  | ({
      attr: 'settings.send_as_new_message';
    } & TelegramBotsPartialUpdateMessageSettingsSendAsNewMessageErrorComponent)
  | ({
      attr: 'images.non_field_errors';
    } & TelegramBotsPartialUpdateMessageImagesNonFieldErrorsErrorComponent)
  | ({
      attr: 'images.INDEX.non_field_errors';
    } & TelegramBotsPartialUpdateMessageImagesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'images.INDEX.file';
    } & TelegramBotsPartialUpdateMessageImagesIndexFileErrorComponent)
  | ({
      attr: 'images.INDEX.from_url';
    } & TelegramBotsPartialUpdateMessageImagesIndexFromUrlErrorComponent)
  | ({
      attr: 'images.INDEX.id';
    } & TelegramBotsPartialUpdateMessageImagesIndexIdErrorComponent)
  | ({
      attr: 'images.INDEX.position';
    } & TelegramBotsPartialUpdateMessageImagesIndexPositionErrorComponent)
  | ({
      attr: 'documents.non_field_errors';
    } & TelegramBotsPartialUpdateMessageDocumentsNonFieldErrorsErrorComponent)
  | ({
      attr: 'documents.INDEX.non_field_errors';
    } & TelegramBotsPartialUpdateMessageDocumentsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'documents.INDEX.file';
    } & TelegramBotsPartialUpdateMessageDocumentsIndexFileErrorComponent)
  | ({
      attr: 'documents.INDEX.from_url';
    } & TelegramBotsPartialUpdateMessageDocumentsIndexFromUrlErrorComponent)
  | ({
      attr: 'documents.INDEX.id';
    } & TelegramBotsPartialUpdateMessageDocumentsIndexIdErrorComponent)
  | ({
      attr: 'documents.INDEX.position';
    } & TelegramBotsPartialUpdateMessageDocumentsIndexPositionErrorComponent)
  | ({
      attr: 'keyboard.non_field_errors';
    } & TelegramBotsPartialUpdateMessageKeyboardNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.type';
    } & TelegramBotsPartialUpdateMessageKeyboardTypeErrorComponent)
  | ({
      attr: 'keyboard.buttons.non_field_errors';
    } & TelegramBotsPartialUpdateMessageKeyboardButtonsNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.non_field_errors';
    } & TelegramBotsPartialUpdateMessageKeyboardButtonsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.id';
    } & TelegramBotsPartialUpdateMessageKeyboardButtonsIndexIdErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.row';
    } & TelegramBotsPartialUpdateMessageKeyboardButtonsIndexRowErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.position';
    } & TelegramBotsPartialUpdateMessageKeyboardButtonsIndexPositionErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.text';
    } & TelegramBotsPartialUpdateMessageKeyboardButtonsIndexTextErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.url';
    } & TelegramBotsPartialUpdateMessageKeyboardButtonsIndexUrlErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.style';
    } & TelegramBotsPartialUpdateMessageKeyboardButtonsIndexStyleErrorComponent);

export type TelegramBotsPartialUpdateMessageErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateMessageValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateMessageImagesIndexFileErrorComponent = {
  attr: 'images.INDEX.file';
  code: 'empty' | 'invalid' | 'invalid_image' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageImagesIndexFromUrlErrorComponent = {
  attr: 'images.INDEX.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageImagesIndexIdErrorComponent = {
  attr: 'images.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageImagesIndexNonFieldErrorsErrorComponent = {
  attr: 'images.INDEX.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageImagesIndexPositionErrorComponent = {
  attr: 'images.INDEX.position';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageImagesNonFieldErrorsErrorComponent = {
  attr: 'images.non_field_errors';
  code: 'not_a_list';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageKeyboardButtonsIndexIdErrorComponent = {
  attr: 'keyboard.buttons.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageKeyboardButtonsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'keyboard.buttons.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };

export type TelegramBotsPartialUpdateMessageKeyboardButtonsIndexPositionErrorComponent =
  {
    attr: 'keyboard.buttons.INDEX.position';
    code:
      'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
    detail: string;
  };

export type TelegramBotsPartialUpdateMessageKeyboardButtonsIndexRowErrorComponent = {
  attr: 'keyboard.buttons.INDEX.row';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageKeyboardButtonsIndexStyleErrorComponent = {
  attr: 'keyboard.buttons.INDEX.style';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageKeyboardButtonsIndexTextErrorComponent = {
  attr: 'keyboard.buttons.INDEX.text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageKeyboardButtonsIndexUrlErrorComponent = {
  attr: 'keyboard.buttons.INDEX.url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageKeyboardButtonsNonFieldErrorsErrorComponent =
  {
    attr: 'keyboard.buttons.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };

export type TelegramBotsPartialUpdateMessageKeyboardNonFieldErrorsErrorComponent = {
  attr: 'keyboard.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageKeyboardTypeErrorComponent = {
  attr: 'keyboard.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageSettingsDeleteUserMessageErrorComponent = {
  attr: 'settings.delete_user_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageSettingsNonFieldErrorsErrorComponent = {
  attr: 'settings.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageSettingsReplyToUserMessageErrorComponent = {
  attr: 'settings.reply_to_user_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageSettingsSendAsNewMessageErrorComponent = {
  attr: 'settings.send_as_new_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageTextErrorComponent = {
  attr: 'text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateMessageError>;
};

export type TelegramBotsPartialUpdateMessageXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateMessageYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateRandomizerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateRandomizerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateRandomizerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateRandomizerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateRandomizerYErrorComponent);

export type TelegramBotsPartialUpdateRandomizerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateRandomizerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateRandomizerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateRandomizerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateRandomizerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateRandomizerError>;
};

export type TelegramBotsPartialUpdateRandomizerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateRandomizerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTelegramBotApiTokenErrorComponent = {
  attr: 'api_token';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed'
    | 'unique';
  detail: string;
};

export type TelegramBotsPartialUpdateTelegramBotError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateTelegramBotNonFieldErrorsErrorComponent)
  | ({
      attr: 'api_token';
    } & TelegramBotsPartialUpdateTelegramBotApiTokenErrorComponent)
  | ({
      attr: 'is_private';
    } & TelegramBotsPartialUpdateTelegramBotIsPrivateErrorComponent);

export type TelegramBotsPartialUpdateTelegramBotErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateTelegramBotValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateTelegramBotIsPrivateErrorComponent = {
  attr: 'is_private';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTelegramBotNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTelegramBotValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateTelegramBotError>;
};

export type TelegramBotsPartialUpdateTemporaryVariableError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateTemporaryVariableNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateTemporaryVariableNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateTemporaryVariableXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateTemporaryVariableYErrorComponent)
  | ({
      attr: 'value';
    } & TelegramBotsPartialUpdateTemporaryVariableValueErrorComponent);

export type TelegramBotsPartialUpdateTemporaryVariableErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateTemporaryVariableValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateTemporaryVariableNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateTemporaryVariableNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTemporaryVariableValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateTemporaryVariableError>;
};

export type TelegramBotsPartialUpdateTemporaryVariableValueErrorComponent = {
  attr: 'value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateTemporaryVariableXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTemporaryVariableYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTimerDurationSecondsErrorComponent = {
  attr: 'duration_seconds';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsPartialUpdateTimerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateTimerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateTimerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateTimerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateTimerYErrorComponent)
  | ({
      attr: 'duration_seconds';
    } & TelegramBotsPartialUpdateTimerDurationSecondsErrorComponent);

export type TelegramBotsPartialUpdateTimerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateTimerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateTimerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateTimerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTimerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateTimerError>;
};

export type TelegramBotsPartialUpdateTimerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTimerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerCommandCommandErrorComponent = {
  attr: 'command.command';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerCommandDescriptionErrorComponent = {
  attr: 'command.description';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerCommandNonFieldErrorsErrorComponent = {
  attr: 'command.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerCommandPayloadErrorComponent = {
  attr: 'command.payload';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateTriggerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateTriggerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsPartialUpdateTriggerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsPartialUpdateTriggerYErrorComponent)
  | ({
      attr: 'command.non_field_errors';
    } & TelegramBotsPartialUpdateTriggerCommandNonFieldErrorsErrorComponent)
  | ({
      attr: 'command.command';
    } & TelegramBotsPartialUpdateTriggerCommandCommandErrorComponent)
  | ({
      attr: 'command.payload';
    } & TelegramBotsPartialUpdateTriggerCommandPayloadErrorComponent)
  | ({
      attr: 'command.description';
    } & TelegramBotsPartialUpdateTriggerCommandDescriptionErrorComponent)
  | ({
      attr: 'message.non_field_errors';
    } & TelegramBotsPartialUpdateTriggerMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'message.text';
    } & TelegramBotsPartialUpdateTriggerMessageTextErrorComponent)
  | ({
      attr: 'webhook.non_field_errors';
    } & TelegramBotsPartialUpdateTriggerWebhookNonFieldErrorsErrorComponent);

export type TelegramBotsPartialUpdateTriggerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateTriggerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateTriggerMessageNonFieldErrorsErrorComponent = {
  attr: 'message.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerMessageTextErrorComponent = {
  attr: 'message.text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateTriggerError>;
};

export type TelegramBotsPartialUpdateTriggerWebhookNonFieldErrorsErrorComponent = {
  attr: 'webhook.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateTriggerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateUserError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateUserNonFieldErrorsErrorComponent)
  | ({
      attr: 'is_allowed';
    } & TelegramBotsPartialUpdateUserIsAllowedErrorComponent)
  | ({
      attr: 'is_blocked';
    } & TelegramBotsPartialUpdateUserIsBlockedErrorComponent);

export type TelegramBotsPartialUpdateUserErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateUserValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateUserIsAllowedErrorComponent = {
  attr: 'is_allowed';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateUserIsBlockedErrorComponent = {
  attr: 'is_blocked';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateUserNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateUserValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateUserError>;
};

export type TelegramBotsPartialUpdateVariableDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateVariableError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsPartialUpdateVariableNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsPartialUpdateVariableNameErrorComponent)
  | ({
      attr: 'value';
    } & TelegramBotsPartialUpdateVariableValueErrorComponent)
  | ({
      attr: 'description';
    } & TelegramBotsPartialUpdateVariableDescriptionErrorComponent);

export type TelegramBotsPartialUpdateVariableErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsPartialUpdateVariableValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsPartialUpdateVariableNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPartialUpdateVariableNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsPartialUpdateVariableValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsPartialUpdateVariableError>;
};

export type TelegramBotsPartialUpdateVariableValueErrorComponent = {
  attr: 'value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsPostTelegramBotRestartErrorResponse400 = ParseErrorResponse;

export type TelegramBotsPostTelegramBotStartErrorResponse400 = ParseErrorResponse;

export type TelegramBotsPostTelegramBotStopErrorResponse400 = ParseErrorResponse;

export type TelegramBotsUpdateApiRequestBodyErrorComponent = {
  attr: 'body';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateApiRequestError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateApiRequestNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateApiRequestNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateApiRequestXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateApiRequestYErrorComponent)
  | ({
      attr: 'url';
    } & TelegramBotsUpdateApiRequestUrlErrorComponent)
  | ({
      attr: 'method';
    } & TelegramBotsUpdateApiRequestMethodErrorComponent)
  | ({
      attr: 'headers';
    } & TelegramBotsUpdateApiRequestHeadersErrorComponent)
  | ({
      attr: 'body';
    } & TelegramBotsUpdateApiRequestBodyErrorComponent);

export type TelegramBotsUpdateApiRequestErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateApiRequestValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateApiRequestHeadersErrorComponent = {
  attr: 'headers';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateApiRequestMethodErrorComponent = {
  attr: 'method';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsUpdateApiRequestNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateApiRequestNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateApiRequestUrlErrorComponent = {
  attr: 'url';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateApiRequestValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateApiRequestError>;
};

export type TelegramBotsUpdateApiRequestXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateApiRequestYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateBackgroundTaskError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateBackgroundTaskNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateBackgroundTaskNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateBackgroundTaskXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateBackgroundTaskYErrorComponent)
  | ({
      attr: 'interval';
    } & TelegramBotsUpdateBackgroundTaskIntervalErrorComponent);

export type TelegramBotsUpdateBackgroundTaskErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateBackgroundTaskValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateBackgroundTaskIntervalErrorComponent = {
  attr: 'interval';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateBackgroundTaskNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateBackgroundTaskNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateBackgroundTaskValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateBackgroundTaskError>;
};

export type TelegramBotsUpdateBackgroundTaskXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateBackgroundTaskYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateChatError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateChatNonFieldErrorsErrorComponent)
  | ({
      attr: 'is_allowed';
    } & TelegramBotsUpdateChatIsAllowedErrorComponent)
  | ({
      attr: 'is_blocked';
    } & TelegramBotsUpdateChatIsBlockedErrorComponent);

export type TelegramBotsUpdateChatErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateChatValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateChatIsAllowedErrorComponent = {
  attr: 'is_allowed';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateChatIsBlockedErrorComponent = {
  attr: 'is_blocked';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateChatNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateChatValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateChatError>;
};

export type TelegramBotsUpdateConditionError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateConditionNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateConditionNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateConditionXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateConditionYErrorComponent)
  | ({
      attr: 'parts.non_field_errors';
    } & TelegramBotsUpdateConditionPartsNonFieldErrorsErrorComponent)
  | ({
      attr: 'parts.INDEX.non_field_errors';
    } & TelegramBotsUpdateConditionPartsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'parts.INDEX.type';
    } & TelegramBotsUpdateConditionPartsIndexTypeErrorComponent)
  | ({
      attr: 'parts.INDEX.first_value';
    } & TelegramBotsUpdateConditionPartsIndexFirstValueErrorComponent)
  | ({
      attr: 'parts.INDEX.operator';
    } & TelegramBotsUpdateConditionPartsIndexOperatorErrorComponent)
  | ({
      attr: 'parts.INDEX.second_value';
    } & TelegramBotsUpdateConditionPartsIndexSecondValueErrorComponent)
  | ({
      attr: 'parts.INDEX.next_part_operator';
    } & TelegramBotsUpdateConditionPartsIndexNextPartOperatorErrorComponent);

export type TelegramBotsUpdateConditionErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateConditionValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateConditionNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateConditionNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateConditionPartsIndexFirstValueErrorComponent = {
  attr: 'parts.INDEX.first_value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateConditionPartsIndexNextPartOperatorErrorComponent = {
  attr: 'parts.INDEX.next_part_operator';
  code: 'invalid_choice';
  detail: string;
};

export type TelegramBotsUpdateConditionPartsIndexNonFieldErrorsErrorComponent = {
  attr: 'parts.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateConditionPartsIndexOperatorErrorComponent = {
  attr: 'parts.INDEX.operator';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateConditionPartsIndexSecondValueErrorComponent = {
  attr: 'parts.INDEX.second_value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateConditionPartsIndexTypeErrorComponent = {
  attr: 'parts.INDEX.type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateConditionPartsNonFieldErrorsErrorComponent = {
  attr: 'parts.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateConditionValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateConditionError>;
};

export type TelegramBotsUpdateConditionXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateConditionYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDatabaseOperationCreateOperationDataErrorComponent = {
  attr: 'create_operation.data';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateDatabaseOperationCreateOperationNonFieldErrorsErrorComponent =
  {
    attr: 'create_operation.non_field_errors';
    code: 'invalid';
    detail: string;
  };

export type TelegramBotsUpdateDatabaseOperationError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDatabaseOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateDatabaseOperationNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDatabaseOperationXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDatabaseOperationYErrorComponent)
  | ({
      attr: 'create_operation.non_field_errors';
    } & TelegramBotsUpdateDatabaseOperationCreateOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'create_operation.data';
    } & TelegramBotsUpdateDatabaseOperationCreateOperationDataErrorComponent)
  | ({
      attr: 'update_operation.non_field_errors';
    } & TelegramBotsUpdateDatabaseOperationUpdateOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'update_operation.overwrite';
    } & TelegramBotsUpdateDatabaseOperationUpdateOperationOverwriteErrorComponent)
  | ({
      attr: 'update_operation.lookup_field_name';
    } & TelegramBotsUpdateDatabaseOperationUpdateOperationLookupFieldNameErrorComponent)
  | ({
      attr: 'update_operation.lookup_field_value';
    } & TelegramBotsUpdateDatabaseOperationUpdateOperationLookupFieldValueErrorComponent)
  | ({
      attr: 'update_operation.create_if_not_found';
    } & TelegramBotsUpdateDatabaseOperationUpdateOperationCreateIfNotFoundErrorComponent)
  | ({
      attr: 'update_operation.new_data';
    } & TelegramBotsUpdateDatabaseOperationUpdateOperationNewDataErrorComponent);

export type TelegramBotsUpdateDatabaseOperationErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDatabaseOperationValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDatabaseOperationNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateDatabaseOperationNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDatabaseOperationUpdateOperationCreateIfNotFoundErrorComponent =
  {
    attr: 'update_operation.create_if_not_found';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsUpdateDatabaseOperationUpdateOperationLookupFieldNameErrorComponent =
  {
    attr: 'update_operation.lookup_field_name';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };

export type TelegramBotsUpdateDatabaseOperationUpdateOperationLookupFieldValueErrorComponent =
  {
    attr: 'update_operation.lookup_field_value';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };

export type TelegramBotsUpdateDatabaseOperationUpdateOperationNewDataErrorComponent = {
  attr: 'update_operation.new_data';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateDatabaseOperationUpdateOperationNonFieldErrorsErrorComponent =
  {
    attr: 'update_operation.non_field_errors';
    code: 'invalid';
    detail: string;
  };

export type TelegramBotsUpdateDatabaseOperationUpdateOperationOverwriteErrorComponent =
  {
    attr: 'update_operation.overwrite';
    code: 'invalid' | 'null';
    detail: string;
  };

export type TelegramBotsUpdateDatabaseOperationValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDatabaseOperationError>;
};

export type TelegramBotsUpdateDatabaseOperationXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDatabaseOperationYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDatabaseRecordDataErrorComponent = {
  attr: 'data';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateDatabaseRecordError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDatabaseRecordNonFieldErrorsErrorComponent)
  | ({
      attr: 'data';
    } & TelegramBotsUpdateDatabaseRecordDataErrorComponent);

export type TelegramBotsUpdateDatabaseRecordErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDatabaseRecordValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDatabaseRecordNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDatabaseRecordValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDatabaseRecordError>;
};

export type TelegramBotsUpdateDiagramApiRequestError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramApiRequestNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramApiRequestXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramApiRequestYErrorComponent);

export type TelegramBotsUpdateDiagramApiRequestErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramApiRequestValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramApiRequestNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramApiRequestValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramApiRequestError>;
};

export type TelegramBotsUpdateDiagramApiRequestXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramApiRequestYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramBackgroundTaskError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramBackgroundTaskNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramBackgroundTaskXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramBackgroundTaskYErrorComponent);

export type TelegramBotsUpdateDiagramBackgroundTaskErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramBackgroundTaskValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramBackgroundTaskNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramBackgroundTaskValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramBackgroundTaskError>;
};

export type TelegramBotsUpdateDiagramBackgroundTaskXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramBackgroundTaskYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramConditionError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramConditionNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramConditionXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramConditionYErrorComponent);

export type TelegramBotsUpdateDiagramConditionErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramConditionValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramConditionNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramConditionValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramConditionError>;
};

export type TelegramBotsUpdateDiagramConditionXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramConditionYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramDatabaseOperationError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramDatabaseOperationNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramDatabaseOperationXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramDatabaseOperationYErrorComponent);

export type TelegramBotsUpdateDiagramDatabaseOperationErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramDatabaseOperationValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramDatabaseOperationNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramDatabaseOperationValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramDatabaseOperationError>;
};

export type TelegramBotsUpdateDiagramDatabaseOperationXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramDatabaseOperationYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramInvoiceError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramInvoiceNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramInvoiceXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramInvoiceYErrorComponent);

export type TelegramBotsUpdateDiagramInvoiceErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramInvoiceValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramInvoiceNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramInvoiceValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramInvoiceError>;
};

export type TelegramBotsUpdateDiagramInvoiceXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramInvoiceYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramMessageError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramMessageXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramMessageYErrorComponent);

export type TelegramBotsUpdateDiagramMessageErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramMessageValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramMessageNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramMessageValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramMessageError>;
};

export type TelegramBotsUpdateDiagramMessageXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramMessageYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramRandomizerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramRandomizerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramRandomizerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramRandomizerYErrorComponent);

export type TelegramBotsUpdateDiagramRandomizerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramRandomizerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramRandomizerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramRandomizerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramRandomizerError>;
};

export type TelegramBotsUpdateDiagramRandomizerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramRandomizerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTemporaryVariableError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramTemporaryVariableNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramTemporaryVariableXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramTemporaryVariableYErrorComponent);

export type TelegramBotsUpdateDiagramTemporaryVariableErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramTemporaryVariableValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramTemporaryVariableNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTemporaryVariableValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramTemporaryVariableError>;
};

export type TelegramBotsUpdateDiagramTemporaryVariableXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTemporaryVariableYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTimerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramTimerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramTimerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramTimerYErrorComponent);

export type TelegramBotsUpdateDiagramTimerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramTimerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramTimerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTimerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramTimerError>;
};

export type TelegramBotsUpdateDiagramTimerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTimerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTriggerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateDiagramTriggerNonFieldErrorsErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateDiagramTriggerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateDiagramTriggerYErrorComponent);

export type TelegramBotsUpdateDiagramTriggerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateDiagramTriggerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateDiagramTriggerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTriggerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateDiagramTriggerError>;
};

export type TelegramBotsUpdateDiagramTriggerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateDiagramTriggerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateInvoiceDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateInvoiceError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateInvoiceNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateInvoiceNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateInvoiceXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateInvoiceYErrorComponent)
  | ({
      attr: 'title';
    } & TelegramBotsUpdateInvoiceTitleErrorComponent)
  | ({
      attr: 'description';
    } & TelegramBotsUpdateInvoiceDescriptionErrorComponent)
  | ({
      attr: 'image.non_field_errors';
    } & TelegramBotsUpdateInvoiceImageNonFieldErrorsErrorComponent)
  | ({
      attr: 'image.file';
    } & TelegramBotsUpdateInvoiceImageFileErrorComponent)
  | ({
      attr: 'image.from_url';
    } & TelegramBotsUpdateInvoiceImageFromUrlErrorComponent)
  | ({
      attr: 'prices.non_field_errors';
    } & TelegramBotsUpdateInvoicePricesNonFieldErrorsErrorComponent)
  | ({
      attr: 'prices.INDEX.non_field_errors';
    } & TelegramBotsUpdateInvoicePricesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'prices.INDEX.label';
    } & TelegramBotsUpdateInvoicePricesIndexLabelErrorComponent)
  | ({
      attr: 'prices.INDEX.amount';
    } & TelegramBotsUpdateInvoicePricesIndexAmountErrorComponent);

export type TelegramBotsUpdateInvoiceErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateInvoiceValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateInvoiceImageFileErrorComponent = {
  attr: 'image.file';
  code: 'empty' | 'invalid' | 'invalid_image' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsUpdateInvoiceImageFromUrlErrorComponent = {
  attr: 'image.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateInvoiceImageNonFieldErrorsErrorComponent = {
  attr: 'image.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateInvoiceNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateInvoiceNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateInvoicePricesIndexAmountErrorComponent = {
  attr: 'prices.INDEX.amount';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateInvoicePricesIndexLabelErrorComponent = {
  attr: 'prices.INDEX.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateInvoicePricesIndexNonFieldErrorsErrorComponent = {
  attr: 'prices.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateInvoicePricesNonFieldErrorsErrorComponent = {
  attr: 'prices.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateInvoiceTitleErrorComponent = {
  attr: 'title';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateInvoiceValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateInvoiceError>;
};

export type TelegramBotsUpdateInvoiceXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateInvoiceYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageDocumentsIndexFileErrorComponent = {
  attr: 'documents.INDEX.file';
  code: 'empty' | 'invalid' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsUpdateMessageDocumentsIndexFromUrlErrorComponent = {
  attr: 'documents.INDEX.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateMessageDocumentsIndexIdErrorComponent = {
  attr: 'documents.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageDocumentsIndexNonFieldErrorsErrorComponent = {
  attr: 'documents.INDEX.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateMessageDocumentsIndexPositionErrorComponent = {
  attr: 'documents.INDEX.position';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateMessageDocumentsNonFieldErrorsErrorComponent = {
  attr: 'documents.non_field_errors';
  code: 'not_a_list';
  detail: string;
};

export type TelegramBotsUpdateMessageError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateMessageNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateMessageXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateMessageYErrorComponent)
  | ({
      attr: 'text';
    } & TelegramBotsUpdateMessageTextErrorComponent)
  | ({
      attr: 'settings.non_field_errors';
    } & TelegramBotsUpdateMessageSettingsNonFieldErrorsErrorComponent)
  | ({
      attr: 'settings.reply_to_user_message';
    } & TelegramBotsUpdateMessageSettingsReplyToUserMessageErrorComponent)
  | ({
      attr: 'settings.delete_user_message';
    } & TelegramBotsUpdateMessageSettingsDeleteUserMessageErrorComponent)
  | ({
      attr: 'settings.send_as_new_message';
    } & TelegramBotsUpdateMessageSettingsSendAsNewMessageErrorComponent)
  | ({
      attr: 'images.non_field_errors';
    } & TelegramBotsUpdateMessageImagesNonFieldErrorsErrorComponent)
  | ({
      attr: 'images.INDEX.non_field_errors';
    } & TelegramBotsUpdateMessageImagesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'images.INDEX.file';
    } & TelegramBotsUpdateMessageImagesIndexFileErrorComponent)
  | ({
      attr: 'images.INDEX.from_url';
    } & TelegramBotsUpdateMessageImagesIndexFromUrlErrorComponent)
  | ({
      attr: 'images.INDEX.id';
    } & TelegramBotsUpdateMessageImagesIndexIdErrorComponent)
  | ({
      attr: 'images.INDEX.position';
    } & TelegramBotsUpdateMessageImagesIndexPositionErrorComponent)
  | ({
      attr: 'documents.non_field_errors';
    } & TelegramBotsUpdateMessageDocumentsNonFieldErrorsErrorComponent)
  | ({
      attr: 'documents.INDEX.non_field_errors';
    } & TelegramBotsUpdateMessageDocumentsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'documents.INDEX.file';
    } & TelegramBotsUpdateMessageDocumentsIndexFileErrorComponent)
  | ({
      attr: 'documents.INDEX.from_url';
    } & TelegramBotsUpdateMessageDocumentsIndexFromUrlErrorComponent)
  | ({
      attr: 'documents.INDEX.id';
    } & TelegramBotsUpdateMessageDocumentsIndexIdErrorComponent)
  | ({
      attr: 'documents.INDEX.position';
    } & TelegramBotsUpdateMessageDocumentsIndexPositionErrorComponent)
  | ({
      attr: 'keyboard.non_field_errors';
    } & TelegramBotsUpdateMessageKeyboardNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.type';
    } & TelegramBotsUpdateMessageKeyboardTypeErrorComponent)
  | ({
      attr: 'keyboard.buttons.non_field_errors';
    } & TelegramBotsUpdateMessageKeyboardButtonsNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.non_field_errors';
    } & TelegramBotsUpdateMessageKeyboardButtonsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.id';
    } & TelegramBotsUpdateMessageKeyboardButtonsIndexIdErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.row';
    } & TelegramBotsUpdateMessageKeyboardButtonsIndexRowErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.position';
    } & TelegramBotsUpdateMessageKeyboardButtonsIndexPositionErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.text';
    } & TelegramBotsUpdateMessageKeyboardButtonsIndexTextErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.url';
    } & TelegramBotsUpdateMessageKeyboardButtonsIndexUrlErrorComponent)
  | ({
      attr: 'keyboard.buttons.INDEX.style';
    } & TelegramBotsUpdateMessageKeyboardButtonsIndexStyleErrorComponent);

export type TelegramBotsUpdateMessageErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateMessageValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateMessageImagesIndexFileErrorComponent = {
  attr: 'images.INDEX.file';
  code: 'empty' | 'invalid' | 'invalid_image' | 'max_length' | 'no_name';
  detail: string;
};

export type TelegramBotsUpdateMessageImagesIndexFromUrlErrorComponent = {
  attr: 'images.INDEX.from_url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateMessageImagesIndexIdErrorComponent = {
  attr: 'images.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageImagesIndexNonFieldErrorsErrorComponent = {
  attr: 'images.INDEX.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateMessageImagesIndexPositionErrorComponent = {
  attr: 'images.INDEX.position';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateMessageImagesNonFieldErrorsErrorComponent = {
  attr: 'images.non_field_errors';
  code: 'not_a_list';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardButtonsIndexIdErrorComponent = {
  attr: 'keyboard.buttons.INDEX.id';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardButtonsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'keyboard.buttons.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };

export type TelegramBotsUpdateMessageKeyboardButtonsIndexPositionErrorComponent = {
  attr: 'keyboard.buttons.INDEX.position';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardButtonsIndexRowErrorComponent = {
  attr: 'keyboard.buttons.INDEX.row';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardButtonsIndexStyleErrorComponent = {
  attr: 'keyboard.buttons.INDEX.style';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardButtonsIndexTextErrorComponent = {
  attr: 'keyboard.buttons.INDEX.text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardButtonsIndexUrlErrorComponent = {
  attr: 'keyboard.buttons.INDEX.url';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardButtonsNonFieldErrorsErrorComponent = {
  attr: 'keyboard.buttons.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardNonFieldErrorsErrorComponent = {
  attr: 'keyboard.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateMessageKeyboardTypeErrorComponent = {
  attr: 'keyboard.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateMessageNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageSettingsDeleteUserMessageErrorComponent = {
  attr: 'settings.delete_user_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageSettingsNonFieldErrorsErrorComponent = {
  attr: 'settings.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateMessageSettingsReplyToUserMessageErrorComponent = {
  attr: 'settings.reply_to_user_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageSettingsSendAsNewMessageErrorComponent = {
  attr: 'settings.send_as_new_message';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageTextErrorComponent = {
  attr: 'text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateMessageValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateMessageError>;
};

export type TelegramBotsUpdateMessageXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateMessageYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateRandomizerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateRandomizerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateRandomizerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateRandomizerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateRandomizerYErrorComponent);

export type TelegramBotsUpdateRandomizerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateRandomizerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateRandomizerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateRandomizerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateRandomizerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateRandomizerError>;
};

export type TelegramBotsUpdateRandomizerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateRandomizerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTelegramBotApiTokenErrorComponent = {
  attr: 'api_token';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed'
    | 'unique';
  detail: string;
};

export type TelegramBotsUpdateTelegramBotError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateTelegramBotNonFieldErrorsErrorComponent)
  | ({
      attr: 'api_token';
    } & TelegramBotsUpdateTelegramBotApiTokenErrorComponent)
  | ({
      attr: 'is_private';
    } & TelegramBotsUpdateTelegramBotIsPrivateErrorComponent);

export type TelegramBotsUpdateTelegramBotErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateTelegramBotValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateTelegramBotIsPrivateErrorComponent = {
  attr: 'is_private';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTelegramBotNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTelegramBotValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateTelegramBotError>;
};

export type TelegramBotsUpdateTemporaryVariableError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateTemporaryVariableNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateTemporaryVariableNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateTemporaryVariableXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateTemporaryVariableYErrorComponent)
  | ({
      attr: 'value';
    } & TelegramBotsUpdateTemporaryVariableValueErrorComponent);

export type TelegramBotsUpdateTemporaryVariableErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateTemporaryVariableValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateTemporaryVariableNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateTemporaryVariableNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTemporaryVariableValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateTemporaryVariableError>;
};

export type TelegramBotsUpdateTemporaryVariableValueErrorComponent = {
  attr: 'value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateTemporaryVariableXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTemporaryVariableYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTimerDurationSecondsErrorComponent = {
  attr: 'duration_seconds';
  code:
    'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null' | 'required';
  detail: string;
};

export type TelegramBotsUpdateTimerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateTimerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateTimerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateTimerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateTimerYErrorComponent)
  | ({
      attr: 'duration_seconds';
    } & TelegramBotsUpdateTimerDurationSecondsErrorComponent);

export type TelegramBotsUpdateTimerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateTimerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateTimerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateTimerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTimerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateTimerError>;
};

export type TelegramBotsUpdateTimerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTimerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTriggerCommandCommandErrorComponent = {
  attr: 'command.command';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateTriggerCommandDescriptionErrorComponent = {
  attr: 'command.description';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateTriggerCommandNonFieldErrorsErrorComponent = {
  attr: 'command.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateTriggerCommandPayloadErrorComponent = {
  attr: 'command.payload';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateTriggerError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateTriggerNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateTriggerNameErrorComponent)
  | ({
      attr: 'x';
    } & TelegramBotsUpdateTriggerXErrorComponent)
  | ({
      attr: 'y';
    } & TelegramBotsUpdateTriggerYErrorComponent)
  | ({
      attr: 'command.non_field_errors';
    } & TelegramBotsUpdateTriggerCommandNonFieldErrorsErrorComponent)
  | ({
      attr: 'command.command';
    } & TelegramBotsUpdateTriggerCommandCommandErrorComponent)
  | ({
      attr: 'command.payload';
    } & TelegramBotsUpdateTriggerCommandPayloadErrorComponent)
  | ({
      attr: 'command.description';
    } & TelegramBotsUpdateTriggerCommandDescriptionErrorComponent)
  | ({
      attr: 'message.non_field_errors';
    } & TelegramBotsUpdateTriggerMessageNonFieldErrorsErrorComponent)
  | ({
      attr: 'message.text';
    } & TelegramBotsUpdateTriggerMessageTextErrorComponent)
  | ({
      attr: 'webhook.non_field_errors';
    } & TelegramBotsUpdateTriggerWebhookNonFieldErrorsErrorComponent);

export type TelegramBotsUpdateTriggerErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateTriggerValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateTriggerMessageNonFieldErrorsErrorComponent = {
  attr: 'message.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateTriggerMessageTextErrorComponent = {
  attr: 'message.text';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateTriggerNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateTriggerNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTriggerValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateTriggerError>;
};

export type TelegramBotsUpdateTriggerWebhookNonFieldErrorsErrorComponent = {
  attr: 'webhook.non_field_errors';
  code: 'invalid';
  detail: string;
};

export type TelegramBotsUpdateTriggerXErrorComponent = {
  attr: 'x';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateTriggerYErrorComponent = {
  attr: 'y';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};

export type TelegramBotsUpdateUserError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateUserNonFieldErrorsErrorComponent)
  | ({
      attr: 'is_allowed';
    } & TelegramBotsUpdateUserIsAllowedErrorComponent)
  | ({
      attr: 'is_blocked';
    } & TelegramBotsUpdateUserIsBlockedErrorComponent);

export type TelegramBotsUpdateUserErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateUserValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateUserIsAllowedErrorComponent = {
  attr: 'is_allowed';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateUserIsBlockedErrorComponent = {
  attr: 'is_blocked';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateUserNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateUserValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateUserError>;
};

export type TelegramBotsUpdateVariableDescriptionErrorComponent = {
  attr: 'description';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateVariableError =
  | ({
      attr: 'non_field_errors';
    } & TelegramBotsUpdateVariableNonFieldErrorsErrorComponent)
  | ({
      attr: 'name';
    } & TelegramBotsUpdateVariableNameErrorComponent)
  | ({
      attr: 'value';
    } & TelegramBotsUpdateVariableValueErrorComponent)
  | ({
      attr: 'description';
    } & TelegramBotsUpdateVariableDescriptionErrorComponent);

export type TelegramBotsUpdateVariableErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TelegramBotsUpdateVariableValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type TelegramBotsUpdateVariableNameErrorComponent = {
  attr: 'name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TelegramBotsUpdateVariableNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type TelegramBotsUpdateVariableValidationError = {
  type: ValidationErrorType;
  errors: Array<TelegramBotsUpdateVariableError>;
};

export type TelegramBotsUpdateVariableValueErrorComponent = {
  attr: 'value';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type TemporaryVariable = {
  readonly id: number;
  name: string;
  value: string;
};

export type TemporaryVariableRequest = {
  name: string;
  value: string;
};

export type Timer = {
  readonly id: number;
  name: string;
  duration_seconds: number;
};

export type TimerRequest = {
  name: string;
  duration_seconds: number;
};

export type Token = {
  readonly jti: string;
  readonly type: TokenType;
  readonly blacklisted_date: string | null;
  readonly expiry_date: string;
  readonly created_date: string;
};

export enum TokenType {
  Refresh = 'refresh',
  Access = 'access',
}

export type Trigger = {
  readonly id: number;
  name: string;
  command?: TriggerCommand | null;
  message?: TriggerMessage | null;
  webhook?: TriggerWebhook | null;
};

export type TriggerCommand = {
  command: string;
  payload?: string | null;
  description?: string | null;
};

export type TriggerCommandRequest = {
  command: string;
  payload?: string | null;
  description?: string | null;
};

export type TriggerMessage = {
  text?: string | null;
};

export type TriggerMessageRequest = {
  text?: string | null;
};

export type TriggerRequest = {
  name: string;
  command?: TriggerCommandRequest | null;
  message?: TriggerMessageRequest | null;
  webhook?: TriggerWebhookRequest | null;
};

export type TriggerWebhook = {
  readonly url: string;
};

export type TriggerWebhookRequest = {
  [key: string]: any;
};

export type User = {
  readonly id: number;
  readonly telegram_id: number;
  readonly first_name: string;
  readonly last_name: string | null;
  readonly full_name: string;
  readonly subscription: UserSubscription | null;
  readonly accepted_terms: boolean;
  readonly is_staff: boolean;
  readonly joined_date: string;
};

export type UserLoginInitResponse = {
  readonly code_challenge: string;
};

export type UserLoginRequest = {
  code: string;
  redirect_uri: string;
};

export type UserLoginResponse = {
  readonly refresh_token: string;
  readonly access_token: string;
};

export type UserStats = {
  readonly total: number;
};

export type UserStatsResponse = {
  readonly total: number;
};

export type UserSubscription = {
  readonly is_expired: boolean;
  readonly expiry_date: string;
};

export type UserTimelineStatsResponse = {
  readonly date: string;
  readonly count: number;
};

export type UserTokenRefreshRequest = {
  refresh_token: string;
};

export type UserTokenRefreshResponse = {
  readonly access_token: string;
};

export type UsersDeleteUserErrorResponse400 = ParseErrorResponse;

export type UsersGetStatsErrorResponse400 = ParseErrorResponse;

export type UsersGetTokenErrorResponse400 = ParseErrorResponse;

export type UsersGetTokenListError = UsersGetTokenListTypeErrorComponent;

export type UsersGetTokenListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & UsersGetTokenListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type UsersGetTokenListTypeErrorComponent = {
  attr: 'type';
  code: 'invalid_choice';
  detail: string;
};

export type UsersGetTokenListValidationError = {
  type: ValidationErrorType;
  errors: Array<UsersGetTokenListError>;
};

export type UsersGetUserErrorResponse400 = ParseErrorResponse;

export type UsersPostUserAcceptTermsErrorResponse400 = ParseErrorResponse;

export type UsersPostUserLoginCodeErrorComponent = {
  attr: 'code';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type UsersPostUserLoginError =
  | ({
      attr: 'non_field_errors';
    } & UsersPostUserLoginNonFieldErrorsErrorComponent)
  | ({
      attr: 'code';
    } & UsersPostUserLoginCodeErrorComponent)
  | ({
      attr: 'redirect_uri';
    } & UsersPostUserLoginRedirectUriErrorComponent);

export type UsersPostUserLoginErrorResponse400 =
  | ({
      type: 'validation_error';
    } & UsersPostUserLoginValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type UsersPostUserLoginInitErrorResponse400 = ParseErrorResponse;

export type UsersPostUserLoginNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type UsersPostUserLoginRedirectUriErrorComponent = {
  attr: 'redirect_uri';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type UsersPostUserLoginValidationError = {
  type: ValidationErrorType;
  errors: Array<UsersPostUserLoginError>;
};

export type UsersPostUserLogoutAllErrorResponse400 = ParseErrorResponse;

export type UsersPostUserLogoutErrorResponse400 = ParseErrorResponse;

export type UsersPostUserTokenRefreshError =
  | ({
      attr: 'non_field_errors';
    } & UsersPostUserTokenRefreshNonFieldErrorsErrorComponent)
  | ({
      attr: 'refresh_token';
    } & UsersPostUserTokenRefreshRefreshTokenErrorComponent);

export type UsersPostUserTokenRefreshErrorResponse400 =
  | ({
      type: 'validation_error';
    } & UsersPostUserTokenRefreshValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);

export type UsersPostUserTokenRefreshNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid' | 'null';
  detail: string;
};

export type UsersPostUserTokenRefreshRefreshTokenErrorComponent = {
  attr: 'refresh_token';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};

export type UsersPostUserTokenRefreshValidationError = {
  type: ValidationErrorType;
  errors: Array<UsersPostUserTokenRefreshError>;
};

export enum ValidationErrorType {
  ValidationError = 'validation_error',
}

export type Variable = {
  readonly id: number;
  name: string;
  value: string;
  description: string;
};

export type VariableRequest = {
  name: string;
  value: string;
  description: string;
};

export type ApiRequestWritable = {
  name: string;
  url: string;
  method?: ApiRequestMethod;
  headers?: any | null;
  body?: any | null;
};

export type ApiRequestRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  url: string;
  method?: ApiRequestMethod;
  headers?: any | null;
  body?: any | null;
};

export type BackgroundTaskWritable = {
  name: string;
  interval: number;
};

export type BackgroundTaskRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  interval: number;
};

export type ChatWritable = {
  is_allowed?: boolean;
  is_blocked?: boolean;
};

export type ConditionWritable = {
  name: string;
  parts: Array<ConditionPartWritable>;
};

export type ConditionPartWritable = {
  type: ConditionPartType;
  first_value: string;
  operator: ConditionPartOperatorType;
  second_value: string;
  next_part_operator?: ConditionPartNextPartOperator | BlankEnum | NullEnum;
};

export type ConditionRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  parts: Array<ConditionPartRequest>;
};

export type ConnectionWritable = {
  source_object_type: ConnectionSourceObjectType;
  source_object_id: number;
  source_handle_position: ConnectionHandlePosition;
  target_object_type: ConnectionTargetObjectType;
  target_object_id: number;
  target_handle_position: ConnectionHandlePosition;
};

export type DatabaseOperationWritable = {
  name: string;
  create_operation?: DatabaseCreateOperation | null;
  update_operation?: DatabaseUpdateOperation | null;
};

export type DatabaseOperationRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  create_operation?: DatabaseCreateOperationRequest | null;
  update_operation?: DatabaseUpdateOperationRequest | null;
};

export type DatabaseRecordWritable = {
  data: any;
};

export type DiagramApiRequestWritable = {
  x?: number;
  y?: number;
};

export type DiagramBackgroundTaskWritable = {
  x?: number;
  y?: number;
};

export type DiagramConditionWritable = {
  x?: number;
  y?: number;
};

export type DiagramDatabaseOperationWritable = {
  x?: number;
  y?: number;
};

export type DiagramInvoiceWritable = {
  x?: number;
  y?: number;
};

export type DiagramMessageWritable = {
  x?: number;
  y?: number;
};

export type DiagramMessageKeyboardWritable = {
  type?: MessageKeyboardType;
  buttons: Array<DiagramMessageKeyboardButtonWritable>;
};

export type DiagramMessageKeyboardButtonWritable = {
  row: number;
  position: number;
  text: string;
  url?: string | null | string;
  style?: MessageKeyboardButtonStyle;
  source_connections: Array<ConnectionWritable>;
};

export type DiagramRandomizerWritable = {
  x?: number;
  y?: number;
};

export type DiagramTemporaryVariableWritable = {
  x?: number;
  y?: number;
};

export type DiagramTimerWritable = {
  x?: number;
  y?: number;
};

export type DiagramTriggerWritable = {
  x?: number;
  y?: number;
};

export type InvoiceWritable = {
  name: string;
  title: string;
  description: string;
  image?: InvoiceImageWritable | null;
  prices: Array<InvoicePriceWritable>;
};

export type InvoiceImageWritable = {
  from_url?: string | null | string;
};

export type InvoiceImageRequestWritable = {
  file?: Blob | File | null;
  from_url?: string | null | string;
};

export type InvoicePriceWritable = {
  label: string;
  amount: number;
};

export type InvoiceRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  title: string;
  description: string;
  image?: InvoiceImageRequestWritable | null;
  prices: Array<InvoicePriceRequest>;
};

export type MessageWritable = {
  name: string;
  text?: string | null;
  settings: MessageSettings;
  images?: Array<MessageImageWritable> | null;
  documents?: Array<MessageDocumentWritable> | null;
  keyboard?: MessageKeyboard | null;
};

export type MessageDocumentWritable = {
  from_url?: string | null | string;
  id?: number;
  position: number;
};

export type MessageDocumentRequestWritable = {
  file?: Blob | File | null;
  from_url?: string | null | string;
  id?: number;
  position: number;
};

export type MessageImageWritable = {
  from_url?: string | null | string;
  id?: number;
  position: number;
};

export type MessageImageRequestWritable = {
  file?: Blob | File | null;
  from_url?: string | null | string;
  id?: number;
  position: number;
};

export type MessageRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  text?: string | null;
  settings: MessageSettingsRequest;
  images?: Array<MessageImageRequestWritable> | null;
  documents?: Array<MessageDocumentRequestWritable> | null;
  keyboard?: MessageKeyboardRequest | null;
};

export type PaginatedChatListWritable = {
  count: number;
  limit: number;
  offset: number;
  results: Array<ChatWritable>;
};

export type PaginatedDatabaseRecordListWritable = {
  count: number;
  limit: number;
  offset: number;
  results: Array<DatabaseRecordWritable>;
};

export type PaginatedSubscriptionInvoiceListWritable = {
  count: number;
  limit: number;
  offset: number;
  results: Array<any>;
};

export type PaginatedTelegramBotUserListWritable = {
  count: number;
  limit: number;
  offset: number;
  results: Array<TelegramBotUserWritable>;
};

export type PaginatedTemporaryVariableListWritable = {
  count: number;
  limit: number;
  offset: number;
  results: Array<TemporaryVariableWritable>;
};

export type PaginatedVariableListWritable = {
  count: number;
  limit: number;
  offset: number;
  results: Array<VariableWritable>;
};

export type PatchedApiRequestRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  url?: string;
  method?: ApiRequestMethod;
  headers?: any | null;
  body?: any | null;
};

export type PatchedBackgroundTaskRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  interval?: number;
};

export type PatchedConditionRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  parts?: Array<ConditionPartRequest>;
};

export type PatchedDatabaseOperationRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  create_operation?: DatabaseCreateOperationRequest | null;
  update_operation?: DatabaseUpdateOperationRequest | null;
};

export type PatchedInvoiceRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  title?: string;
  description?: string;
  image?: InvoiceImageRequestWritable | null;
  prices?: Array<InvoicePriceRequest>;
};

export type PatchedMessageRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  text?: string | null;
  settings?: MessageSettingsRequest;
  images?: Array<MessageImageRequestWritable> | null;
  documents?: Array<MessageDocumentRequestWritable> | null;
  keyboard?: MessageKeyboardRequest | null;
};

export type PatchedRandomizerRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
};

export type PatchedTemporaryVariableRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  value?: string;
};

export type PatchedTimerRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  duration_seconds?: number;
};

export type PatchedTriggerRequestWritable = {
  name?: string;
  x?: number;
  y?: number;
  command?: TriggerCommandRequest | null;
  message?: TriggerMessageRequest | null;
  webhook?: TriggerWebhookRequest | null;
};

export type RandomizerWritable = {
  name: string;
};

export type RandomizerRequestWritable = {
  name: string;
  x?: number;
  y?: number;
};

export type TelegramBotWritable = {
  api_token: string;
  is_private?: boolean;
};

export type TelegramBotStatsResponseWritable = {
  [key: string]: any;
};

export type TelegramBotUserWritable = {
  is_allowed?: boolean;
  is_blocked?: boolean;
};

export type TelegramBotsGetUserListErrorWritable = any;

export type TemporaryVariableWritable = {
  name: string;
  value: string;
};

export type TemporaryVariableRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  value: string;
};

export type TimerWritable = {
  name: string;
  duration_seconds: number;
};

export type TimerRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  duration_seconds: number;
};

export type TriggerWritable = {
  name: string;
  command?: TriggerCommand | null;
  message?: TriggerMessage | null;
  webhook?: null;
};

export type TriggerRequestWritable = {
  name: string;
  x?: number;
  y?: number;
  command?: TriggerCommandRequest | null;
  message?: TriggerMessageRequest | null;
  webhook?: TriggerWebhookRequest | null;
};

export type VariableWritable = {
  name: string;
  value: string;
  description: string;
};

export type InstructionGetSectionListData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/instruction/sections/';
};

export type InstructionGetSectionListErrors = {
  400: InstructionGetSectionListErrorResponse400;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type InstructionGetSectionListError =
  InstructionGetSectionListErrors[keyof InstructionGetSectionListErrors];

export type InstructionGetSectionListResponses = {
  200: Array<Section>;
};

export type InstructionGetSectionListResponse =
  InstructionGetSectionListResponses[keyof InstructionGetSectionListResponses];

export type LegalGetDocumentData = {
  body?: never;
  path: {
    type: 'privacy-policy' | 'terms-of-service';
  };
  query?: never;
  url: '/api/legal/documents/{type}/';
};

export type LegalGetDocumentErrors = {
  400: LegalGetDocumentErrorResponse400;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type LegalGetDocumentError =
  LegalGetDocumentErrors[keyof LegalGetDocumentErrors];

export type LegalGetDocumentResponses = {
  200: Document;
};

export type LegalGetDocumentResponse =
  LegalGetDocumentResponses[keyof LegalGetDocumentResponses];

export type PremiumGetSubscriptionInvoiceListData = {
  body?: never;
  path?: never;
  query?: {
    limit?: number;
    offset?: number;
    statuses?: Array<'expired' | 'failed' | 'paid' | 'pending' | 'refunded'>;
  };
  url: '/api/premium/subscription-invoices/';
};

export type PremiumGetSubscriptionInvoiceListErrors = {
  400: PremiumGetSubscriptionInvoiceListErrorResponse400;
  401: ErrorResponse401;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type PremiumGetSubscriptionInvoiceListError2 =
  PremiumGetSubscriptionInvoiceListErrors[keyof PremiumGetSubscriptionInvoiceListErrors];

export type PremiumGetSubscriptionInvoiceListResponses = {
  200: PaginatedSubscriptionInvoiceList;
};

export type PremiumGetSubscriptionInvoiceListResponse =
  PremiumGetSubscriptionInvoiceListResponses[keyof PremiumGetSubscriptionInvoiceListResponses];

export type PremiumGetSubscriptionInvoiceData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/premium/subscription-invoices/{id}/';
};

export type PremiumGetSubscriptionInvoiceErrors = {
  400: PremiumGetSubscriptionInvoiceErrorResponse400;
  401: ErrorResponse401;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type PremiumGetSubscriptionInvoiceError =
  PremiumGetSubscriptionInvoiceErrors[keyof PremiumGetSubscriptionInvoiceErrors];

export type PremiumGetSubscriptionInvoiceResponses = {
  200: SubscriptionInvoice;
};

export type PremiumGetSubscriptionInvoiceResponse =
  PremiumGetSubscriptionInvoiceResponses[keyof PremiumGetSubscriptionInvoiceResponses];

export type PremiumGetSubscriptionPriceListData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/premium/subscription-prices/';
};

export type PremiumGetSubscriptionPriceListErrors = {
  400: PremiumGetSubscriptionPriceListErrorResponse400;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type PremiumGetSubscriptionPriceListError =
  PremiumGetSubscriptionPriceListErrors[keyof PremiumGetSubscriptionPriceListErrors];

export type PremiumGetSubscriptionPriceListResponses = {
  200: Array<SubscriptionPrice>;
};

export type PremiumGetSubscriptionPriceListResponse =
  PremiumGetSubscriptionPriceListResponses[keyof PremiumGetSubscriptionPriceListResponses];

export type PremiumGetSubscriptionPriceData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/premium/subscription-prices/{id}/';
};

export type PremiumGetSubscriptionPriceErrors = {
  400: PremiumGetSubscriptionPriceErrorResponse400;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type PremiumGetSubscriptionPriceError =
  PremiumGetSubscriptionPriceErrors[keyof PremiumGetSubscriptionPriceErrors];

export type PremiumGetSubscriptionPriceResponses = {
  200: SubscriptionPrice;
};

export type PremiumGetSubscriptionPriceResponse =
  PremiumGetSubscriptionPriceResponses[keyof PremiumGetSubscriptionPriceResponses];

export type PremiumGetSubscriptionPriceCheckoutData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/premium/subscription-prices/{id}/checkout/';
};

export type PremiumGetSubscriptionPriceCheckoutErrors = {
  400: PremiumGetSubscriptionPriceCheckoutErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type PremiumGetSubscriptionPriceCheckoutError =
  PremiumGetSubscriptionPriceCheckoutErrors[keyof PremiumGetSubscriptionPriceCheckoutErrors];

export type PremiumGetSubscriptionPriceCheckoutResponses = {
  200: SubscriptionPriceCheckoutResponse;
};

export type PremiumGetSubscriptionPriceCheckoutResponse =
  PremiumGetSubscriptionPriceCheckoutResponses[keyof PremiumGetSubscriptionPriceCheckoutResponses];

export type TelegramBotsGetTelegramBotListData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/telegram-bots/';
};

export type TelegramBotsGetTelegramBotListErrors = {
  400: TelegramBotsGetTelegramBotListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetTelegramBotListError =
  TelegramBotsGetTelegramBotListErrors[keyof TelegramBotsGetTelegramBotListErrors];

export type TelegramBotsGetTelegramBotListResponses = {
  200: Array<TelegramBot>;
};

export type TelegramBotsGetTelegramBotListResponse =
  TelegramBotsGetTelegramBotListResponses[keyof TelegramBotsGetTelegramBotListResponses];

export type TelegramBotsCreateTelegramBotData = {
  body: TelegramBotRequest;
  path?: never;
  query?: never;
  url: '/api/telegram-bots/';
};

export type TelegramBotsCreateTelegramBotErrors = {
  400: TelegramBotsCreateTelegramBotErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateTelegramBotError2 =
  TelegramBotsCreateTelegramBotErrors[keyof TelegramBotsCreateTelegramBotErrors];

export type TelegramBotsCreateTelegramBotResponses = {
  201: TelegramBot;
};

export type TelegramBotsCreateTelegramBotResponse =
  TelegramBotsCreateTelegramBotResponses[keyof TelegramBotsCreateTelegramBotResponses];

export type TelegramBotsDeleteTelegramBotData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/telegram-bots/{id}/';
};

export type TelegramBotsDeleteTelegramBotErrors = {
  400: TelegramBotsDeleteTelegramBotErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteTelegramBotError =
  TelegramBotsDeleteTelegramBotErrors[keyof TelegramBotsDeleteTelegramBotErrors];

export type TelegramBotsDeleteTelegramBotResponses = {
  204: void;
};

export type TelegramBotsDeleteTelegramBotResponse =
  TelegramBotsDeleteTelegramBotResponses[keyof TelegramBotsDeleteTelegramBotResponses];

export type TelegramBotsGetTelegramBotData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/telegram-bots/{id}/';
};

export type TelegramBotsGetTelegramBotErrors = {
  400: TelegramBotsGetTelegramBotErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetTelegramBotError =
  TelegramBotsGetTelegramBotErrors[keyof TelegramBotsGetTelegramBotErrors];

export type TelegramBotsGetTelegramBotResponses = {
  200: TelegramBot;
};

export type TelegramBotsGetTelegramBotResponse =
  TelegramBotsGetTelegramBotResponses[keyof TelegramBotsGetTelegramBotResponses];

export type TelegramBotsPartialUpdateTelegramBotData = {
  body?: PatchedTelegramBotRequest;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/telegram-bots/{id}/';
};

export type TelegramBotsPartialUpdateTelegramBotErrors = {
  400: TelegramBotsPartialUpdateTelegramBotErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateTelegramBotError2 =
  TelegramBotsPartialUpdateTelegramBotErrors[keyof TelegramBotsPartialUpdateTelegramBotErrors];

export type TelegramBotsPartialUpdateTelegramBotResponses = {
  200: TelegramBot;
};

export type TelegramBotsPartialUpdateTelegramBotResponse =
  TelegramBotsPartialUpdateTelegramBotResponses[keyof TelegramBotsPartialUpdateTelegramBotResponses];

export type TelegramBotsUpdateTelegramBotData = {
  body: TelegramBotRequest;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/telegram-bots/{id}/';
};

export type TelegramBotsUpdateTelegramBotErrors = {
  400: TelegramBotsUpdateTelegramBotErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateTelegramBotError2 =
  TelegramBotsUpdateTelegramBotErrors[keyof TelegramBotsUpdateTelegramBotErrors];

export type TelegramBotsUpdateTelegramBotResponses = {
  200: TelegramBot;
};

export type TelegramBotsUpdateTelegramBotResponse =
  TelegramBotsUpdateTelegramBotResponses[keyof TelegramBotsUpdateTelegramBotResponses];

export type TelegramBotsPostTelegramBotRestartData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/telegram-bots/{id}/restart/';
};

export type TelegramBotsPostTelegramBotRestartErrors = {
  400: TelegramBotsPostTelegramBotRestartErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPostTelegramBotRestartError =
  TelegramBotsPostTelegramBotRestartErrors[keyof TelegramBotsPostTelegramBotRestartErrors];

export type TelegramBotsPostTelegramBotRestartResponses = {
  200: TelegramBot;
};

export type TelegramBotsPostTelegramBotRestartResponse =
  TelegramBotsPostTelegramBotRestartResponses[keyof TelegramBotsPostTelegramBotRestartResponses];

export type TelegramBotsPostTelegramBotStartData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/telegram-bots/{id}/start/';
};

export type TelegramBotsPostTelegramBotStartErrors = {
  400: TelegramBotsPostTelegramBotStartErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPostTelegramBotStartError =
  TelegramBotsPostTelegramBotStartErrors[keyof TelegramBotsPostTelegramBotStartErrors];

export type TelegramBotsPostTelegramBotStartResponses = {
  200: TelegramBot;
};

export type TelegramBotsPostTelegramBotStartResponse =
  TelegramBotsPostTelegramBotStartResponses[keyof TelegramBotsPostTelegramBotStartResponses];

export type TelegramBotsPostTelegramBotStopData = {
  body?: never;
  path: {
    id: number;
  };
  query?: never;
  url: '/api/telegram-bots/{id}/stop/';
};

export type TelegramBotsPostTelegramBotStopErrors = {
  400: TelegramBotsPostTelegramBotStopErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPostTelegramBotStopError =
  TelegramBotsPostTelegramBotStopErrors[keyof TelegramBotsPostTelegramBotStopErrors];

export type TelegramBotsPostTelegramBotStopResponses = {
  200: TelegramBot;
};

export type TelegramBotsPostTelegramBotStopResponse =
  TelegramBotsPostTelegramBotStopResponses[keyof TelegramBotsPostTelegramBotStopResponses];

export type TelegramBotsGetApiRequestListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/api-requests/';
};

export type TelegramBotsGetApiRequestListErrors = {
  400: TelegramBotsGetApiRequestListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetApiRequestListError =
  TelegramBotsGetApiRequestListErrors[keyof TelegramBotsGetApiRequestListErrors];

export type TelegramBotsGetApiRequestListResponses = {
  200: Array<ApiRequest>;
};

export type TelegramBotsGetApiRequestListResponse =
  TelegramBotsGetApiRequestListResponses[keyof TelegramBotsGetApiRequestListResponses];

export type TelegramBotsCreateApiRequestData = {
  body: ApiRequestRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/api-requests/';
};

export type TelegramBotsCreateApiRequestErrors = {
  400: TelegramBotsCreateApiRequestErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateApiRequestError2 =
  TelegramBotsCreateApiRequestErrors[keyof TelegramBotsCreateApiRequestErrors];

export type TelegramBotsCreateApiRequestResponses = {
  201: ApiRequest;
};

export type TelegramBotsCreateApiRequestResponse =
  TelegramBotsCreateApiRequestResponses[keyof TelegramBotsCreateApiRequestResponses];

export type TelegramBotsDeleteApiRequestData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/api-requests/{id}/';
};

export type TelegramBotsDeleteApiRequestErrors = {
  400: TelegramBotsDeleteApiRequestErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteApiRequestError =
  TelegramBotsDeleteApiRequestErrors[keyof TelegramBotsDeleteApiRequestErrors];

export type TelegramBotsDeleteApiRequestResponses = {
  204: void;
};

export type TelegramBotsDeleteApiRequestResponse =
  TelegramBotsDeleteApiRequestResponses[keyof TelegramBotsDeleteApiRequestResponses];

export type TelegramBotsGetApiRequestData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/api-requests/{id}/';
};

export type TelegramBotsGetApiRequestErrors = {
  400: TelegramBotsGetApiRequestErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetApiRequestError =
  TelegramBotsGetApiRequestErrors[keyof TelegramBotsGetApiRequestErrors];

export type TelegramBotsGetApiRequestResponses = {
  200: ApiRequest;
};

export type TelegramBotsGetApiRequestResponse =
  TelegramBotsGetApiRequestResponses[keyof TelegramBotsGetApiRequestResponses];

export type TelegramBotsPartialUpdateApiRequestData = {
  body?: PatchedApiRequestRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/api-requests/{id}/';
};

export type TelegramBotsPartialUpdateApiRequestErrors = {
  400: TelegramBotsPartialUpdateApiRequestErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateApiRequestError2 =
  TelegramBotsPartialUpdateApiRequestErrors[keyof TelegramBotsPartialUpdateApiRequestErrors];

export type TelegramBotsPartialUpdateApiRequestResponses = {
  200: ApiRequest;
};

export type TelegramBotsPartialUpdateApiRequestResponse =
  TelegramBotsPartialUpdateApiRequestResponses[keyof TelegramBotsPartialUpdateApiRequestResponses];

export type TelegramBotsUpdateApiRequestData = {
  body: ApiRequestRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/api-requests/{id}/';
};

export type TelegramBotsUpdateApiRequestErrors = {
  400: TelegramBotsUpdateApiRequestErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateApiRequestError2 =
  TelegramBotsUpdateApiRequestErrors[keyof TelegramBotsUpdateApiRequestErrors];

export type TelegramBotsUpdateApiRequestResponses = {
  200: ApiRequest;
};

export type TelegramBotsUpdateApiRequestResponse =
  TelegramBotsUpdateApiRequestResponses[keyof TelegramBotsUpdateApiRequestResponses];

export type TelegramBotsGetBackgroundTaskListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/background-tasks/';
};

export type TelegramBotsGetBackgroundTaskListErrors = {
  400: TelegramBotsGetBackgroundTaskListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetBackgroundTaskListError =
  TelegramBotsGetBackgroundTaskListErrors[keyof TelegramBotsGetBackgroundTaskListErrors];

export type TelegramBotsGetBackgroundTaskListResponses = {
  200: Array<BackgroundTask>;
};

export type TelegramBotsGetBackgroundTaskListResponse =
  TelegramBotsGetBackgroundTaskListResponses[keyof TelegramBotsGetBackgroundTaskListResponses];

export type TelegramBotsCreateBackgroundTaskData = {
  body: BackgroundTaskRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/background-tasks/';
};

export type TelegramBotsCreateBackgroundTaskErrors = {
  400: TelegramBotsCreateBackgroundTaskErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateBackgroundTaskError2 =
  TelegramBotsCreateBackgroundTaskErrors[keyof TelegramBotsCreateBackgroundTaskErrors];

export type TelegramBotsCreateBackgroundTaskResponses = {
  201: BackgroundTask;
};

export type TelegramBotsCreateBackgroundTaskResponse =
  TelegramBotsCreateBackgroundTaskResponses[keyof TelegramBotsCreateBackgroundTaskResponses];

export type TelegramBotsDeleteBackgroundTaskData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/background-tasks/{id}/';
};

export type TelegramBotsDeleteBackgroundTaskErrors = {
  400: TelegramBotsDeleteBackgroundTaskErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteBackgroundTaskError =
  TelegramBotsDeleteBackgroundTaskErrors[keyof TelegramBotsDeleteBackgroundTaskErrors];

export type TelegramBotsDeleteBackgroundTaskResponses = {
  204: void;
};

export type TelegramBotsDeleteBackgroundTaskResponse =
  TelegramBotsDeleteBackgroundTaskResponses[keyof TelegramBotsDeleteBackgroundTaskResponses];

export type TelegramBotsGetBackgroundTaskData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/background-tasks/{id}/';
};

export type TelegramBotsGetBackgroundTaskErrors = {
  400: TelegramBotsGetBackgroundTaskErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetBackgroundTaskError =
  TelegramBotsGetBackgroundTaskErrors[keyof TelegramBotsGetBackgroundTaskErrors];

export type TelegramBotsGetBackgroundTaskResponses = {
  200: BackgroundTask;
};

export type TelegramBotsGetBackgroundTaskResponse =
  TelegramBotsGetBackgroundTaskResponses[keyof TelegramBotsGetBackgroundTaskResponses];

export type TelegramBotsPartialUpdateBackgroundTaskData = {
  body?: PatchedBackgroundTaskRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/background-tasks/{id}/';
};

export type TelegramBotsPartialUpdateBackgroundTaskErrors = {
  400: TelegramBotsPartialUpdateBackgroundTaskErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateBackgroundTaskError2 =
  TelegramBotsPartialUpdateBackgroundTaskErrors[keyof TelegramBotsPartialUpdateBackgroundTaskErrors];

export type TelegramBotsPartialUpdateBackgroundTaskResponses = {
  200: BackgroundTask;
};

export type TelegramBotsPartialUpdateBackgroundTaskResponse =
  TelegramBotsPartialUpdateBackgroundTaskResponses[keyof TelegramBotsPartialUpdateBackgroundTaskResponses];

export type TelegramBotsUpdateBackgroundTaskData = {
  body: BackgroundTaskRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/background-tasks/{id}/';
};

export type TelegramBotsUpdateBackgroundTaskErrors = {
  400: TelegramBotsUpdateBackgroundTaskErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateBackgroundTaskError2 =
  TelegramBotsUpdateBackgroundTaskErrors[keyof TelegramBotsUpdateBackgroundTaskErrors];

export type TelegramBotsUpdateBackgroundTaskResponses = {
  200: BackgroundTask;
};

export type TelegramBotsUpdateBackgroundTaskResponse =
  TelegramBotsUpdateBackgroundTaskResponses[keyof TelegramBotsUpdateBackgroundTaskResponses];

export type TelegramBotsGetChatListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: {
    is_allowed?: boolean;
    is_blocked?: boolean;
    limit?: number;
    offset?: number;
    ordering?: string;
    search?: string;
    type?: 'channel' | 'group' | 'private' | 'supergroup';
  };
  url: '/api/telegram-bots/{telegramBotId}/chats/';
};

export type TelegramBotsGetChatListErrors = {
  400: TelegramBotsGetChatListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetChatListError2 =
  TelegramBotsGetChatListErrors[keyof TelegramBotsGetChatListErrors];

export type TelegramBotsGetChatListResponses = {
  200: PaginatedChatList;
};

export type TelegramBotsGetChatListResponse =
  TelegramBotsGetChatListResponses[keyof TelegramBotsGetChatListResponses];

export type TelegramBotsDeleteChatData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/chats/{id}/';
};

export type TelegramBotsDeleteChatErrors = {
  400: TelegramBotsDeleteChatErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteChatError =
  TelegramBotsDeleteChatErrors[keyof TelegramBotsDeleteChatErrors];

export type TelegramBotsDeleteChatResponses = {
  204: void;
};

export type TelegramBotsDeleteChatResponse =
  TelegramBotsDeleteChatResponses[keyof TelegramBotsDeleteChatResponses];

export type TelegramBotsGetChatData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/chats/{id}/';
};

export type TelegramBotsGetChatErrors = {
  400: TelegramBotsGetChatErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetChatError =
  TelegramBotsGetChatErrors[keyof TelegramBotsGetChatErrors];

export type TelegramBotsGetChatResponses = {
  200: Chat;
};

export type TelegramBotsGetChatResponse =
  TelegramBotsGetChatResponses[keyof TelegramBotsGetChatResponses];

export type TelegramBotsPartialUpdateChatData = {
  body?: PatchedChatRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/chats/{id}/';
};

export type TelegramBotsPartialUpdateChatErrors = {
  400: TelegramBotsPartialUpdateChatErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateChatError2 =
  TelegramBotsPartialUpdateChatErrors[keyof TelegramBotsPartialUpdateChatErrors];

export type TelegramBotsPartialUpdateChatResponses = {
  200: Chat;
};

export type TelegramBotsPartialUpdateChatResponse =
  TelegramBotsPartialUpdateChatResponses[keyof TelegramBotsPartialUpdateChatResponses];

export type TelegramBotsUpdateChatData = {
  body?: ChatRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/chats/{id}/';
};

export type TelegramBotsUpdateChatErrors = {
  400: TelegramBotsUpdateChatErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateChatError2 =
  TelegramBotsUpdateChatErrors[keyof TelegramBotsUpdateChatErrors];

export type TelegramBotsUpdateChatResponses = {
  200: Chat;
};

export type TelegramBotsUpdateChatResponse =
  TelegramBotsUpdateChatResponses[keyof TelegramBotsUpdateChatResponses];

export type TelegramBotsGetConditionListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/conditions/';
};

export type TelegramBotsGetConditionListErrors = {
  400: TelegramBotsGetConditionListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetConditionListError =
  TelegramBotsGetConditionListErrors[keyof TelegramBotsGetConditionListErrors];

export type TelegramBotsGetConditionListResponses = {
  200: Array<Condition>;
};

export type TelegramBotsGetConditionListResponse =
  TelegramBotsGetConditionListResponses[keyof TelegramBotsGetConditionListResponses];

export type TelegramBotsCreateConditionData = {
  body: ConditionRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/conditions/';
};

export type TelegramBotsCreateConditionErrors = {
  400: TelegramBotsCreateConditionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateConditionError2 =
  TelegramBotsCreateConditionErrors[keyof TelegramBotsCreateConditionErrors];

export type TelegramBotsCreateConditionResponses = {
  201: Condition;
};

export type TelegramBotsCreateConditionResponse =
  TelegramBotsCreateConditionResponses[keyof TelegramBotsCreateConditionResponses];

export type TelegramBotsDeleteConditionData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/conditions/{id}/';
};

export type TelegramBotsDeleteConditionErrors = {
  400: TelegramBotsDeleteConditionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteConditionError =
  TelegramBotsDeleteConditionErrors[keyof TelegramBotsDeleteConditionErrors];

export type TelegramBotsDeleteConditionResponses = {
  204: void;
};

export type TelegramBotsDeleteConditionResponse =
  TelegramBotsDeleteConditionResponses[keyof TelegramBotsDeleteConditionResponses];

export type TelegramBotsGetConditionData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/conditions/{id}/';
};

export type TelegramBotsGetConditionErrors = {
  400: TelegramBotsGetConditionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetConditionError =
  TelegramBotsGetConditionErrors[keyof TelegramBotsGetConditionErrors];

export type TelegramBotsGetConditionResponses = {
  200: Condition;
};

export type TelegramBotsGetConditionResponse =
  TelegramBotsGetConditionResponses[keyof TelegramBotsGetConditionResponses];

export type TelegramBotsPartialUpdateConditionData = {
  body?: PatchedConditionRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/conditions/{id}/';
};

export type TelegramBotsPartialUpdateConditionErrors = {
  400: TelegramBotsPartialUpdateConditionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateConditionError2 =
  TelegramBotsPartialUpdateConditionErrors[keyof TelegramBotsPartialUpdateConditionErrors];

export type TelegramBotsPartialUpdateConditionResponses = {
  200: Condition;
};

export type TelegramBotsPartialUpdateConditionResponse =
  TelegramBotsPartialUpdateConditionResponses[keyof TelegramBotsPartialUpdateConditionResponses];

export type TelegramBotsUpdateConditionData = {
  body: ConditionRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/conditions/{id}/';
};

export type TelegramBotsUpdateConditionErrors = {
  400: TelegramBotsUpdateConditionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateConditionError2 =
  TelegramBotsUpdateConditionErrors[keyof TelegramBotsUpdateConditionErrors];

export type TelegramBotsUpdateConditionResponses = {
  200: Condition;
};

export type TelegramBotsUpdateConditionResponse =
  TelegramBotsUpdateConditionResponses[keyof TelegramBotsUpdateConditionResponses];

export type TelegramBotsCreateConnectionData = {
  body: ConnectionRequest;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/connections/';
};

export type TelegramBotsCreateConnectionErrors = {
  400: TelegramBotsCreateConnectionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateConnectionError2 =
  TelegramBotsCreateConnectionErrors[keyof TelegramBotsCreateConnectionErrors];

export type TelegramBotsCreateConnectionResponses = {
  201: Connection;
};

export type TelegramBotsCreateConnectionResponse =
  TelegramBotsCreateConnectionResponses[keyof TelegramBotsCreateConnectionResponses];

export type TelegramBotsDeleteConnectionData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/connections/{id}/';
};

export type TelegramBotsDeleteConnectionErrors = {
  400: TelegramBotsDeleteConnectionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteConnectionError =
  TelegramBotsDeleteConnectionErrors[keyof TelegramBotsDeleteConnectionErrors];

export type TelegramBotsDeleteConnectionResponses = {
  204: void;
};

export type TelegramBotsDeleteConnectionResponse =
  TelegramBotsDeleteConnectionResponses[keyof TelegramBotsDeleteConnectionResponses];

export type TelegramBotsGetDatabaseOperationListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-operations/';
};

export type TelegramBotsGetDatabaseOperationListErrors = {
  400: TelegramBotsGetDatabaseOperationListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDatabaseOperationListError =
  TelegramBotsGetDatabaseOperationListErrors[keyof TelegramBotsGetDatabaseOperationListErrors];

export type TelegramBotsGetDatabaseOperationListResponses = {
  200: Array<DatabaseOperation>;
};

export type TelegramBotsGetDatabaseOperationListResponse =
  TelegramBotsGetDatabaseOperationListResponses[keyof TelegramBotsGetDatabaseOperationListResponses];

export type TelegramBotsCreateDatabaseOperationData = {
  body: DatabaseOperationRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-operations/';
};

export type TelegramBotsCreateDatabaseOperationErrors = {
  400: TelegramBotsCreateDatabaseOperationErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateDatabaseOperationError2 =
  TelegramBotsCreateDatabaseOperationErrors[keyof TelegramBotsCreateDatabaseOperationErrors];

export type TelegramBotsCreateDatabaseOperationResponses = {
  201: DatabaseOperation;
};

export type TelegramBotsCreateDatabaseOperationResponse =
  TelegramBotsCreateDatabaseOperationResponses[keyof TelegramBotsCreateDatabaseOperationResponses];

export type TelegramBotsDeleteDatabaseOperationData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-operations/{id}/';
};

export type TelegramBotsDeleteDatabaseOperationErrors = {
  400: TelegramBotsDeleteDatabaseOperationErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteDatabaseOperationError =
  TelegramBotsDeleteDatabaseOperationErrors[keyof TelegramBotsDeleteDatabaseOperationErrors];

export type TelegramBotsDeleteDatabaseOperationResponses = {
  204: void;
};

export type TelegramBotsDeleteDatabaseOperationResponse =
  TelegramBotsDeleteDatabaseOperationResponses[keyof TelegramBotsDeleteDatabaseOperationResponses];

export type TelegramBotsGetDatabaseOperationData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-operations/{id}/';
};

export type TelegramBotsGetDatabaseOperationErrors = {
  400: TelegramBotsGetDatabaseOperationErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDatabaseOperationError =
  TelegramBotsGetDatabaseOperationErrors[keyof TelegramBotsGetDatabaseOperationErrors];

export type TelegramBotsGetDatabaseOperationResponses = {
  200: DatabaseOperation;
};

export type TelegramBotsGetDatabaseOperationResponse =
  TelegramBotsGetDatabaseOperationResponses[keyof TelegramBotsGetDatabaseOperationResponses];

export type TelegramBotsPartialUpdateDatabaseOperationData = {
  body?: PatchedDatabaseOperationRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-operations/{id}/';
};

export type TelegramBotsPartialUpdateDatabaseOperationErrors = {
  400: TelegramBotsPartialUpdateDatabaseOperationErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDatabaseOperationError2 =
  TelegramBotsPartialUpdateDatabaseOperationErrors[keyof TelegramBotsPartialUpdateDatabaseOperationErrors];

export type TelegramBotsPartialUpdateDatabaseOperationResponses = {
  200: DatabaseOperation;
};

export type TelegramBotsPartialUpdateDatabaseOperationResponse =
  TelegramBotsPartialUpdateDatabaseOperationResponses[keyof TelegramBotsPartialUpdateDatabaseOperationResponses];

export type TelegramBotsUpdateDatabaseOperationData = {
  body: DatabaseOperationRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-operations/{id}/';
};

export type TelegramBotsUpdateDatabaseOperationErrors = {
  400: TelegramBotsUpdateDatabaseOperationErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDatabaseOperationError2 =
  TelegramBotsUpdateDatabaseOperationErrors[keyof TelegramBotsUpdateDatabaseOperationErrors];

export type TelegramBotsUpdateDatabaseOperationResponses = {
  200: DatabaseOperation;
};

export type TelegramBotsUpdateDatabaseOperationResponse =
  TelegramBotsUpdateDatabaseOperationResponses[keyof TelegramBotsUpdateDatabaseOperationResponses];

export type TelegramBotsGetDatabaseRecordListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: {
    limit?: number;
    offset?: number;
    ordering?: string;
    search?: string;
  };
  url: '/api/telegram-bots/{telegramBotId}/database-records/';
};

export type TelegramBotsGetDatabaseRecordListErrors = {
  400: TelegramBotsGetDatabaseRecordListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDatabaseRecordListError =
  TelegramBotsGetDatabaseRecordListErrors[keyof TelegramBotsGetDatabaseRecordListErrors];

export type TelegramBotsGetDatabaseRecordListResponses = {
  200: PaginatedDatabaseRecordList;
};

export type TelegramBotsGetDatabaseRecordListResponse =
  TelegramBotsGetDatabaseRecordListResponses[keyof TelegramBotsGetDatabaseRecordListResponses];

export type TelegramBotsCreateDatabaseRecordData = {
  body: DatabaseRecordRequest;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-records/';
};

export type TelegramBotsCreateDatabaseRecordErrors = {
  400: TelegramBotsCreateDatabaseRecordErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateDatabaseRecordError2 =
  TelegramBotsCreateDatabaseRecordErrors[keyof TelegramBotsCreateDatabaseRecordErrors];

export type TelegramBotsCreateDatabaseRecordResponses = {
  201: DatabaseRecord;
};

export type TelegramBotsCreateDatabaseRecordResponse =
  TelegramBotsCreateDatabaseRecordResponses[keyof TelegramBotsCreateDatabaseRecordResponses];

export type TelegramBotsDeleteDatabaseRecordData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-records/{id}/';
};

export type TelegramBotsDeleteDatabaseRecordErrors = {
  400: TelegramBotsDeleteDatabaseRecordErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteDatabaseRecordError =
  TelegramBotsDeleteDatabaseRecordErrors[keyof TelegramBotsDeleteDatabaseRecordErrors];

export type TelegramBotsDeleteDatabaseRecordResponses = {
  204: void;
};

export type TelegramBotsDeleteDatabaseRecordResponse =
  TelegramBotsDeleteDatabaseRecordResponses[keyof TelegramBotsDeleteDatabaseRecordResponses];

export type TelegramBotsGetDatabaseRecordData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-records/{id}/';
};

export type TelegramBotsGetDatabaseRecordErrors = {
  400: TelegramBotsGetDatabaseRecordErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDatabaseRecordError =
  TelegramBotsGetDatabaseRecordErrors[keyof TelegramBotsGetDatabaseRecordErrors];

export type TelegramBotsGetDatabaseRecordResponses = {
  200: DatabaseRecord;
};

export type TelegramBotsGetDatabaseRecordResponse =
  TelegramBotsGetDatabaseRecordResponses[keyof TelegramBotsGetDatabaseRecordResponses];

export type TelegramBotsPartialUpdateDatabaseRecordData = {
  body?: PatchedDatabaseRecordRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-records/{id}/';
};

export type TelegramBotsPartialUpdateDatabaseRecordErrors = {
  400: TelegramBotsPartialUpdateDatabaseRecordErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDatabaseRecordError2 =
  TelegramBotsPartialUpdateDatabaseRecordErrors[keyof TelegramBotsPartialUpdateDatabaseRecordErrors];

export type TelegramBotsPartialUpdateDatabaseRecordResponses = {
  200: DatabaseRecord;
};

export type TelegramBotsPartialUpdateDatabaseRecordResponse =
  TelegramBotsPartialUpdateDatabaseRecordResponses[keyof TelegramBotsPartialUpdateDatabaseRecordResponses];

export type TelegramBotsUpdateDatabaseRecordData = {
  body: DatabaseRecordRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/database-records/{id}/';
};

export type TelegramBotsUpdateDatabaseRecordErrors = {
  400: TelegramBotsUpdateDatabaseRecordErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDatabaseRecordError2 =
  TelegramBotsUpdateDatabaseRecordErrors[keyof TelegramBotsUpdateDatabaseRecordErrors];

export type TelegramBotsUpdateDatabaseRecordResponses = {
  200: DatabaseRecord;
};

export type TelegramBotsUpdateDatabaseRecordResponse =
  TelegramBotsUpdateDatabaseRecordResponses[keyof TelegramBotsUpdateDatabaseRecordResponses];

export type TelegramBotsGetDiagramApiRequestListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/api-requests/';
};

export type TelegramBotsGetDiagramApiRequestListErrors = {
  400: TelegramBotsGetDiagramApiRequestListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramApiRequestListError =
  TelegramBotsGetDiagramApiRequestListErrors[keyof TelegramBotsGetDiagramApiRequestListErrors];

export type TelegramBotsGetDiagramApiRequestListResponses = {
  200: Array<DiagramApiRequest>;
};

export type TelegramBotsGetDiagramApiRequestListResponse =
  TelegramBotsGetDiagramApiRequestListResponses[keyof TelegramBotsGetDiagramApiRequestListResponses];

export type TelegramBotsGetDiagramApiRequestData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/api-requests/{id}/';
};

export type TelegramBotsGetDiagramApiRequestErrors = {
  400: TelegramBotsGetDiagramApiRequestErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramApiRequestError =
  TelegramBotsGetDiagramApiRequestErrors[keyof TelegramBotsGetDiagramApiRequestErrors];

export type TelegramBotsGetDiagramApiRequestResponses = {
  200: DiagramApiRequest;
};

export type TelegramBotsGetDiagramApiRequestResponse =
  TelegramBotsGetDiagramApiRequestResponses[keyof TelegramBotsGetDiagramApiRequestResponses];

export type TelegramBotsPartialUpdateDiagramApiRequestData = {
  body?: PatchedDiagramApiRequestRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/api-requests/{id}/';
};

export type TelegramBotsPartialUpdateDiagramApiRequestErrors = {
  400: TelegramBotsPartialUpdateDiagramApiRequestErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramApiRequestError2 =
  TelegramBotsPartialUpdateDiagramApiRequestErrors[keyof TelegramBotsPartialUpdateDiagramApiRequestErrors];

export type TelegramBotsPartialUpdateDiagramApiRequestResponses = {
  200: DiagramApiRequest;
};

export type TelegramBotsPartialUpdateDiagramApiRequestResponse =
  TelegramBotsPartialUpdateDiagramApiRequestResponses[keyof TelegramBotsPartialUpdateDiagramApiRequestResponses];

export type TelegramBotsUpdateDiagramApiRequestData = {
  body?: DiagramApiRequestRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/api-requests/{id}/';
};

export type TelegramBotsUpdateDiagramApiRequestErrors = {
  400: TelegramBotsUpdateDiagramApiRequestErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramApiRequestError2 =
  TelegramBotsUpdateDiagramApiRequestErrors[keyof TelegramBotsUpdateDiagramApiRequestErrors];

export type TelegramBotsUpdateDiagramApiRequestResponses = {
  200: DiagramApiRequest;
};

export type TelegramBotsUpdateDiagramApiRequestResponse =
  TelegramBotsUpdateDiagramApiRequestResponses[keyof TelegramBotsUpdateDiagramApiRequestResponses];

export type TelegramBotsGetDiagramBackgroundTaskListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/background-tasks/';
};

export type TelegramBotsGetDiagramBackgroundTaskListErrors = {
  400: TelegramBotsGetDiagramBackgroundTaskListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramBackgroundTaskListError =
  TelegramBotsGetDiagramBackgroundTaskListErrors[keyof TelegramBotsGetDiagramBackgroundTaskListErrors];

export type TelegramBotsGetDiagramBackgroundTaskListResponses = {
  200: Array<DiagramBackgroundTask>;
};

export type TelegramBotsGetDiagramBackgroundTaskListResponse =
  TelegramBotsGetDiagramBackgroundTaskListResponses[keyof TelegramBotsGetDiagramBackgroundTaskListResponses];

export type TelegramBotsGetDiagramBackgroundTaskData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/background-tasks/{id}/';
};

export type TelegramBotsGetDiagramBackgroundTaskErrors = {
  400: TelegramBotsGetDiagramBackgroundTaskErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramBackgroundTaskError =
  TelegramBotsGetDiagramBackgroundTaskErrors[keyof TelegramBotsGetDiagramBackgroundTaskErrors];

export type TelegramBotsGetDiagramBackgroundTaskResponses = {
  200: DiagramBackgroundTask;
};

export type TelegramBotsGetDiagramBackgroundTaskResponse =
  TelegramBotsGetDiagramBackgroundTaskResponses[keyof TelegramBotsGetDiagramBackgroundTaskResponses];

export type TelegramBotsPartialUpdateDiagramBackgroundTaskData = {
  body?: PatchedDiagramBackgroundTaskRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/background-tasks/{id}/';
};

export type TelegramBotsPartialUpdateDiagramBackgroundTaskErrors = {
  400: TelegramBotsPartialUpdateDiagramBackgroundTaskErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramBackgroundTaskError2 =
  TelegramBotsPartialUpdateDiagramBackgroundTaskErrors[keyof TelegramBotsPartialUpdateDiagramBackgroundTaskErrors];

export type TelegramBotsPartialUpdateDiagramBackgroundTaskResponses = {
  200: DiagramBackgroundTask;
};

export type TelegramBotsPartialUpdateDiagramBackgroundTaskResponse =
  TelegramBotsPartialUpdateDiagramBackgroundTaskResponses[keyof TelegramBotsPartialUpdateDiagramBackgroundTaskResponses];

export type TelegramBotsUpdateDiagramBackgroundTaskData = {
  body?: DiagramBackgroundTaskRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/background-tasks/{id}/';
};

export type TelegramBotsUpdateDiagramBackgroundTaskErrors = {
  400: TelegramBotsUpdateDiagramBackgroundTaskErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramBackgroundTaskError2 =
  TelegramBotsUpdateDiagramBackgroundTaskErrors[keyof TelegramBotsUpdateDiagramBackgroundTaskErrors];

export type TelegramBotsUpdateDiagramBackgroundTaskResponses = {
  200: DiagramBackgroundTask;
};

export type TelegramBotsUpdateDiagramBackgroundTaskResponse =
  TelegramBotsUpdateDiagramBackgroundTaskResponses[keyof TelegramBotsUpdateDiagramBackgroundTaskResponses];

export type TelegramBotsGetDiagramConditionListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/conditions/';
};

export type TelegramBotsGetDiagramConditionListErrors = {
  400: TelegramBotsGetDiagramConditionListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramConditionListError =
  TelegramBotsGetDiagramConditionListErrors[keyof TelegramBotsGetDiagramConditionListErrors];

export type TelegramBotsGetDiagramConditionListResponses = {
  200: Array<DiagramCondition>;
};

export type TelegramBotsGetDiagramConditionListResponse =
  TelegramBotsGetDiagramConditionListResponses[keyof TelegramBotsGetDiagramConditionListResponses];

export type TelegramBotsGetDiagramConditionData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/conditions/{id}/';
};

export type TelegramBotsGetDiagramConditionErrors = {
  400: TelegramBotsGetDiagramConditionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramConditionError =
  TelegramBotsGetDiagramConditionErrors[keyof TelegramBotsGetDiagramConditionErrors];

export type TelegramBotsGetDiagramConditionResponses = {
  200: DiagramCondition;
};

export type TelegramBotsGetDiagramConditionResponse =
  TelegramBotsGetDiagramConditionResponses[keyof TelegramBotsGetDiagramConditionResponses];

export type TelegramBotsPartialUpdateDiagramConditionData = {
  body?: PatchedDiagramConditionRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/conditions/{id}/';
};

export type TelegramBotsPartialUpdateDiagramConditionErrors = {
  400: TelegramBotsPartialUpdateDiagramConditionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramConditionError2 =
  TelegramBotsPartialUpdateDiagramConditionErrors[keyof TelegramBotsPartialUpdateDiagramConditionErrors];

export type TelegramBotsPartialUpdateDiagramConditionResponses = {
  200: DiagramCondition;
};

export type TelegramBotsPartialUpdateDiagramConditionResponse =
  TelegramBotsPartialUpdateDiagramConditionResponses[keyof TelegramBotsPartialUpdateDiagramConditionResponses];

export type TelegramBotsUpdateDiagramConditionData = {
  body?: DiagramConditionRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/conditions/{id}/';
};

export type TelegramBotsUpdateDiagramConditionErrors = {
  400: TelegramBotsUpdateDiagramConditionErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramConditionError2 =
  TelegramBotsUpdateDiagramConditionErrors[keyof TelegramBotsUpdateDiagramConditionErrors];

export type TelegramBotsUpdateDiagramConditionResponses = {
  200: DiagramCondition;
};

export type TelegramBotsUpdateDiagramConditionResponse =
  TelegramBotsUpdateDiagramConditionResponses[keyof TelegramBotsUpdateDiagramConditionResponses];

export type TelegramBotsGetDiagramDatabaseOperationListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/database-operations/';
};

export type TelegramBotsGetDiagramDatabaseOperationListErrors = {
  400: TelegramBotsGetDiagramDatabaseOperationListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramDatabaseOperationListError =
  TelegramBotsGetDiagramDatabaseOperationListErrors[keyof TelegramBotsGetDiagramDatabaseOperationListErrors];

export type TelegramBotsGetDiagramDatabaseOperationListResponses = {
  200: Array<DiagramDatabaseOperation>;
};

export type TelegramBotsGetDiagramDatabaseOperationListResponse =
  TelegramBotsGetDiagramDatabaseOperationListResponses[keyof TelegramBotsGetDiagramDatabaseOperationListResponses];

export type TelegramBotsGetDiagramDatabaseOperationData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/database-operations/{id}/';
};

export type TelegramBotsGetDiagramDatabaseOperationErrors = {
  400: TelegramBotsGetDiagramDatabaseOperationErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramDatabaseOperationError =
  TelegramBotsGetDiagramDatabaseOperationErrors[keyof TelegramBotsGetDiagramDatabaseOperationErrors];

export type TelegramBotsGetDiagramDatabaseOperationResponses = {
  200: DiagramDatabaseOperation;
};

export type TelegramBotsGetDiagramDatabaseOperationResponse =
  TelegramBotsGetDiagramDatabaseOperationResponses[keyof TelegramBotsGetDiagramDatabaseOperationResponses];

export type TelegramBotsPartialUpdateDiagramDatabaseOperationData = {
  body?: PatchedDiagramDatabaseOperationRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/database-operations/{id}/';
};

export type TelegramBotsPartialUpdateDiagramDatabaseOperationErrors = {
  400: TelegramBotsPartialUpdateDiagramDatabaseOperationErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramDatabaseOperationError2 =
  TelegramBotsPartialUpdateDiagramDatabaseOperationErrors[keyof TelegramBotsPartialUpdateDiagramDatabaseOperationErrors];

export type TelegramBotsPartialUpdateDiagramDatabaseOperationResponses = {
  200: DiagramDatabaseOperation;
};

export type TelegramBotsPartialUpdateDiagramDatabaseOperationResponse =
  TelegramBotsPartialUpdateDiagramDatabaseOperationResponses[keyof TelegramBotsPartialUpdateDiagramDatabaseOperationResponses];

export type TelegramBotsUpdateDiagramDatabaseOperationData = {
  body?: DiagramDatabaseOperationRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/database-operations/{id}/';
};

export type TelegramBotsUpdateDiagramDatabaseOperationErrors = {
  400: TelegramBotsUpdateDiagramDatabaseOperationErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramDatabaseOperationError2 =
  TelegramBotsUpdateDiagramDatabaseOperationErrors[keyof TelegramBotsUpdateDiagramDatabaseOperationErrors];

export type TelegramBotsUpdateDiagramDatabaseOperationResponses = {
  200: DiagramDatabaseOperation;
};

export type TelegramBotsUpdateDiagramDatabaseOperationResponse =
  TelegramBotsUpdateDiagramDatabaseOperationResponses[keyof TelegramBotsUpdateDiagramDatabaseOperationResponses];

export type TelegramBotsGetDiagramInvoiceListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/invoices/';
};

export type TelegramBotsGetDiagramInvoiceListErrors = {
  400: TelegramBotsGetDiagramInvoiceListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramInvoiceListError =
  TelegramBotsGetDiagramInvoiceListErrors[keyof TelegramBotsGetDiagramInvoiceListErrors];

export type TelegramBotsGetDiagramInvoiceListResponses = {
  200: Array<DiagramInvoice>;
};

export type TelegramBotsGetDiagramInvoiceListResponse =
  TelegramBotsGetDiagramInvoiceListResponses[keyof TelegramBotsGetDiagramInvoiceListResponses];

export type TelegramBotsGetDiagramInvoiceData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/invoices/{id}/';
};

export type TelegramBotsGetDiagramInvoiceErrors = {
  400: TelegramBotsGetDiagramInvoiceErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramInvoiceError =
  TelegramBotsGetDiagramInvoiceErrors[keyof TelegramBotsGetDiagramInvoiceErrors];

export type TelegramBotsGetDiagramInvoiceResponses = {
  200: DiagramInvoice;
};

export type TelegramBotsGetDiagramInvoiceResponse =
  TelegramBotsGetDiagramInvoiceResponses[keyof TelegramBotsGetDiagramInvoiceResponses];

export type TelegramBotsPartialUpdateDiagramInvoiceData = {
  body?: PatchedDiagramInvoiceRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/invoices/{id}/';
};

export type TelegramBotsPartialUpdateDiagramInvoiceErrors = {
  400: TelegramBotsPartialUpdateDiagramInvoiceErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramInvoiceError2 =
  TelegramBotsPartialUpdateDiagramInvoiceErrors[keyof TelegramBotsPartialUpdateDiagramInvoiceErrors];

export type TelegramBotsPartialUpdateDiagramInvoiceResponses = {
  200: DiagramInvoice;
};

export type TelegramBotsPartialUpdateDiagramInvoiceResponse =
  TelegramBotsPartialUpdateDiagramInvoiceResponses[keyof TelegramBotsPartialUpdateDiagramInvoiceResponses];

export type TelegramBotsUpdateDiagramInvoiceData = {
  body?: DiagramInvoiceRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/invoices/{id}/';
};

export type TelegramBotsUpdateDiagramInvoiceErrors = {
  400: TelegramBotsUpdateDiagramInvoiceErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramInvoiceError2 =
  TelegramBotsUpdateDiagramInvoiceErrors[keyof TelegramBotsUpdateDiagramInvoiceErrors];

export type TelegramBotsUpdateDiagramInvoiceResponses = {
  200: DiagramInvoice;
};

export type TelegramBotsUpdateDiagramInvoiceResponse =
  TelegramBotsUpdateDiagramInvoiceResponses[keyof TelegramBotsUpdateDiagramInvoiceResponses];

export type TelegramBotsGetDiagramMessageListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/messages/';
};

export type TelegramBotsGetDiagramMessageListErrors = {
  400: TelegramBotsGetDiagramMessageListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramMessageListError =
  TelegramBotsGetDiagramMessageListErrors[keyof TelegramBotsGetDiagramMessageListErrors];

export type TelegramBotsGetDiagramMessageListResponses = {
  200: Array<DiagramMessage>;
};

export type TelegramBotsGetDiagramMessageListResponse =
  TelegramBotsGetDiagramMessageListResponses[keyof TelegramBotsGetDiagramMessageListResponses];

export type TelegramBotsGetDiagramMessageData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/messages/{id}/';
};

export type TelegramBotsGetDiagramMessageErrors = {
  400: TelegramBotsGetDiagramMessageErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramMessageError =
  TelegramBotsGetDiagramMessageErrors[keyof TelegramBotsGetDiagramMessageErrors];

export type TelegramBotsGetDiagramMessageResponses = {
  200: DiagramMessage;
};

export type TelegramBotsGetDiagramMessageResponse =
  TelegramBotsGetDiagramMessageResponses[keyof TelegramBotsGetDiagramMessageResponses];

export type TelegramBotsPartialUpdateDiagramMessageData = {
  body?: PatchedDiagramMessageRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/messages/{id}/';
};

export type TelegramBotsPartialUpdateDiagramMessageErrors = {
  400: TelegramBotsPartialUpdateDiagramMessageErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramMessageError2 =
  TelegramBotsPartialUpdateDiagramMessageErrors[keyof TelegramBotsPartialUpdateDiagramMessageErrors];

export type TelegramBotsPartialUpdateDiagramMessageResponses = {
  200: DiagramMessage;
};

export type TelegramBotsPartialUpdateDiagramMessageResponse =
  TelegramBotsPartialUpdateDiagramMessageResponses[keyof TelegramBotsPartialUpdateDiagramMessageResponses];

export type TelegramBotsUpdateDiagramMessageData = {
  body?: DiagramMessageRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/messages/{id}/';
};

export type TelegramBotsUpdateDiagramMessageErrors = {
  400: TelegramBotsUpdateDiagramMessageErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramMessageError2 =
  TelegramBotsUpdateDiagramMessageErrors[keyof TelegramBotsUpdateDiagramMessageErrors];

export type TelegramBotsUpdateDiagramMessageResponses = {
  200: DiagramMessage;
};

export type TelegramBotsUpdateDiagramMessageResponse =
  TelegramBotsUpdateDiagramMessageResponses[keyof TelegramBotsUpdateDiagramMessageResponses];

export type TelegramBotsGetDiagramRandomizerListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/';
};

export type TelegramBotsGetDiagramRandomizerListErrors = {
  400: TelegramBotsGetDiagramRandomizerListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramRandomizerListError =
  TelegramBotsGetDiagramRandomizerListErrors[keyof TelegramBotsGetDiagramRandomizerListErrors];

export type TelegramBotsGetDiagramRandomizerListResponses = {
  200: Array<DiagramRandomizer>;
};

export type TelegramBotsGetDiagramRandomizerListResponse =
  TelegramBotsGetDiagramRandomizerListResponses[keyof TelegramBotsGetDiagramRandomizerListResponses];

export type TelegramBotsCreateDiagramRandomizerData = {
  body?: DiagramRandomizerRequest;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/';
};

export type TelegramBotsCreateDiagramRandomizerErrors = {
  400: TelegramBotsCreateDiagramRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateDiagramRandomizerError2 =
  TelegramBotsCreateDiagramRandomizerErrors[keyof TelegramBotsCreateDiagramRandomizerErrors];

export type TelegramBotsCreateDiagramRandomizerResponses = {
  201: DiagramRandomizer;
};

export type TelegramBotsCreateDiagramRandomizerResponse =
  TelegramBotsCreateDiagramRandomizerResponses[keyof TelegramBotsCreateDiagramRandomizerResponses];

export type TelegramBotsDeleteDiagramRandomizerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/{id}/';
};

export type TelegramBotsDeleteDiagramRandomizerErrors = {
  400: TelegramBotsDeleteDiagramRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteDiagramRandomizerError =
  TelegramBotsDeleteDiagramRandomizerErrors[keyof TelegramBotsDeleteDiagramRandomizerErrors];

export type TelegramBotsDeleteDiagramRandomizerResponses = {
  204: void;
};

export type TelegramBotsDeleteDiagramRandomizerResponse =
  TelegramBotsDeleteDiagramRandomizerResponses[keyof TelegramBotsDeleteDiagramRandomizerResponses];

export type TelegramBotsGetDiagramRandomizerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/{id}/';
};

export type TelegramBotsGetDiagramRandomizerErrors = {
  400: TelegramBotsGetDiagramRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramRandomizerError =
  TelegramBotsGetDiagramRandomizerErrors[keyof TelegramBotsGetDiagramRandomizerErrors];

export type TelegramBotsGetDiagramRandomizerResponses = {
  200: DiagramRandomizer;
};

export type TelegramBotsGetDiagramRandomizerResponse =
  TelegramBotsGetDiagramRandomizerResponses[keyof TelegramBotsGetDiagramRandomizerResponses];

export type TelegramBotsPartialUpdateDiagramRandomizerData = {
  body?: PatchedDiagramRandomizerRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/{id}/';
};

export type TelegramBotsPartialUpdateDiagramRandomizerErrors = {
  400: TelegramBotsPartialUpdateDiagramRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramRandomizerError2 =
  TelegramBotsPartialUpdateDiagramRandomizerErrors[keyof TelegramBotsPartialUpdateDiagramRandomizerErrors];

export type TelegramBotsPartialUpdateDiagramRandomizerResponses = {
  200: DiagramRandomizer;
};

export type TelegramBotsPartialUpdateDiagramRandomizerResponse =
  TelegramBotsPartialUpdateDiagramRandomizerResponses[keyof TelegramBotsPartialUpdateDiagramRandomizerResponses];

export type TelegramBotsUpdateDiagramRandomizerData = {
  body?: DiagramRandomizerRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/randomizers/{id}/';
};

export type TelegramBotsUpdateDiagramRandomizerErrors = {
  400: TelegramBotsUpdateDiagramRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramRandomizerError2 =
  TelegramBotsUpdateDiagramRandomizerErrors[keyof TelegramBotsUpdateDiagramRandomizerErrors];

export type TelegramBotsUpdateDiagramRandomizerResponses = {
  200: DiagramRandomizer;
};

export type TelegramBotsUpdateDiagramRandomizerResponse =
  TelegramBotsUpdateDiagramRandomizerResponses[keyof TelegramBotsUpdateDiagramRandomizerResponses];

export type TelegramBotsGetDiagramTemporaryVariableListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/temporary-variables/';
};

export type TelegramBotsGetDiagramTemporaryVariableListErrors = {
  400: TelegramBotsGetDiagramTemporaryVariableListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramTemporaryVariableListError =
  TelegramBotsGetDiagramTemporaryVariableListErrors[keyof TelegramBotsGetDiagramTemporaryVariableListErrors];

export type TelegramBotsGetDiagramTemporaryVariableListResponses = {
  200: Array<DiagramTemporaryVariable>;
};

export type TelegramBotsGetDiagramTemporaryVariableListResponse =
  TelegramBotsGetDiagramTemporaryVariableListResponses[keyof TelegramBotsGetDiagramTemporaryVariableListResponses];

export type TelegramBotsGetDiagramTemporaryVariableData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/temporary-variables/{id}/';
};

export type TelegramBotsGetDiagramTemporaryVariableErrors = {
  400: TelegramBotsGetDiagramTemporaryVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramTemporaryVariableError =
  TelegramBotsGetDiagramTemporaryVariableErrors[keyof TelegramBotsGetDiagramTemporaryVariableErrors];

export type TelegramBotsGetDiagramTemporaryVariableResponses = {
  200: DiagramTemporaryVariable;
};

export type TelegramBotsGetDiagramTemporaryVariableResponse =
  TelegramBotsGetDiagramTemporaryVariableResponses[keyof TelegramBotsGetDiagramTemporaryVariableResponses];

export type TelegramBotsPartialUpdateDiagramTemporaryVariableData = {
  body?: PatchedDiagramTemporaryVariableRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/temporary-variables/{id}/';
};

export type TelegramBotsPartialUpdateDiagramTemporaryVariableErrors = {
  400: TelegramBotsPartialUpdateDiagramTemporaryVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramTemporaryVariableError2 =
  TelegramBotsPartialUpdateDiagramTemporaryVariableErrors[keyof TelegramBotsPartialUpdateDiagramTemporaryVariableErrors];

export type TelegramBotsPartialUpdateDiagramTemporaryVariableResponses = {
  200: DiagramTemporaryVariable;
};

export type TelegramBotsPartialUpdateDiagramTemporaryVariableResponse =
  TelegramBotsPartialUpdateDiagramTemporaryVariableResponses[keyof TelegramBotsPartialUpdateDiagramTemporaryVariableResponses];

export type TelegramBotsUpdateDiagramTemporaryVariableData = {
  body?: DiagramTemporaryVariableRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/temporary-variables/{id}/';
};

export type TelegramBotsUpdateDiagramTemporaryVariableErrors = {
  400: TelegramBotsUpdateDiagramTemporaryVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramTemporaryVariableError2 =
  TelegramBotsUpdateDiagramTemporaryVariableErrors[keyof TelegramBotsUpdateDiagramTemporaryVariableErrors];

export type TelegramBotsUpdateDiagramTemporaryVariableResponses = {
  200: DiagramTemporaryVariable;
};

export type TelegramBotsUpdateDiagramTemporaryVariableResponse =
  TelegramBotsUpdateDiagramTemporaryVariableResponses[keyof TelegramBotsUpdateDiagramTemporaryVariableResponses];

export type TelegramBotsGetDiagramTimerListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/timers/';
};

export type TelegramBotsGetDiagramTimerListErrors = {
  400: TelegramBotsGetDiagramTimerListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramTimerListError =
  TelegramBotsGetDiagramTimerListErrors[keyof TelegramBotsGetDiagramTimerListErrors];

export type TelegramBotsGetDiagramTimerListResponses = {
  200: Array<DiagramTimer>;
};

export type TelegramBotsGetDiagramTimerListResponse =
  TelegramBotsGetDiagramTimerListResponses[keyof TelegramBotsGetDiagramTimerListResponses];

export type TelegramBotsCreateDiagramTimerData = {
  body?: DiagramTimerRequest;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/timers/';
};

export type TelegramBotsCreateDiagramTimerErrors = {
  400: TelegramBotsCreateDiagramTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateDiagramTimerError2 =
  TelegramBotsCreateDiagramTimerErrors[keyof TelegramBotsCreateDiagramTimerErrors];

export type TelegramBotsCreateDiagramTimerResponses = {
  201: DiagramTimer;
};

export type TelegramBotsCreateDiagramTimerResponse =
  TelegramBotsCreateDiagramTimerResponses[keyof TelegramBotsCreateDiagramTimerResponses];

export type TelegramBotsDeleteDiagramTimerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/timers/{id}/';
};

export type TelegramBotsDeleteDiagramTimerErrors = {
  400: TelegramBotsDeleteDiagramTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteDiagramTimerError =
  TelegramBotsDeleteDiagramTimerErrors[keyof TelegramBotsDeleteDiagramTimerErrors];

export type TelegramBotsDeleteDiagramTimerResponses = {
  204: void;
};

export type TelegramBotsDeleteDiagramTimerResponse =
  TelegramBotsDeleteDiagramTimerResponses[keyof TelegramBotsDeleteDiagramTimerResponses];

export type TelegramBotsGetDiagramTimerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/timers/{id}/';
};

export type TelegramBotsGetDiagramTimerErrors = {
  400: TelegramBotsGetDiagramTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramTimerError =
  TelegramBotsGetDiagramTimerErrors[keyof TelegramBotsGetDiagramTimerErrors];

export type TelegramBotsGetDiagramTimerResponses = {
  200: DiagramTimer;
};

export type TelegramBotsGetDiagramTimerResponse =
  TelegramBotsGetDiagramTimerResponses[keyof TelegramBotsGetDiagramTimerResponses];

export type TelegramBotsPartialUpdateDiagramTimerData = {
  body?: PatchedDiagramTimerRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/timers/{id}/';
};

export type TelegramBotsPartialUpdateDiagramTimerErrors = {
  400: TelegramBotsPartialUpdateDiagramTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramTimerError2 =
  TelegramBotsPartialUpdateDiagramTimerErrors[keyof TelegramBotsPartialUpdateDiagramTimerErrors];

export type TelegramBotsPartialUpdateDiagramTimerResponses = {
  200: DiagramTimer;
};

export type TelegramBotsPartialUpdateDiagramTimerResponse =
  TelegramBotsPartialUpdateDiagramTimerResponses[keyof TelegramBotsPartialUpdateDiagramTimerResponses];

export type TelegramBotsUpdateDiagramTimerData = {
  body?: DiagramTimerRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/timers/{id}/';
};

export type TelegramBotsUpdateDiagramTimerErrors = {
  400: TelegramBotsUpdateDiagramTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramTimerError2 =
  TelegramBotsUpdateDiagramTimerErrors[keyof TelegramBotsUpdateDiagramTimerErrors];

export type TelegramBotsUpdateDiagramTimerResponses = {
  200: DiagramTimer;
};

export type TelegramBotsUpdateDiagramTimerResponse =
  TelegramBotsUpdateDiagramTimerResponses[keyof TelegramBotsUpdateDiagramTimerResponses];

export type TelegramBotsGetDiagramTriggerListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/';
};

export type TelegramBotsGetDiagramTriggerListErrors = {
  400: TelegramBotsGetDiagramTriggerListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramTriggerListError =
  TelegramBotsGetDiagramTriggerListErrors[keyof TelegramBotsGetDiagramTriggerListErrors];

export type TelegramBotsGetDiagramTriggerListResponses = {
  200: Array<DiagramTrigger>;
};

export type TelegramBotsGetDiagramTriggerListResponse =
  TelegramBotsGetDiagramTriggerListResponses[keyof TelegramBotsGetDiagramTriggerListResponses];

export type TelegramBotsCreateDiagramTriggerData = {
  body?: DiagramTriggerRequest;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/';
};

export type TelegramBotsCreateDiagramTriggerErrors = {
  400: TelegramBotsCreateDiagramTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateDiagramTriggerError2 =
  TelegramBotsCreateDiagramTriggerErrors[keyof TelegramBotsCreateDiagramTriggerErrors];

export type TelegramBotsCreateDiagramTriggerResponses = {
  201: DiagramTrigger;
};

export type TelegramBotsCreateDiagramTriggerResponse =
  TelegramBotsCreateDiagramTriggerResponses[keyof TelegramBotsCreateDiagramTriggerResponses];

export type TelegramBotsDeleteDiagramTriggerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/{id}/';
};

export type TelegramBotsDeleteDiagramTriggerErrors = {
  400: TelegramBotsDeleteDiagramTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteDiagramTriggerError =
  TelegramBotsDeleteDiagramTriggerErrors[keyof TelegramBotsDeleteDiagramTriggerErrors];

export type TelegramBotsDeleteDiagramTriggerResponses = {
  204: void;
};

export type TelegramBotsDeleteDiagramTriggerResponse =
  TelegramBotsDeleteDiagramTriggerResponses[keyof TelegramBotsDeleteDiagramTriggerResponses];

export type TelegramBotsGetDiagramTriggerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/{id}/';
};

export type TelegramBotsGetDiagramTriggerErrors = {
  400: TelegramBotsGetDiagramTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetDiagramTriggerError =
  TelegramBotsGetDiagramTriggerErrors[keyof TelegramBotsGetDiagramTriggerErrors];

export type TelegramBotsGetDiagramTriggerResponses = {
  200: DiagramTrigger;
};

export type TelegramBotsGetDiagramTriggerResponse =
  TelegramBotsGetDiagramTriggerResponses[keyof TelegramBotsGetDiagramTriggerResponses];

export type TelegramBotsPartialUpdateDiagramTriggerData = {
  body?: PatchedDiagramTriggerRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/{id}/';
};

export type TelegramBotsPartialUpdateDiagramTriggerErrors = {
  400: TelegramBotsPartialUpdateDiagramTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateDiagramTriggerError2 =
  TelegramBotsPartialUpdateDiagramTriggerErrors[keyof TelegramBotsPartialUpdateDiagramTriggerErrors];

export type TelegramBotsPartialUpdateDiagramTriggerResponses = {
  200: DiagramTrigger;
};

export type TelegramBotsPartialUpdateDiagramTriggerResponse =
  TelegramBotsPartialUpdateDiagramTriggerResponses[keyof TelegramBotsPartialUpdateDiagramTriggerResponses];

export type TelegramBotsUpdateDiagramTriggerData = {
  body?: DiagramTriggerRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/diagram/triggers/{id}/';
};

export type TelegramBotsUpdateDiagramTriggerErrors = {
  400: TelegramBotsUpdateDiagramTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateDiagramTriggerError2 =
  TelegramBotsUpdateDiagramTriggerErrors[keyof TelegramBotsUpdateDiagramTriggerErrors];

export type TelegramBotsUpdateDiagramTriggerResponses = {
  200: DiagramTrigger;
};

export type TelegramBotsUpdateDiagramTriggerResponse =
  TelegramBotsUpdateDiagramTriggerResponses[keyof TelegramBotsUpdateDiagramTriggerResponses];

export type TelegramBotsGetInvoiceListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/invoices/';
};

export type TelegramBotsGetInvoiceListErrors = {
  400: TelegramBotsGetInvoiceListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetInvoiceListError =
  TelegramBotsGetInvoiceListErrors[keyof TelegramBotsGetInvoiceListErrors];

export type TelegramBotsGetInvoiceListResponses = {
  200: Array<Invoice>;
};

export type TelegramBotsGetInvoiceListResponse =
  TelegramBotsGetInvoiceListResponses[keyof TelegramBotsGetInvoiceListResponses];

export type TelegramBotsCreateInvoiceData = {
  body: InvoiceRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/invoices/';
};

export type TelegramBotsCreateInvoiceErrors = {
  400: TelegramBotsCreateInvoiceErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateInvoiceError2 =
  TelegramBotsCreateInvoiceErrors[keyof TelegramBotsCreateInvoiceErrors];

export type TelegramBotsCreateInvoiceResponses = {
  201: Invoice;
};

export type TelegramBotsCreateInvoiceResponse =
  TelegramBotsCreateInvoiceResponses[keyof TelegramBotsCreateInvoiceResponses];

export type TelegramBotsDeleteInvoiceData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/invoices/{id}/';
};

export type TelegramBotsDeleteInvoiceErrors = {
  400: TelegramBotsDeleteInvoiceErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteInvoiceError =
  TelegramBotsDeleteInvoiceErrors[keyof TelegramBotsDeleteInvoiceErrors];

export type TelegramBotsDeleteInvoiceResponses = {
  204: void;
};

export type TelegramBotsDeleteInvoiceResponse =
  TelegramBotsDeleteInvoiceResponses[keyof TelegramBotsDeleteInvoiceResponses];

export type TelegramBotsGetInvoiceData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/invoices/{id}/';
};

export type TelegramBotsGetInvoiceErrors = {
  400: TelegramBotsGetInvoiceErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetInvoiceError =
  TelegramBotsGetInvoiceErrors[keyof TelegramBotsGetInvoiceErrors];

export type TelegramBotsGetInvoiceResponses = {
  200: Invoice;
};

export type TelegramBotsGetInvoiceResponse =
  TelegramBotsGetInvoiceResponses[keyof TelegramBotsGetInvoiceResponses];

export type TelegramBotsPartialUpdateInvoiceData = {
  body?: PatchedInvoiceRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/invoices/{id}/';
};

export type TelegramBotsPartialUpdateInvoiceErrors = {
  400: TelegramBotsPartialUpdateInvoiceErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateInvoiceError2 =
  TelegramBotsPartialUpdateInvoiceErrors[keyof TelegramBotsPartialUpdateInvoiceErrors];

export type TelegramBotsPartialUpdateInvoiceResponses = {
  200: Invoice;
};

export type TelegramBotsPartialUpdateInvoiceResponse =
  TelegramBotsPartialUpdateInvoiceResponses[keyof TelegramBotsPartialUpdateInvoiceResponses];

export type TelegramBotsUpdateInvoiceData = {
  body: InvoiceRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/invoices/{id}/';
};

export type TelegramBotsUpdateInvoiceErrors = {
  400: TelegramBotsUpdateInvoiceErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateInvoiceError2 =
  TelegramBotsUpdateInvoiceErrors[keyof TelegramBotsUpdateInvoiceErrors];

export type TelegramBotsUpdateInvoiceResponses = {
  200: Invoice;
};

export type TelegramBotsUpdateInvoiceResponse =
  TelegramBotsUpdateInvoiceResponses[keyof TelegramBotsUpdateInvoiceResponses];

export type TelegramBotsGetMessageListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/messages/';
};

export type TelegramBotsGetMessageListErrors = {
  400: TelegramBotsGetMessageListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetMessageListError =
  TelegramBotsGetMessageListErrors[keyof TelegramBotsGetMessageListErrors];

export type TelegramBotsGetMessageListResponses = {
  200: Array<Message>;
};

export type TelegramBotsGetMessageListResponse =
  TelegramBotsGetMessageListResponses[keyof TelegramBotsGetMessageListResponses];

export type TelegramBotsCreateMessageData = {
  body: MessageRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/messages/';
};

export type TelegramBotsCreateMessageErrors = {
  400: TelegramBotsCreateMessageErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateMessageError2 =
  TelegramBotsCreateMessageErrors[keyof TelegramBotsCreateMessageErrors];

export type TelegramBotsCreateMessageResponses = {
  201: Message;
};

export type TelegramBotsCreateMessageResponse =
  TelegramBotsCreateMessageResponses[keyof TelegramBotsCreateMessageResponses];

export type TelegramBotsDeleteMessageData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/messages/{id}/';
};

export type TelegramBotsDeleteMessageErrors = {
  400: TelegramBotsDeleteMessageErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteMessageError =
  TelegramBotsDeleteMessageErrors[keyof TelegramBotsDeleteMessageErrors];

export type TelegramBotsDeleteMessageResponses = {
  204: void;
};

export type TelegramBotsDeleteMessageResponse =
  TelegramBotsDeleteMessageResponses[keyof TelegramBotsDeleteMessageResponses];

export type TelegramBotsGetMessageData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/messages/{id}/';
};

export type TelegramBotsGetMessageErrors = {
  400: TelegramBotsGetMessageErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetMessageError =
  TelegramBotsGetMessageErrors[keyof TelegramBotsGetMessageErrors];

export type TelegramBotsGetMessageResponses = {
  200: Message;
};

export type TelegramBotsGetMessageResponse =
  TelegramBotsGetMessageResponses[keyof TelegramBotsGetMessageResponses];

export type TelegramBotsPartialUpdateMessageData = {
  body?: PatchedMessageRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/messages/{id}/';
};

export type TelegramBotsPartialUpdateMessageErrors = {
  400: TelegramBotsPartialUpdateMessageErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateMessageError2 =
  TelegramBotsPartialUpdateMessageErrors[keyof TelegramBotsPartialUpdateMessageErrors];

export type TelegramBotsPartialUpdateMessageResponses = {
  200: Message;
};

export type TelegramBotsPartialUpdateMessageResponse =
  TelegramBotsPartialUpdateMessageResponses[keyof TelegramBotsPartialUpdateMessageResponses];

export type TelegramBotsUpdateMessageData = {
  body: MessageRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/messages/{id}/';
};

export type TelegramBotsUpdateMessageErrors = {
  400: TelegramBotsUpdateMessageErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateMessageError2 =
  TelegramBotsUpdateMessageErrors[keyof TelegramBotsUpdateMessageErrors];

export type TelegramBotsUpdateMessageResponses = {
  200: Message;
};

export type TelegramBotsUpdateMessageResponse =
  TelegramBotsUpdateMessageResponses[keyof TelegramBotsUpdateMessageResponses];

export type TelegramBotsGetRandomizerListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/randomizers/';
};

export type TelegramBotsGetRandomizerListErrors = {
  400: TelegramBotsGetRandomizerListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetRandomizerListError =
  TelegramBotsGetRandomizerListErrors[keyof TelegramBotsGetRandomizerListErrors];

export type TelegramBotsGetRandomizerListResponses = {
  200: Array<Randomizer>;
};

export type TelegramBotsGetRandomizerListResponse =
  TelegramBotsGetRandomizerListResponses[keyof TelegramBotsGetRandomizerListResponses];

export type TelegramBotsCreateRandomizerData = {
  body: RandomizerRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/randomizers/';
};

export type TelegramBotsCreateRandomizerErrors = {
  400: TelegramBotsCreateRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateRandomizerError2 =
  TelegramBotsCreateRandomizerErrors[keyof TelegramBotsCreateRandomizerErrors];

export type TelegramBotsCreateRandomizerResponses = {
  201: Randomizer;
};

export type TelegramBotsCreateRandomizerResponse =
  TelegramBotsCreateRandomizerResponses[keyof TelegramBotsCreateRandomizerResponses];

export type TelegramBotsDeleteRandomizerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/randomizers/{id}/';
};

export type TelegramBotsDeleteRandomizerErrors = {
  400: TelegramBotsDeleteRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteRandomizerError =
  TelegramBotsDeleteRandomizerErrors[keyof TelegramBotsDeleteRandomizerErrors];

export type TelegramBotsDeleteRandomizerResponses = {
  204: void;
};

export type TelegramBotsDeleteRandomizerResponse =
  TelegramBotsDeleteRandomizerResponses[keyof TelegramBotsDeleteRandomizerResponses];

export type TelegramBotsGetRandomizerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/randomizers/{id}/';
};

export type TelegramBotsGetRandomizerErrors = {
  400: TelegramBotsGetRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetRandomizerError =
  TelegramBotsGetRandomizerErrors[keyof TelegramBotsGetRandomizerErrors];

export type TelegramBotsGetRandomizerResponses = {
  200: Randomizer;
};

export type TelegramBotsGetRandomizerResponse =
  TelegramBotsGetRandomizerResponses[keyof TelegramBotsGetRandomizerResponses];

export type TelegramBotsPartialUpdateRandomizerData = {
  body?: PatchedRandomizerRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/randomizers/{id}/';
};

export type TelegramBotsPartialUpdateRandomizerErrors = {
  400: TelegramBotsPartialUpdateRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateRandomizerError2 =
  TelegramBotsPartialUpdateRandomizerErrors[keyof TelegramBotsPartialUpdateRandomizerErrors];

export type TelegramBotsPartialUpdateRandomizerResponses = {
  200: Randomizer;
};

export type TelegramBotsPartialUpdateRandomizerResponse =
  TelegramBotsPartialUpdateRandomizerResponses[keyof TelegramBotsPartialUpdateRandomizerResponses];

export type TelegramBotsUpdateRandomizerData = {
  body: RandomizerRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/randomizers/{id}/';
};

export type TelegramBotsUpdateRandomizerErrors = {
  400: TelegramBotsUpdateRandomizerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateRandomizerError2 =
  TelegramBotsUpdateRandomizerErrors[keyof TelegramBotsUpdateRandomizerErrors];

export type TelegramBotsUpdateRandomizerResponses = {
  200: Randomizer;
};

export type TelegramBotsUpdateRandomizerResponse =
  TelegramBotsUpdateRandomizerResponses[keyof TelegramBotsUpdateRandomizerResponses];

export type TelegramBotsGetTemporaryVariableListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: {
    limit?: number;
    offset?: number;
  };
  url: '/api/telegram-bots/{telegramBotId}/temporary-variables/';
};

export type TelegramBotsGetTemporaryVariableListErrors = {
  400: TelegramBotsGetTemporaryVariableListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetTemporaryVariableListError =
  TelegramBotsGetTemporaryVariableListErrors[keyof TelegramBotsGetTemporaryVariableListErrors];

export type TelegramBotsGetTemporaryVariableListResponses = {
  200: PaginatedTemporaryVariableList;
};

export type TelegramBotsGetTemporaryVariableListResponse =
  TelegramBotsGetTemporaryVariableListResponses[keyof TelegramBotsGetTemporaryVariableListResponses];

export type TelegramBotsCreateTemporaryVariableData = {
  body: TemporaryVariableRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/temporary-variables/';
};

export type TelegramBotsCreateTemporaryVariableErrors = {
  400: TelegramBotsCreateTemporaryVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateTemporaryVariableError2 =
  TelegramBotsCreateTemporaryVariableErrors[keyof TelegramBotsCreateTemporaryVariableErrors];

export type TelegramBotsCreateTemporaryVariableResponses = {
  201: TemporaryVariable;
};

export type TelegramBotsCreateTemporaryVariableResponse =
  TelegramBotsCreateTemporaryVariableResponses[keyof TelegramBotsCreateTemporaryVariableResponses];

export type TelegramBotsDeleteTemporaryVariableData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/temporary-variables/{id}/';
};

export type TelegramBotsDeleteTemporaryVariableErrors = {
  400: TelegramBotsDeleteTemporaryVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteTemporaryVariableError =
  TelegramBotsDeleteTemporaryVariableErrors[keyof TelegramBotsDeleteTemporaryVariableErrors];

export type TelegramBotsDeleteTemporaryVariableResponses = {
  204: void;
};

export type TelegramBotsDeleteTemporaryVariableResponse =
  TelegramBotsDeleteTemporaryVariableResponses[keyof TelegramBotsDeleteTemporaryVariableResponses];

export type TelegramBotsGetTemporaryVariableData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/temporary-variables/{id}/';
};

export type TelegramBotsGetTemporaryVariableErrors = {
  400: TelegramBotsGetTemporaryVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetTemporaryVariableError =
  TelegramBotsGetTemporaryVariableErrors[keyof TelegramBotsGetTemporaryVariableErrors];

export type TelegramBotsGetTemporaryVariableResponses = {
  200: TemporaryVariable;
};

export type TelegramBotsGetTemporaryVariableResponse =
  TelegramBotsGetTemporaryVariableResponses[keyof TelegramBotsGetTemporaryVariableResponses];

export type TelegramBotsPartialUpdateTemporaryVariableData = {
  body?: PatchedTemporaryVariableRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/temporary-variables/{id}/';
};

export type TelegramBotsPartialUpdateTemporaryVariableErrors = {
  400: TelegramBotsPartialUpdateTemporaryVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateTemporaryVariableError2 =
  TelegramBotsPartialUpdateTemporaryVariableErrors[keyof TelegramBotsPartialUpdateTemporaryVariableErrors];

export type TelegramBotsPartialUpdateTemporaryVariableResponses = {
  200: TemporaryVariable;
};

export type TelegramBotsPartialUpdateTemporaryVariableResponse =
  TelegramBotsPartialUpdateTemporaryVariableResponses[keyof TelegramBotsPartialUpdateTemporaryVariableResponses];

export type TelegramBotsUpdateTemporaryVariableData = {
  body: TemporaryVariableRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/temporary-variables/{id}/';
};

export type TelegramBotsUpdateTemporaryVariableErrors = {
  400: TelegramBotsUpdateTemporaryVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateTemporaryVariableError2 =
  TelegramBotsUpdateTemporaryVariableErrors[keyof TelegramBotsUpdateTemporaryVariableErrors];

export type TelegramBotsUpdateTemporaryVariableResponses = {
  200: TemporaryVariable;
};

export type TelegramBotsUpdateTemporaryVariableResponse =
  TelegramBotsUpdateTemporaryVariableResponses[keyof TelegramBotsUpdateTemporaryVariableResponses];

export type TelegramBotsGetTimerListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/timers/';
};

export type TelegramBotsGetTimerListErrors = {
  400: TelegramBotsGetTimerListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetTimerListError =
  TelegramBotsGetTimerListErrors[keyof TelegramBotsGetTimerListErrors];

export type TelegramBotsGetTimerListResponses = {
  200: Array<Timer>;
};

export type TelegramBotsGetTimerListResponse =
  TelegramBotsGetTimerListResponses[keyof TelegramBotsGetTimerListResponses];

export type TelegramBotsCreateTimerData = {
  body: TimerRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/timers/';
};

export type TelegramBotsCreateTimerErrors = {
  400: TelegramBotsCreateTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateTimerError2 =
  TelegramBotsCreateTimerErrors[keyof TelegramBotsCreateTimerErrors];

export type TelegramBotsCreateTimerResponses = {
  201: Timer;
};

export type TelegramBotsCreateTimerResponse =
  TelegramBotsCreateTimerResponses[keyof TelegramBotsCreateTimerResponses];

export type TelegramBotsDeleteTimerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/timers/{id}/';
};

export type TelegramBotsDeleteTimerErrors = {
  400: TelegramBotsDeleteTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteTimerError =
  TelegramBotsDeleteTimerErrors[keyof TelegramBotsDeleteTimerErrors];

export type TelegramBotsDeleteTimerResponses = {
  204: void;
};

export type TelegramBotsDeleteTimerResponse =
  TelegramBotsDeleteTimerResponses[keyof TelegramBotsDeleteTimerResponses];

export type TelegramBotsGetTimerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/timers/{id}/';
};

export type TelegramBotsGetTimerErrors = {
  400: TelegramBotsGetTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetTimerError =
  TelegramBotsGetTimerErrors[keyof TelegramBotsGetTimerErrors];

export type TelegramBotsGetTimerResponses = {
  200: Timer;
};

export type TelegramBotsGetTimerResponse =
  TelegramBotsGetTimerResponses[keyof TelegramBotsGetTimerResponses];

export type TelegramBotsPartialUpdateTimerData = {
  body?: PatchedTimerRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/timers/{id}/';
};

export type TelegramBotsPartialUpdateTimerErrors = {
  400: TelegramBotsPartialUpdateTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateTimerError2 =
  TelegramBotsPartialUpdateTimerErrors[keyof TelegramBotsPartialUpdateTimerErrors];

export type TelegramBotsPartialUpdateTimerResponses = {
  200: Timer;
};

export type TelegramBotsPartialUpdateTimerResponse =
  TelegramBotsPartialUpdateTimerResponses[keyof TelegramBotsPartialUpdateTimerResponses];

export type TelegramBotsUpdateTimerData = {
  body: TimerRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/timers/{id}/';
};

export type TelegramBotsUpdateTimerErrors = {
  400: TelegramBotsUpdateTimerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateTimerError2 =
  TelegramBotsUpdateTimerErrors[keyof TelegramBotsUpdateTimerErrors];

export type TelegramBotsUpdateTimerResponses = {
  200: Timer;
};

export type TelegramBotsUpdateTimerResponse =
  TelegramBotsUpdateTimerResponses[keyof TelegramBotsUpdateTimerResponses];

export type TelegramBotsGetTriggerListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/triggers/';
};

export type TelegramBotsGetTriggerListErrors = {
  400: TelegramBotsGetTriggerListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetTriggerListError =
  TelegramBotsGetTriggerListErrors[keyof TelegramBotsGetTriggerListErrors];

export type TelegramBotsGetTriggerListResponses = {
  200: Array<Trigger>;
};

export type TelegramBotsGetTriggerListResponse =
  TelegramBotsGetTriggerListResponses[keyof TelegramBotsGetTriggerListResponses];

export type TelegramBotsCreateTriggerData = {
  body: TriggerRequestWritable;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/triggers/';
};

export type TelegramBotsCreateTriggerErrors = {
  400: TelegramBotsCreateTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateTriggerError2 =
  TelegramBotsCreateTriggerErrors[keyof TelegramBotsCreateTriggerErrors];

export type TelegramBotsCreateTriggerResponses = {
  201: Trigger;
};

export type TelegramBotsCreateTriggerResponse =
  TelegramBotsCreateTriggerResponses[keyof TelegramBotsCreateTriggerResponses];

export type TelegramBotsDeleteTriggerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/triggers/{id}/';
};

export type TelegramBotsDeleteTriggerErrors = {
  400: TelegramBotsDeleteTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteTriggerError =
  TelegramBotsDeleteTriggerErrors[keyof TelegramBotsDeleteTriggerErrors];

export type TelegramBotsDeleteTriggerResponses = {
  204: void;
};

export type TelegramBotsDeleteTriggerResponse =
  TelegramBotsDeleteTriggerResponses[keyof TelegramBotsDeleteTriggerResponses];

export type TelegramBotsGetTriggerData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/triggers/{id}/';
};

export type TelegramBotsGetTriggerErrors = {
  400: TelegramBotsGetTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetTriggerError =
  TelegramBotsGetTriggerErrors[keyof TelegramBotsGetTriggerErrors];

export type TelegramBotsGetTriggerResponses = {
  200: Trigger;
};

export type TelegramBotsGetTriggerResponse =
  TelegramBotsGetTriggerResponses[keyof TelegramBotsGetTriggerResponses];

export type TelegramBotsPartialUpdateTriggerData = {
  body?: PatchedTriggerRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/triggers/{id}/';
};

export type TelegramBotsPartialUpdateTriggerErrors = {
  400: TelegramBotsPartialUpdateTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateTriggerError2 =
  TelegramBotsPartialUpdateTriggerErrors[keyof TelegramBotsPartialUpdateTriggerErrors];

export type TelegramBotsPartialUpdateTriggerResponses = {
  200: Trigger;
};

export type TelegramBotsPartialUpdateTriggerResponse =
  TelegramBotsPartialUpdateTriggerResponses[keyof TelegramBotsPartialUpdateTriggerResponses];

export type TelegramBotsUpdateTriggerData = {
  body: TriggerRequestWritable;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/triggers/{id}/';
};

export type TelegramBotsUpdateTriggerErrors = {
  400: TelegramBotsUpdateTriggerErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateTriggerError2 =
  TelegramBotsUpdateTriggerErrors[keyof TelegramBotsUpdateTriggerErrors];

export type TelegramBotsUpdateTriggerResponses = {
  200: Trigger;
};

export type TelegramBotsUpdateTriggerResponse =
  TelegramBotsUpdateTriggerResponses[keyof TelegramBotsUpdateTriggerResponses];

export type TelegramBotsGetUserListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: {
    is_allowed?: boolean;
    is_blocked?: boolean;
    limit?: number;
    offset?: number;
    ordering?: string;
    search?: string;
  };
  url: '/api/telegram-bots/{telegramBotId}/users/';
};

export type TelegramBotsGetUserListErrors = {
  400: TelegramBotsGetUserListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetUserListError2 =
  TelegramBotsGetUserListErrors[keyof TelegramBotsGetUserListErrors];

export type TelegramBotsGetUserListResponses = {
  200: PaginatedTelegramBotUserList;
};

export type TelegramBotsGetUserListResponse =
  TelegramBotsGetUserListResponses[keyof TelegramBotsGetUserListResponses];

export type TelegramBotsDeleteUserData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/users/{id}/';
};

export type TelegramBotsDeleteUserErrors = {
  400: TelegramBotsDeleteUserErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteUserError =
  TelegramBotsDeleteUserErrors[keyof TelegramBotsDeleteUserErrors];

export type TelegramBotsDeleteUserResponses = {
  204: void;
};

export type TelegramBotsDeleteUserResponse =
  TelegramBotsDeleteUserResponses[keyof TelegramBotsDeleteUserResponses];

export type TelegramBotsGetUserData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/users/{id}/';
};

export type TelegramBotsGetUserErrors = {
  400: TelegramBotsGetUserErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetUserError =
  TelegramBotsGetUserErrors[keyof TelegramBotsGetUserErrors];

export type TelegramBotsGetUserResponses = {
  200: TelegramBotUser;
};

export type TelegramBotsGetUserResponse =
  TelegramBotsGetUserResponses[keyof TelegramBotsGetUserResponses];

export type TelegramBotsPartialUpdateUserData = {
  body?: PatchedTelegramBotUserRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/users/{id}/';
};

export type TelegramBotsPartialUpdateUserErrors = {
  400: TelegramBotsPartialUpdateUserErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateUserError2 =
  TelegramBotsPartialUpdateUserErrors[keyof TelegramBotsPartialUpdateUserErrors];

export type TelegramBotsPartialUpdateUserResponses = {
  200: TelegramBotUser;
};

export type TelegramBotsPartialUpdateUserResponse =
  TelegramBotsPartialUpdateUserResponses[keyof TelegramBotsPartialUpdateUserResponses];

export type TelegramBotsUpdateUserData = {
  body?: TelegramBotUserRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/users/{id}/';
};

export type TelegramBotsUpdateUserErrors = {
  400: TelegramBotsUpdateUserErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateUserError2 =
  TelegramBotsUpdateUserErrors[keyof TelegramBotsUpdateUserErrors];

export type TelegramBotsUpdateUserResponses = {
  200: TelegramBotUser;
};

export type TelegramBotsUpdateUserResponse =
  TelegramBotsUpdateUserResponses[keyof TelegramBotsUpdateUserResponses];

export type TelegramBotsGetUserTimelineStatsData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: {
    days?: number;
    field?: 'activated_date' | 'last_activity_date';
  };
  url: '/api/telegram-bots/{telegramBotId}/users/timeline-stats/';
};

export type TelegramBotsGetUserTimelineStatsErrors = {
  400: TelegramBotsGetUserTimelineStatsErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetUserTimelineStatsError =
  TelegramBotsGetUserTimelineStatsErrors[keyof TelegramBotsGetUserTimelineStatsErrors];

export type TelegramBotsGetUserTimelineStatsResponses = {
  200: Array<UserTimelineStatsResponse>;
};

export type TelegramBotsGetUserTimelineStatsResponse =
  TelegramBotsGetUserTimelineStatsResponses[keyof TelegramBotsGetUserTimelineStatsResponses];

export type TelegramBotsGetVariableListData = {
  body?: never;
  path: {
    telegramBotId: number;
  };
  query?: {
    limit?: number;
    offset?: number;
    ordering?: string;
    search?: string;
  };
  url: '/api/telegram-bots/{telegramBotId}/variables/';
};

export type TelegramBotsGetVariableListErrors = {
  400: TelegramBotsGetVariableListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetVariableListError =
  TelegramBotsGetVariableListErrors[keyof TelegramBotsGetVariableListErrors];

export type TelegramBotsGetVariableListResponses = {
  200: PaginatedVariableList;
};

export type TelegramBotsGetVariableListResponse =
  TelegramBotsGetVariableListResponses[keyof TelegramBotsGetVariableListResponses];

export type TelegramBotsCreateVariableData = {
  body: VariableRequest;
  path: {
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/variables/';
};

export type TelegramBotsCreateVariableErrors = {
  400: TelegramBotsCreateVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsCreateVariableError2 =
  TelegramBotsCreateVariableErrors[keyof TelegramBotsCreateVariableErrors];

export type TelegramBotsCreateVariableResponses = {
  201: Variable;
};

export type TelegramBotsCreateVariableResponse =
  TelegramBotsCreateVariableResponses[keyof TelegramBotsCreateVariableResponses];

export type TelegramBotsDeleteVariableData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/variables/{id}/';
};

export type TelegramBotsDeleteVariableErrors = {
  400: TelegramBotsDeleteVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsDeleteVariableError =
  TelegramBotsDeleteVariableErrors[keyof TelegramBotsDeleteVariableErrors];

export type TelegramBotsDeleteVariableResponses = {
  204: void;
};

export type TelegramBotsDeleteVariableResponse =
  TelegramBotsDeleteVariableResponses[keyof TelegramBotsDeleteVariableResponses];

export type TelegramBotsGetVariableData = {
  body?: never;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/variables/{id}/';
};

export type TelegramBotsGetVariableErrors = {
  400: TelegramBotsGetVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetVariableError =
  TelegramBotsGetVariableErrors[keyof TelegramBotsGetVariableErrors];

export type TelegramBotsGetVariableResponses = {
  200: Variable;
};

export type TelegramBotsGetVariableResponse =
  TelegramBotsGetVariableResponses[keyof TelegramBotsGetVariableResponses];

export type TelegramBotsPartialUpdateVariableData = {
  body?: PatchedVariableRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/variables/{id}/';
};

export type TelegramBotsPartialUpdateVariableErrors = {
  400: TelegramBotsPartialUpdateVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsPartialUpdateVariableError2 =
  TelegramBotsPartialUpdateVariableErrors[keyof TelegramBotsPartialUpdateVariableErrors];

export type TelegramBotsPartialUpdateVariableResponses = {
  200: Variable;
};

export type TelegramBotsPartialUpdateVariableResponse =
  TelegramBotsPartialUpdateVariableResponses[keyof TelegramBotsPartialUpdateVariableResponses];

export type TelegramBotsUpdateVariableData = {
  body: VariableRequest;
  path: {
    id: number;
    telegramBotId: number;
  };
  query?: never;
  url: '/api/telegram-bots/{telegramBotId}/variables/{id}/';
};

export type TelegramBotsUpdateVariableErrors = {
  400: TelegramBotsUpdateVariableErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsUpdateVariableError2 =
  TelegramBotsUpdateVariableErrors[keyof TelegramBotsUpdateVariableErrors];

export type TelegramBotsUpdateVariableResponses = {
  200: Variable;
};

export type TelegramBotsUpdateVariableResponse =
  TelegramBotsUpdateVariableResponses[keyof TelegramBotsUpdateVariableResponses];

export type TelegramBotsGetStatsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/telegram-bots/stats/';
};

export type TelegramBotsGetStatsErrors = {
  400: TelegramBotsGetStatsErrorResponse400;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type TelegramBotsGetStatsError =
  TelegramBotsGetStatsErrors[keyof TelegramBotsGetStatsErrors];

export type TelegramBotsGetStatsResponses = {
  200: TelegramBotStatsResponse;
};

export type TelegramBotsGetStatsResponse =
  TelegramBotsGetStatsResponses[keyof TelegramBotsGetStatsResponses];

export type UsersPostUserLoginData = {
  body: UserLoginRequest;
  path?: never;
  query?: never;
  url: '/api/users/login/';
};

export type UsersPostUserLoginErrors = {
  400: UsersPostUserLoginErrorResponse400;
  401: ErrorResponse401;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersPostUserLoginError2 =
  UsersPostUserLoginErrors[keyof UsersPostUserLoginErrors];

export type UsersPostUserLoginResponses = {
  200: UserLoginResponse;
};

export type UsersPostUserLoginResponse =
  UsersPostUserLoginResponses[keyof UsersPostUserLoginResponses];

export type UsersPostUserLoginInitData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/users/login-init/';
};

export type UsersPostUserLoginInitErrors = {
  400: UsersPostUserLoginInitErrorResponse400;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersPostUserLoginInitError =
  UsersPostUserLoginInitErrors[keyof UsersPostUserLoginInitErrors];

export type UsersPostUserLoginInitResponses = {
  200: UserLoginInitResponse;
};

export type UsersPostUserLoginInitResponse =
  UsersPostUserLoginInitResponses[keyof UsersPostUserLoginInitResponses];

export type UsersDeleteUserData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/users/me/';
};

export type UsersDeleteUserErrors = {
  400: UsersDeleteUserErrorResponse400;
  401: ErrorResponse401;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersDeleteUserError = UsersDeleteUserErrors[keyof UsersDeleteUserErrors];

export type UsersDeleteUserResponses = {
  204: void;
};

export type UsersDeleteUserResponse =
  UsersDeleteUserResponses[keyof UsersDeleteUserResponses];

export type UsersGetUserData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/users/me/';
};

export type UsersGetUserErrors = {
  400: UsersGetUserErrorResponse400;
  401: ErrorResponse401;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersGetUserError = UsersGetUserErrors[keyof UsersGetUserErrors];

export type UsersGetUserResponses = {
  200: User;
};

export type UsersGetUserResponse = UsersGetUserResponses[keyof UsersGetUserResponses];

export type UsersPostUserAcceptTermsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/users/me/accept-terms/';
};

export type UsersPostUserAcceptTermsErrors = {
  400: UsersPostUserAcceptTermsErrorResponse400;
  401: ErrorResponse401;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersPostUserAcceptTermsError =
  UsersPostUserAcceptTermsErrors[keyof UsersPostUserAcceptTermsErrors];

export type UsersPostUserAcceptTermsResponses = {
  204: void;
};

export type UsersPostUserAcceptTermsResponse =
  UsersPostUserAcceptTermsResponses[keyof UsersPostUserAcceptTermsResponses];

export type UsersPostUserLogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/users/me/logout/';
};

export type UsersPostUserLogoutErrors = {
  400: UsersPostUserLogoutErrorResponse400;
  401: ErrorResponse401;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersPostUserLogoutError =
  UsersPostUserLogoutErrors[keyof UsersPostUserLogoutErrors];

export type UsersPostUserLogoutResponses = {
  204: void;
};

export type UsersPostUserLogoutResponse =
  UsersPostUserLogoutResponses[keyof UsersPostUserLogoutResponses];

export type UsersPostUserLogoutAllData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/users/me/logout-all/';
};

export type UsersPostUserLogoutAllErrors = {
  400: UsersPostUserLogoutAllErrorResponse400;
  401: ErrorResponse401;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersPostUserLogoutAllError =
  UsersPostUserLogoutAllErrors[keyof UsersPostUserLogoutAllErrors];

export type UsersPostUserLogoutAllResponses = {
  204: void;
};

export type UsersPostUserLogoutAllResponse =
  UsersPostUserLogoutAllResponses[keyof UsersPostUserLogoutAllResponses];

export type UsersPostUserTokenRefreshData = {
  body: UserTokenRefreshRequest;
  path?: never;
  query?: never;
  url: '/api/users/me/token-refresh/';
};

export type UsersPostUserTokenRefreshErrors = {
  400: UsersPostUserTokenRefreshErrorResponse400;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersPostUserTokenRefreshError2 =
  UsersPostUserTokenRefreshErrors[keyof UsersPostUserTokenRefreshErrors];

export type UsersPostUserTokenRefreshResponses = {
  200: UserTokenRefreshResponse;
};

export type UsersPostUserTokenRefreshResponse =
  UsersPostUserTokenRefreshResponses[keyof UsersPostUserTokenRefreshResponses];

export type UsersGetStatsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/users/stats/';
};

export type UsersGetStatsErrors = {
  400: UsersGetStatsErrorResponse400;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersGetStatsError = UsersGetStatsErrors[keyof UsersGetStatsErrors];

export type UsersGetStatsResponses = {
  200: UserStatsResponse;
};

export type UsersGetStatsResponse =
  UsersGetStatsResponses[keyof UsersGetStatsResponses];

export type UsersGetTokenListData = {
  body?: never;
  path?: never;
  query?: {
    ordering?: string;
    type?: 'access' | 'refresh';
  };
  url: '/api/users/tokens/';
};

export type UsersGetTokenListErrors = {
  400: UsersGetTokenListErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersGetTokenListError2 =
  UsersGetTokenListErrors[keyof UsersGetTokenListErrors];

export type UsersGetTokenListResponses = {
  200: Array<Token>;
};

export type UsersGetTokenListResponse =
  UsersGetTokenListResponses[keyof UsersGetTokenListResponses];

export type UsersGetTokenData = {
  body?: never;
  path: {
    jti: string;
  };
  query?: never;
  url: '/api/users/tokens/{jti}/';
};

export type UsersGetTokenErrors = {
  400: UsersGetTokenErrorResponse400;
  401: ErrorResponse401;
  403: ErrorResponse403;
  404: ErrorResponse404;
  405: ErrorResponse405;
  406: ErrorResponse406;
  415: ErrorResponse415;
  500: ErrorResponse500;
};

export type UsersGetTokenError = UsersGetTokenErrors[keyof UsersGetTokenErrors];

export type UsersGetTokenResponses = {
  200: Token;
};

export type UsersGetTokenResponse =
  UsersGetTokenResponses[keyof UsersGetTokenResponses];
